(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var helpers = {
  blockTransitions: function(node, duration) {
    // we use a negative delay value since it performs blocking
    // yet it doesn't kill any existing transitions running on the
    // same element which makes this safe for class-based animations
    var value = duration ? '-' + duration + 's' : '';
    applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
    return [TRANSITION_DELAY_PROP, value];
  }
};

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## General Use
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$animateCache',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,   $$animateCache,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
      var timings = $$animateCache.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // if a css animation has no duration we
      // should mark that so that repeated addClass/removeClass calls are skipped
      var hasDuration = allowNoDuration || (timings.transitionDuration > 0 || timings.animationDuration > 0);

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      $$animateCache.put(cacheKey, timings, hasDuration);

      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;
      var staggerCacheKey = 'stagger-' + cacheKey;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if ($$animateCache.count(cacheKey) > 0) {
        stagger = $$animateCache.get(staggerCacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          $$animateCache.put(staggerCacheKey, stagger, true);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        $$animateCache.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey, allowNoDuration) {
      var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
      if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
        preparationClasses = null;
        return closeAndReturnNoopAnimator();
      }

      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : $$animateCache.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        helpers.blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (preparationClasses && !options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }

        if (activeClasses) {
          $$jqLite.removeClass(element, activeClasses);
        }

        blockKeyframeAnimations(node, false);
        helpers.blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          helpers.blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        if (ev.target !== node) {
          // Since TransitionEvent / AnimationEvent bubble up,
          // we have to ignore events by finished child animations
          return;
        }

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
            cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);

            timings = computeTimings(node, fullClassName, cacheKey, false);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function getEventData(options) {
    return {
      addClass: options.addClass,
      removeClass: options.removeClass,
      from: options.from,
      to: options.to
    };
  }

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
               '$$isDocumentHidden',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
                $$isDocumentHidden) {

    var activeAnimationsLookup = new $$Map();
    var disabledElementsLookup = new $$Map();
    var animationsEnabled = null;

    function removeFromDisabledElementsLookup(evt) {
      disabledElementsLookup.delete(evt.target);
    }

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the `customFilter`/`classNameFilter` are set during the
    // provider/config stage therefore we can optimize here and setup helper functions
    var customFilter = $animateProvider.customFilter();
    var classNameFilter = $animateProvider.classNameFilter();
    var returnTrue = function() { return true; };

    var isAnimatableByFilter = customFilter || returnTrue;
    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
      return classNameFilter.test(className);
    };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(targetParentNode, targetNode, event) {
      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, node) {
      if (phase === 'close' && !node.parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(node);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              if (!disabledElementsLookup.has(node)) {
                // The element is added to the map for the first time.
                // Create a listener to remove it on `$destroy` (to avoid memory leak).
                jqLite(element).on('$destroy', removeFromDisabledElementsLookup);
              }
              disabledElementsLookup.set(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(originalElement, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var element = stripCommentsFromElement(originalElement);
      var node = getDomNode(element);
      var parentNode = node && node.parentNode;

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // If animations are hard-disabled for the whole application there is no need to continue.
      // There are also situations where a directive issues an animation for a jqLite wrapper that
      // contains only comment nodes. In this case, there is no way we can perform an animation.
      if (!animationsEnabled ||
          !node ||
          !isAnimatableByFilter(node, event, initialOptions) ||
          !isAnimatableClassName(node, options)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $$isDocumentHidden();

      // This is a hard disable of all animations the element itself, therefore  there is no need to
      // continue further past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start', getEventData(options));
        close();
        if (documentHidden) notifyProgress(runner, event, 'close', getEventData(options));
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(node);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(node);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
        // happen if the animated element is a transcluded clone and also has a `templateUrl`
        // directive on it. Therefore, we must recreate `element` in order to interact with the
        // actual DOM nodes.
        // Note: We still need to use the old `node` for certain things, such as looking up in
        //       HashMaps where it was used as the key.

        element = stripCommentsFromElement(originalElement);

        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(node);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(node, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', getEventData(options));

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(node);
          }
          notifyProgress(runner, event, 'close', getEventData(options));
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parentNode, node, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, node);
            });
          } else {
            cleanupEventListeners(phase, node);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(node) {
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.delete(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(node) {
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.delete(node);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(node, parentNode, event) {
      var bodyNode = $document[0].body;
      var rootNode = getDomNode($rootElement);

      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
      var rootNodeDetected = (node === rootNode);
      var parentAnimationDetected = false;
      var elementDisabled = disabledElementsLookup.get(node);
      var animateChildren;

      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentNode = getDomNode(parentHost);
      }

      while (parentNode) {
        if (!rootNodeDetected) {
          // AngularJS doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootNodeDetected = (parentNode === rootNode);
        }

        if (parentNode.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentNode) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentNodeDisabled = disabledElementsLookup.get(parentNode);

          if (parentNodeDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentNodeDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyNodeDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyNodeDetected = (parentNode === bodyNode);
        }

        if (bodyNodeDetected && rootNodeDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootNodeDetected) {
          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentNode = getDomNode(parentHost);
            continue;
          }
        }

        parentNode = parentNode.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootNodeDetected && bodyNodeDetected;
    }

    function markElementAnimationState(node, state, details) {
      details = details || {};
      details.state = state;

      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.set(node, newValue);
    }
  }];
}];

/** @this */
var $$AnimateCacheProvider = function() {

  var KEY = '$$ngAnimateParentKey';
  var parentCounter = 0;
  var cache = Object.create(null);

  this.$get = [function() {
    return {
      cacheKey: function(node, method, addClass, removeClass) {
        var parentNode = node.parentNode;
        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
        var parts = [parentID, method, node.getAttribute('class')];
        if (addClass) {
          parts.push(addClass);
        }
        if (removeClass) {
          parts.push(removeClass);
        }
        return parts.join(' ');
      },

      containsCachedAnimationWithoutDuration: function(key) {
        var entry = cache[key];

        // nothing cached, so go ahead and animate
        // otherwise it should be a valid animation
        return (entry && !entry.isValid) || false;
      },

      flush: function() {
        cache = Object.create(null);
      },

      count: function(key) {
        var entry = cache[key];
        return entry ? entry.total : 0;
      },

      get: function(key) {
        var entry = cache[key];
        return entry && entry.value;
      },

      put: function(key, value, isValid) {
        if (!cache[key]) {
          cache[key] = { total: 1, value: value, isValid: isValid };
        } else {
          cache[key].total++;
          cache[key].value = value;
        }
      }
    };
  }];
};

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';
  var PREPARE_CLASSES_KEY = '$$animatePrepareClasses';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', '$$animateCache',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler, $$animateCache) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$Map();

      // this is done first beforehand so that the map
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.set(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          element: animation.element,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.set(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      if (isStructural) {
        element.data(PREPARE_CLASSES_KEY, 'ng-' + event + PREPARE_CLASS_SUFFIX);
      }

      setRunner(element, runner);

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
          var extraClasses = options.addClass;

          extraClasses = (extraClasses ? (extraClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
          var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);

          toBeSortedAnimations.push({
            element: element,
            domNode: getDomNode(element),
            fn: function triggerAnimationStart() {
              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that we've cached the animation status for this element
              // and it's in fact an invalid animation (something that has duration = 0)
              // then we should skip all the heavy work from here on
              if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                closeFn();
                return;
              }

              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        var finalAnimations = sortAnimations(toBeSortedAnimations);
        for (var i = 0; i < finalAnimations.length; i++) {
          var innerArray = finalAnimations[i];
          for (var j = 0; j < innerArray.length; j++) {
            var entry = innerArray[j];
            var element = entry.element;

            // the RAFScheduler code only uses functions
            finalAnimations[i][j] = entry.fn;

            // the first row of elements shouldn't have a prepare-class added to them
            // since the elements are at the top of the animation hierarchy and they
            // will be applied without a RAF having to pass...
            if (i === 0) {
              element.removeData(PREPARE_CLASSES_KEY);
              continue;
            }

            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
            if (prepareClassName) {
              $$jqLite.addClass(element, prepareClassName);
            }
          }
        }

        $$rAFScheduler(finalAnimations);
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        tempClasses = (tempClasses ? (tempClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
        $$jqLite.addClass(element, tempClasses);

        var prepareClassName = element.data(PREPARE_CLASSES_KEY);
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 550, // We use 550 here to ensure that the directive is caught before others,
                   // but after `ngIf` (at priority 600).
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          $transclude(function(clone, childScope) {
            previousElement = clone;
            previousScope = childScope;
            $animate.enter(clone, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
 *
 * ## Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                     | Supported Animations                                                      |
 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
 *
 * (More information can be found by visiting the documentation associated with each directive.)
 *
 * For a full breakdown of the steps involved during each animation event, refer to the
 * {@link ng.$animate `$animate` API docs}.
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 *
 *   /&#42; if you are using animations instead of transitions you should configure as follows:
 *     animation-delay: 0.1s;
 *     animation-duration: 0s; &#42;/
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 * ```
 *
 * ### Animating between value changes
 *
 * Sometimes you need to animate between different expression states, whose values
 * don't necessary need to be known or referenced in CSS styles.
 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
 *
 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
 * creates a new instance of the element (including any other/child directives it may have) and
 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
 * (e.g. for performance reasons, or when you wish to retain internal state on the original
 * element instance).
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that AngularJS
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from AngularJS core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .info({ angularVersion: '1.8.3' })
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animateCache', $$AnimateCacheProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);

},{}],2:[function(require,module,exports){
require('./angular-animate');
module.exports = 'ngAnimate';

},{"./angular-animate":1}],3:[function(require,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 * See {@link ngCookies.$cookies `$cookies`} for usage.
 */


angular.module('ngCookies', ['ng']).
  info({ angularVersion: '1.8.3' }).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
   provider('$cookies', [/** @this */function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

/**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */
function $$CookieWriter($document, $log, $browser) {
  var cookiePath = $browser.baseHref();
  var rawDocument = $document[0];

  function buildCookieString(name, value, options) {
    var path, expires;
    options = options || {};
    expires = options.expires;
    path = angular.isDefined(options.path) ? options.path : cookiePath;
    if (angular.isUndefined(value)) {
      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
      value = '';
    }
    if (angular.isString(expires)) {
      expires = new Date(expires);
    }

    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    str += path ? ';path=' + path : '';
    str += options.domain ? ';domain=' + options.domain : '';
    str += expires ? ';expires=' + expires.toUTCString() : '';
    str += options.secure ? ';secure' : '';
    str += options.samesite ? ';samesite=' + options.samesite : '';

    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
    // - 300 cookies
    // - 20 cookies per unique domain
    // - 4096 bytes per cookie
    var cookieLength = str.length + 1;
    if (cookieLength > 4096) {
      $log.warn('Cookie \'' + name +
        '\' possibly not set or overflowed because it was too large (' +
        cookieLength + ' > 4096 bytes)!');
    }

    return str;
  }

  return function(name, value, options) {
    rawDocument.cookie = buildCookieString(name, value, options);
  };
}

$$CookieWriter.$inject = ['$document', '$log', '$browser'];

angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
  this.$get = $$CookieWriter;
});


})(window, window.angular);

},{}],4:[function(require,module,exports){
require('./angular-cookies');
module.exports = 'ngCookies';

},{"./angular-cookies":3}],5:[function(require,module,exports){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/*
	*
	* A AngularJS module that implements the HTML5 W3C saveAs() in browsers that
	* do not natively support it
	*
	* (c) 2015 Philipp Alferov
	* License: MIT
	*
	*/

	module.exports = 'ngFileSaver';

	angular.module('ngFileSaver', [])
	  .factory('FileSaver', ['Blob', 'SaveAs', 'FileSaverUtils', __webpack_require__(1)])
	  .factory('FileSaverUtils', [__webpack_require__(2)])
	  .factory('Blob', ['$window', __webpack_require__(3)])
	  .factory('SaveAs', [__webpack_require__(5)]);


/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	module.exports = function FileSaver(Blob, SaveAs, FileSaverUtils) {

	  function save(blob, filename, disableAutoBOM) {
	    try {
	      SaveAs(blob, filename, disableAutoBOM);
	    } catch(err) {
	      FileSaverUtils.handleErrors(err.message);
	    }
	  }

	  return {

	    /**
	    * saveAs
	    * Immediately starts saving a file, returns undefined.
	    *
	    * @name saveAs
	    * @function
	    * @param {Blob} data A Blob instance
	    * @param {Object} filename Custom filename (extension is optional)
	    * @param {Boolean} disableAutoBOM Disable automatically provided Unicode
	    * text encoding hints
	    *
	    * @return {Undefined}
	    */

	    saveAs: function(data, filename, disableAutoBOM) {

	      if (!FileSaverUtils.isBlobInstance(data)) {
	        FileSaverUtils.handleErrors('Data argument should be a blob instance');
	      }

	      if (!FileSaverUtils.isString(filename)) {
	        FileSaverUtils.handleErrors('Filename argument should be a string');
	      }

	      return save(data, filename, disableAutoBOM);
	    }
	  };
	};


/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';

	module.exports = function FileSaverUtils() {
	  return {
	    handleErrors: function(msg) {
	      throw new Error(msg);
	    },
	    isString: function(obj) {
	      return typeof obj === 'string' || obj instanceof String;
	    },
	    isUndefined: function(obj) {
	      return typeof obj === 'undefined';
	    },
	    isBlobInstance: function(obj) {
	      return obj instanceof Blob;
	    }
	  };
	};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(4);

	module.exports = function Blob($window) {
	  return $window.Blob;
	};


/***/ },
/* 4 */
/***/ function(module, exports) {

	/* Blob.js
	 * A Blob implementation.
	 * 2014-07-24
	 *
	 * By Eli Grey, http://eligrey.com
	 * By Devin Samarin, https://github.com/dsamarin
	 * License: MIT
	 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
	 */

	/*global self, unescape */
	/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
	  plusplus: true */

	/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */

	(function (view) {
		"use strict";

		view.URL = view.URL || view.webkitURL;

		if (view.Blob && view.URL) {
			try {
				new Blob;
				return;
			} catch (e) {}
		}

		// Internally we use a BlobBuilder implementation to base Blob off of
		// in order to support older browsers that only have BlobBuilder
		var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view) {
			var
				  get_class = function(object) {
					return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
				}
				, FakeBlobBuilder = function BlobBuilder() {
					this.data = [];
				}
				, FakeBlob = function Blob(data, type, encoding) {
					this.data = data;
					this.size = data.length;
					this.type = type;
					this.encoding = encoding;
				}
				, FBB_proto = FakeBlobBuilder.prototype
				, FB_proto = FakeBlob.prototype
				, FileReaderSync = view.FileReaderSync
				, FileException = function(type) {
					this.code = this[this.name = type];
				}
				, file_ex_codes = (
					  "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR "
					+ "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR"
				).split(" ")
				, file_ex_code = file_ex_codes.length
				, real_URL = view.URL || view.webkitURL || view
				, real_create_object_URL = real_URL.createObjectURL
				, real_revoke_object_URL = real_URL.revokeObjectURL
				, URL = real_URL
				, btoa = view.btoa
				, atob = view.atob

				, ArrayBuffer = view.ArrayBuffer
				, Uint8Array = view.Uint8Array

				, origin = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/
			;
			FakeBlob.fake = FB_proto.fake = true;
			while (file_ex_code--) {
				FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
			}
			// Polyfill URL
			if (!real_URL.createObjectURL) {
				URL = view.URL = function(uri) {
					var
						  uri_info = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
						, uri_origin
					;
					uri_info.href = uri;
					if (!("origin" in uri_info)) {
						if (uri_info.protocol.toLowerCase() === "data:") {
							uri_info.origin = null;
						} else {
							uri_origin = uri.match(origin);
							uri_info.origin = uri_origin && uri_origin[1];
						}
					}
					return uri_info;
				};
			}
			URL.createObjectURL = function(blob) {
				var
					  type = blob.type
					, data_URI_header
				;
				if (type === null) {
					type = "application/octet-stream";
				}
				if (blob instanceof FakeBlob) {
					data_URI_header = "data:" + type;
					if (blob.encoding === "base64") {
						return data_URI_header + ";base64," + blob.data;
					} else if (blob.encoding === "URI") {
						return data_URI_header + "," + decodeURIComponent(blob.data);
					} if (btoa) {
						return data_URI_header + ";base64," + btoa(blob.data);
					} else {
						return data_URI_header + "," + encodeURIComponent(blob.data);
					}
				} else if (real_create_object_URL) {
					return real_create_object_URL.call(real_URL, blob);
				}
			};
			URL.revokeObjectURL = function(object_URL) {
				if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
					real_revoke_object_URL.call(real_URL, object_URL);
				}
			};
			FBB_proto.append = function(data/*, endings*/) {
				var bb = this.data;
				// decode data to a binary string
				if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
					var
						  str = ""
						, buf = new Uint8Array(data)
						, i = 0
						, buf_len = buf.length
					;
					for (; i < buf_len; i++) {
						str += String.fromCharCode(buf[i]);
					}
					bb.push(str);
				} else if (get_class(data) === "Blob" || get_class(data) === "File") {
					if (FileReaderSync) {
						var fr = new FileReaderSync;
						bb.push(fr.readAsBinaryString(data));
					} else {
						// async FileReader won't work as BlobBuilder is sync
						throw new FileException("NOT_READABLE_ERR");
					}
				} else if (data instanceof FakeBlob) {
					if (data.encoding === "base64" && atob) {
						bb.push(atob(data.data));
					} else if (data.encoding === "URI") {
						bb.push(decodeURIComponent(data.data));
					} else if (data.encoding === "raw") {
						bb.push(data.data);
					}
				} else {
					if (typeof data !== "string") {
						data += ""; // convert unsupported types to strings
					}
					// decode UTF-16 to binary string
					bb.push(unescape(encodeURIComponent(data)));
				}
			};
			FBB_proto.getBlob = function(type) {
				if (!arguments.length) {
					type = null;
				}
				return new FakeBlob(this.data.join(""), type, "raw");
			};
			FBB_proto.toString = function() {
				return "[object BlobBuilder]";
			};
			FB_proto.slice = function(start, end, type) {
				var args = arguments.length;
				if (args < 3) {
					type = null;
				}
				return new FakeBlob(
					  this.data.slice(start, args > 1 ? end : this.data.length)
					, type
					, this.encoding
				);
			};
			FB_proto.toString = function() {
				return "[object Blob]";
			};
			FB_proto.close = function() {
				this.size = 0;
				delete this.data;
			};
			return FakeBlobBuilder;
		}(view));

		view.Blob = function(blobParts, options) {
			var type = options ? (options.type || "") : "";
			var builder = new BlobBuilder();
			if (blobParts) {
				for (var i = 0, len = blobParts.length; i < len; i++) {
					if (Uint8Array && blobParts[i] instanceof Uint8Array) {
						builder.append(blobParts[i].buffer);
					}
					else {
						builder.append(blobParts[i]);
					}
				}
			}
			var blob = builder.getBlob(type);
			if (!blob.slice && blob.webkitSlice) {
				blob.slice = blob.webkitSlice;
			}
			return blob;
		};

		var getPrototypeOf = Object.getPrototypeOf || function(object) {
			return object.__proto__;
		};
		view.Blob.prototype = getPrototypeOf(new view.Blob());
	}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this));


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function SaveAs() {
	  return __webpack_require__(6).saveAs || function() {};
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */

	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;

				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}

				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";

				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}

		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;

		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;

		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window

	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(7) !== null) && (__webpack_require__(8) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 8 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;

	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }
/******/ ])
});
;
},{}],6:[function(require,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isArray;
var isDefined;
var lowercase;
var noop;
var nodeContains;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var hasBeenInstantiated = false;
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    hasBeenInstantiated = true;
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidElements = function(elements) {
    if (!hasBeenInstantiated) {
      if (isArray(elements)) {
        elements = {htmlElements: elements};
      }

      addElementsTo(svgElements, elements.svgElements);
      addElementsTo(voidElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlElements);
    }

    return this;
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidAttrs = function(attrs) {
    if (!hasBeenInstantiated) {
      extend(validAttrs, arrayToMap(attrs, true));
    }
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isArray = angular.isArray;
  isDefined = angular.isDefined;
  lowercase = angular.$$lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = stringToMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = stringToMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = stringToMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');

  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function stringToMap(str, lowercaseKeys) {
    return arrayToMap(str.split(','), lowercaseKeys);
  }

  function arrayToMap(items, lowercaseKeys) {
    var obj = {}, i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  function addElementsTo(elementsMap, newElements) {
    if (newElements && newElements.length) {
      extend(elementsMap, arrayToMap(newElements));
    }
  }

  /**
   * Create an inert document that contains the dirty HTML that needs sanitizing.
   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
   * available.
   */
  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
    if (isDOMParserAvailable()) {
      return getInertBodyElement_DOMParser;
    }

    if (!document || !document.implementation) {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var inertDocument = document.implementation.createHTMLDocument('inert');
    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
    return getInertBodyElement_InertDocument;

    function isDOMParserAvailable() {
      try {
        return !!getInertBodyElement_DOMParser('');
      } catch (e) {
        return false;
      }
    }

    function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
        body.firstChild.remove();
        return body;
      } catch (e) {
        return undefined;
      }
    }

    function getInertBodyElement_InertDocument(html) {
      inertBodyElement.innerHTML = html;

      // Support: IE 9-11 only
      // strip custom-namespaced attributes on IE<=11
      if (document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }

      return inertBodyElement;
    }
  })(window, window.document);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }

    var inertBodyElement = getInertBodyElement(html);
    if (!inertBodyElement) return '';

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // trigger mXSS if it is going to happen by reading and writing the innerHTML
      html = inertBodyElement.innerHTML;
      inertBodyElement = getInertBodyElement(html);
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = getNonDescendant('nextSibling', node);
        if (!nextNode) {
          while (nextNode == null) {
            node = getNonDescendant('parentNode', node);
            if (node === inertBodyElement) break;
            nextNode = getNonDescendant('nextSibling', node);
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = getNonDescendant('nextSibling', node);
    }
  }

  function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
    var nextNode = node[propName];
    if (nextNode && nodeContains.call(node, nextNode)) {
      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
    }
    return nextNode;
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', [])
  .provider('$sanitize', $SanitizeProvider)
  .info({ angularVersion: '1.8.3' });

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);

},{}],7:[function(require,module,exports){
require('./angular-sanitize');
module.exports = 'ngSanitize';

},{"./angular-sanitize":6}],8:[function(require,module,exports){
'use strict';

/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (typeof module !== 'undefined') {
  module.exports = dijkstra;
}

},{}],9:[function(require,module,exports){
'use strict'

module.exports = function encodeUtf8 (input) {
  var result = []
  var size = input.length

  for (var index = 0; index < size; index++) {
    var point = input.charCodeAt(index)

    if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
      var second = input.charCodeAt(index + 1)

      if (second >= 0xDC00 && second <= 0xDFFF) {
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000
        index += 1
      }
    }

    // US-ASCII
    if (point < 0x80) {
      result.push(point)
      continue
    }

    // 2-byte UTF-8
    if (point < 0x800) {
      result.push((point >> 6) | 192)
      result.push((point & 63) | 128)
      continue
    }

    // 3-byte UTF-8
    if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
      result.push((point >> 12) | 224)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // 4-byte UTF-8
    if (point >= 0x10000 && point <= 0x10FFFF) {
      result.push((point >> 18) | 240)
      result.push(((point >> 12) & 63) | 128)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // Invalid character
    result.push(0xEF, 0xBF, 0xBD)
  }

  return new Uint8Array(result).buffer
}

},{}],10:[function(require,module,exports){
(function (global){(function (){
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Popper = factory());
}(this, (function () { 'use strict';

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

return Popper;

})));


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],11:[function(require,module,exports){

const canPromise = require('./can-promise')

const QRCode = require('./core/qrcode')
const CanvasRenderer = require('./renderer/canvas')
const SvgRenderer = require('./renderer/svg-tag.js')

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1)
  const argsNum = args.length
  const isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    const data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})

},{"./can-promise":12,"./core/qrcode":28,"./renderer/canvas":35,"./renderer/svg-tag.js":36}],12:[function(require,module,exports){
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}

},{}],13:[function(require,module,exports){
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

const getSymbolSize = require('./utils').getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2
  const size = getSymbolSize(version)
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  const positions = [size - 7] // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = []
  const pos = exports.getRowColCoords(version)
  const posLength = pos.length

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}

},{"./utils":32}],14:[function(require,module,exports){
const Mode = require('./mode')

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData

},{"./mode":25}],15:[function(require,module,exports){
function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer

},{}],16:[function(require,module,exports){
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = new Uint8Array(size * size)
  this.reservedBit = new Uint8Array(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix

},{}],17:[function(require,module,exports){
const encodeUtf8 = require('encode-utf8')
const Mode = require('./mode')

function ByteData (data) {
  this.mode = Mode.BYTE
  if (typeof (data) === 'string') {
    data = encodeUtf8(data)
  }
  this.data = new Uint8Array(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData

},{"./mode":25,"encode-utf8":9}],18:[function(require,module,exports){
const ECLevel = require('./error-correction-level')

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

},{"./error-correction-level":19}],19:[function(require,module,exports){
exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{}],20:[function(require,module,exports){
const getSymbolSize = require('./utils').getSymbolSize
const FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}

},{"./utils":32}],21:[function(require,module,exports){
const Utils = require('./utils')

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
const G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask)
  let d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}

},{"./utils":32}],22:[function(require,module,exports){
const EXP_TABLE = new Uint8Array(512)
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}

},{}],23:[function(require,module,exports){
const Mode = require('./mode')
const Utils = require('./utils')

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  let i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData

},{"./mode":25,"./utils":32}],24:[function(require,module,exports){
/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size
  let points = 0
  let sameCountCol = 0
  let sameCountRow = 0
  let lastCol = null
  let lastRow = null

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size
  let points = 0

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size
  let points = 0
  let bitsCol = 0
  let bitsRow = 0

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0
  const modulesCount = data.data.length

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i]

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length
  let bestPattern = 0
  let lowerPenalty = Infinity

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}

},{}],25:[function(require,module,exports){
const VersionCheck = require('./version-check')
const Regex = require('./regex')

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{"./regex":30,"./version-check":33}],26:[function(require,module,exports){
const Mode = require('./mode')

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData

},{"./mode":25}],27:[function(require,module,exports){
const GF = require('./galois-field')

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1)

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident)

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0]

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    let offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1])
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]))
  }

  return poly
}

},{"./galois-field":22}],28:[function(require,module,exports){
const Utils = require('./utils')
const ECLevel = require('./error-correction-level')
const BitBuffer = require('./bit-buffer')
const BitMatrix = require('./bit-matrix')
const AlignmentPattern = require('./alignment-pattern')
const FinderPattern = require('./finder-pattern')
const MaskPattern = require('./mask-pattern')
const ECCode = require('./error-correction-code')
const ReedSolomonEncoder = require('./reed-solomon-encoder')
const Version = require('./version')
const FormatInfo = require('./format-info')
const Mode = require('./mode')
const Segments = require('./segments')

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size
  const pos = FinderPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size
  const bits = Version.getEncodedBits(version)
  let row, col, mod

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  let i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size
  let inc = -1
  let row = size - 1
  let bitIndex = 7
  let byteIndex = 0

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  const totalCodewords = Utils.getSymbolTotalCodewords(version)
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount)

  let offset = 0
  const dcData = new Array(ecTotalBlocks)
  const ecData = new Array(ecTotalBlocks)
  let maxDataSize = 0
  const buffer = new Uint8Array(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords)
  let index = 0
  let i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    let estimatedVersion = version

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  const moduleCount = Utils.getSymbolSize(version)
  const modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M
  let version
  let mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}

},{"./alignment-pattern":13,"./bit-buffer":15,"./bit-matrix":16,"./error-correction-code":18,"./error-correction-level":19,"./finder-pattern":20,"./format-info":21,"./mask-pattern":24,"./mode":25,"./reed-solomon-encoder":29,"./segments":31,"./utils":32,"./version":34}],29:[function(require,module,exports){
const Polynomial = require('./polynomial')

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree)
  paddedData.set(data)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length
  if (start > 0) {
    const buff = new Uint8Array(this.degree)
    buff.set(remainder, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder

},{"./polynomial":27}],30:[function(require,module,exports){
const numeric = '[0-9]+'
const alphanumeric = '[A-Z $%*+\\-./:]+'
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

const TEST_KANJI = new RegExp('^' + kanji + '$')
const TEST_NUMERIC = new RegExp('^' + numeric + '$')
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}

},{}],31:[function(require,module,exports){
const Mode = require('./mode')
const NumericData = require('./numeric-data')
const AlphanumericData = require('./alphanumeric-data')
const ByteData = require('./byte-data')
const KanjiData = require('./kanji-data')
const Regex = require('./regex')
const Utils = require('./utils')
const dijkstra = require('dijkstrajs')

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = []
  let result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  let byteSegs
  let kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = []
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {}
  const graph = { start: {} }
  let prevNodeIds = ['start']

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i]
    const currentNodeIds = []

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j]
      const key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode
  const bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  const nodes = buildNodes(segs)
  const graph = buildGraph(nodes, version)
  const path = dijkstra.find_path(graph.map, 'start', 'end')

  const optimizedSegs = []
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}

},{"./alphanumeric-data":14,"./byte-data":17,"./kanji-data":23,"./mode":25,"./numeric-data":26,"./regex":30,"./utils":32,"dijkstrajs":8}],32:[function(require,module,exports){
let toSJISFunction
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  let digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}

},{}],33:[function(require,module,exports){
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}

},{}],34:[function(require,module,exports){
const Utils = require('./utils')
const ECCode = require('./error-correction-code')
const ECLevel = require('./error-correction-level')
const Mode = require('./mode')
const VersionCheck = require('./version-check')

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
const G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}

},{"./error-correction-code":18,"./error-correction-level":19,"./mode":25,"./utils":32,"./version-check":33}],35:[function(require,module,exports){
const Utils = require('./utils')

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options
  let canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  const size = Utils.getImageWidth(qrData.modules.size, opts)

  const ctx = canvasEl.getContext('2d')
  const image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  const canvasEl = exports.render(qrData, canvas, opts)

  const type = opts.type || 'image/png'
  const rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}

},{"./utils":37}],36:[function(require,module,exports){
const Utils = require('./utils')

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255
  const str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  let path = ''
  let moveBy = 0
  let newRow = false
  let lineLength = 0

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size)
    const row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options)
  const size = qrData.modules.size
  const data = qrData.modules.data
  const qrcodesize = size + opts.margin * 2

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}

},{"./utils":37}],37:[function(require,module,exports){
function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  const hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin

  const width = options.width && options.width >= 21 ? options.width : undefined
  const scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size
  const data = qr.modules.data
  const scale = exports.getScale(size, opts)
  const symbolSize = Math.floor((size + opts.margin * 2) * scale)
  const scaledMargin = opts.margin * scale
  const palette = [opts.color.light, opts.color.dark]

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4
      let pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale)
        const jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}

},{}],38:[function(require,module,exports){
module.exports = ['$scope', '$http', function ($scope, $http) {

    $scope.mailAdres = "";
    $scope.status = "";
    $scope.enrolmentId = "";
    $scope.vavoCollege = "";
    $scope.allSaved = true;
    $scope.admissionTests = [];
    $scope.admissionTestsToDelete = [];
    $scope.newAdmissionTest = {
        uuid: "",
        enrolmentId: "",
        courseName: "",
        date: new Date(),
        time: "",
        materialSent: false,
        grade: "",
        taken: false,
        advice: "",
        newAppointment: false,

        clear: function () {
            uuid = null;
            enrolmentId = null;
            coursename = null;
            date = null;
            time = null;
            materialSent = null;
            grade = null;
        }
    }
    $scope.admissionTestsHeaders = {
        courseName: "Vak",
        date: "Datum",
        time: "Tijd",
        materialSent: "Materiaal opgestuurd",
        taken: "Gedaan",
        grade: "Cijfer",
        // called: "Gebeld",
        advice: "Advies",
        // newAppointment: "Nieuwe afspraak",
    }
    $scope.dates = [];
    $scope.times = [];
    $scope.course = "";
    $scope.currentlyEditing = "";



    $('#mailOk').css('display', 'none');
    $scope.back = function () {
        window.history.back();
    }

    $scope.save = function () {
        this.save("no");
    }

    $scope.hasKey = function (arr, value) {
        let hasKey = false;
        Object.keys(arr).forEach(function (key) {
            if (key == value) {
                hasKey = true;
            }
        })
        return hasKey
    }

    $scope.getMonthNumber = function (month) {
        if (month != null) {
            month = month.toLowerCase();
            var months = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
            return months.indexOf(month);
        }
    };

    $scope.getAdmissionTests = function (uuid) {
        let requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/getAdmissionTestsForEnrolment?uuid=" + uuid;
        } else {
            requestUrl = "/.rest/admissiontest/v1/getAdmissionTestsForEnrolment?uuid=" + uuid;
        }
        // $scope.admissionTests.
        console.log(requestUrl);
        $.ajax({
            url: requestUrl,
            type: "get",
            contentType: "application/json",
            success: function (res) {
                console.log('res in getAdmissionTests', res.admissionTestList)
                for (let i = 0; i < res.admissionTestList.length; i++) {
                    $scope.admissionTests.push(res.admissionTestList[i]);
                }
                $scope.$apply();
                //Make sure the ui is updated before changing input fields to date fields
                setTimeout(function () {
                    $scope.setDateField()
                }, 100);

            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + JSON.stringify(error)
                );
            },
        });
    };

    $scope.$watch('admissionTests', function () {
        $scope.getAdmissionTests($scope.getUuidFromUrl());
    });

    $scope.getUuidFromUrl = function () {
        return new URLSearchParams(window.location.search).get('enrolmentId');
    }

    $scope.getInputType = function (value) {
        switch (typeof value) {
            case "string":
                result = "text";
                break;
            case "boolean":
                result = "checkbox";
                break;
            default:
                result = "text";
                break;
        }
        return result;
    }

    $scope.test = function () {
        return true;
    }

    $scope.removeTest = function (uuid) {
        if (confirm("Weet je zeker dat je deze toets wilt verwijderen?")) {
            let indexToRemove = $scope.admissionTests.findIndex(function (admissionTest) {
                return admissionTest.uuid === uuid;
            })
            $scope.admissionTestsToDelete.push(uuid)
            $scope.admissionTests.splice(indexToRemove, 1)
        }
    }

    $scope.saveAdmissionTests = function () {
        changedUUIDs = $scope.getChangedAdmissionTests($scope.formEditAdmissionTests);
        let requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/update";
        } else {
            requestUrl = "/.rest/admissiontest/v1/update";
        }
        console.log(requestUrl);
        let body = $scope.admissionTests;

        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(body),
            success: function (res) {
                // TODO: reload ofzo, iets van feedback
                $scope.admissionTests = [];
                $scope.$apply();
                console.log("res of update/create", res);
                $scope.currentlyEditing="";
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + JSON.stringify(error)
                );
            },
        });

        if ($scope.admissionTestsToDelete) {
            for (let i = 0; i < $scope.admissionTestsToDelete.length; i++) {
                let uuid = $scope.admissionTestsToDelete[i];
                let requestUrl = '';
                if (location.hostname === "localhost") {
                    requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/delete?uuid=" + uuid;
                } else {
                    requestUrl = "/.rest/admissiontest/v1/delete?uuid=" + uuid;
                }
                console.log(requestUrl);
                $.ajax({
                    url: requestUrl,
                    type: "delete",
                    async: false,
                    contentType: "application/json",
                    success: function (res) {
                        console.log('res of delete', res);

                    },
                    error: function (error) {
                        console.error(
                            "The following error occurred: " + JSON.stringify(error)
                        );
                    },
                });
            }
            $scope.admissionTestsToDelete = [];
        }

    }

    $scope.loadDates = function (element , year )
    {
        $scope.course =  element.value
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/config/testdates?year=" + year + "&course="+ $scope.course;
        } else {
            requestUrl = "/.rest/admissiontest/v1/config/testdates?year=" + year + "&course="+ $scope.course;
        }
        console.log(requestUrl);
        $.ajax({
            url: requestUrl,
            type: "get",
            async: false,
            contentType: "application/json",
            success: function (res) {
                $scope.dates = res.testValue;
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + JSON.stringify(error)
                );
            },
        });
    }

  $scope.loadTimes = function (element , year )
    {
        let date = element.value.replace('string:', '');
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/config/testtimes?year=" + year + "&course="+ $scope.course + "&date="+ date;
        } else {
            requestUrl = "/.rest/admissiontest/v1/config/testtimes?year=" + year + "&course="+  $scope.course  + "&date="+ date;
        }
        $.ajax({
            url: requestUrl,
            type: "get",
            async: false,
            contentType: "application/json",
            success: function (res) {
                $scope.times = res.testValue;
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + JSON.stringify(error)
                );
            },
        });
    }

    $scope.canAddNewDisabled = function() {
        if ($scope.currentlyEditing !== "") {
            // console.log("Editing row, shouldn't be able to add new rows now!");
            return true;
        }
        for (admissionTest in $scope.admissionTests) {
            if ($scope.admissionTests[admissionTest].uuid.includes("temp")) {
                return true;
            }
        }
        return false;
    }

    $scope.getAdmissionTestByUUID = function (uuid) {
        return $scope.admissionTests;

        for (admissionTest in $scope.admissionTests) {
            if ($scope.admissionTests[admissionTest].uuid === uuid) {
                return $scope.admissionTests[admissionTest];
            }
        }
        return null;
    }

    $scope.getInputName = function (uuid, fieldName) {
        return uuid + "_" + fieldName;
    }

    $scope.splitInputName = function (inputName) {
        return inputName.split("_");
    }

    $scope.getChangedAdmissionTests = function (inputFields) {
        changedUUIDs = [];
        // returns uuids of changed admissiontests
        for (field in inputFields) {
            if (!field.startsWith("$")) {
                if (inputFields[field].$dirty) {
                    uuid = $scope.splitInputName(inputFields[field].$name)[0];
                    if (uuid.includes('tempID')) {
                        changedUUIDs.push(uuid)
                    }
                    if (!changedUUIDs.includes(uuid)) {
                        changedUUIDs.push(uuid);
                    }
                }
            }
        }
        return changedUUIDs;
    }

    let tempId = 0;
    $scope.addTest = function () {
        $scope.currentlyEditing = 'tempId' + tempId;
        $scope.admissionTests.push({
            uuid: 'tempId' + tempId++,
            courseName: "",
            date: '',
            materialSent: false,
            taken: false,
            called: false,
            newAppointment: false,
            enrolmentId: $scope.getUuidFromUrl()
        });
        //Make sure the ui is updated before changing input fields to date fields
        setTimeout(function () {
            $scope.setDateField()
        }, 100);
    }

    $scope.editRow = function (uuid, year) {
        $scope.currentlyEditing = uuid;
        let courseNameField = $("#" + $scope.getInputName(uuid, "courseName"));
        let dateField = $("#" + $scope.getInputName(uuid, "date"));
        console.log(courseNameField);
        console.log($scope.getInputName(uuid, "courseName"));
        for (admissionTest in $scope.admissionTests) {
            if ($scope.admissionTests[admissionTest].uuid === uuid) {
                console.log($scope.admissionTests[admissionTest]);
                courseNameField.value = $scope.admissionTests[admissionTest].courseName;
                $scope.loadDates(courseNameField, year);
                dateField.value = $scope.admissionTests[admissionTest].date;
                $scope.loadTimes(dateField, year);
            }
        }
        // console.log($scope.currentlyEditing);
    }

    $scope.canEditRow = function () {
        return $scope.currentlyEditing === "";
    }

    $scope.isDisabled = function(value, name, uuid) {
        if (uuid === $scope.currentlyEditing) return false;

        if (name.includes('tempId')) {
            if ($scope.currentlyEditing === "") {
                return false;
            }
        }

        return true;
    }

    // var dates = ["20/06/2021", "21/06/2021", "22/06/2021", "23/06/2021"];
    // var dates = [ ];

    function DisableDates(date) {
        var string = jQuery.datepicker.formatDate('dd/mm/yy', date);
        return [$scope.dates.indexOf(string) >= 0 || $scope.dates.length < 1];
    }

    $scope.setDateField = function () {
        for (field in $scope.formEditAdmissionTests) {
            if (field.includes('_date')) {
                $("[name=" + field + "]").datepicker({
                    changeMonth: true,
                    changeYear: true,
                    yearRange: "-1:+1",
                    dateFormat: "dd MM yy",
                    regional: "nl",
                    beforeShowDay: disableDates
                });
            }
        }
    }
}];

},{}],39:[function(require,module,exports){
module.exports = ['$scope', '$http', 'Blob', 'FileSaver', function ($scope, $http, Blob, FileSaver) {
    $scope.admissionTestCourseConfig = {};
    $scope.admissionTestEnrolments = [];
    $scope.admissionTestSearch = {};
    $scope.admissionTestSearchFilters = {};
    $scope.admissionTestSortType = '';
    $scope.admissionTestSortReverse = false;
    $scope.admissionTestSearchResults = [];
    $scope.searchEducationOptions = [];
    $scope.admissionTestTotalSearchResults = 0;
    $scope.admissionTestSearchAdmissonTestCourseNameOptions = [];
    $scope.admissionTestcurrentAdmissionTestsPage = 1;
    $scope.admissionTestcurrentAdmissionTestsPageWithFilter = 1;
    $scope.admissionTestFilteredResults = null;

    $scope.currentAdmissionTestsPage = 1;
    $scope.currentAdmissionTestsPageWithFilter = 1;

    $scope.admissionTestGoToAdmissionTest = function (enrolment, url) {
        window.location.href = url + "?enrolmentId=" + enrolment["enrolmentId"];
    };

    $scope.admissionTestClearFilter = function () {
        var clearValues = ["searchAdmissionTestText", "searchAdmissionTestIsCalled", "searchAdmissionTestNewAppointment",
            "searchAdmissionTestCourseName", "searchAdmissionTestDate", "searchAdmissionTestTime", "searchAdmissionTestIsMaterialSent",
            "searchAdmissionTestTaken"];
        for (var x = 0; x < clearValues.length; x++) {
            $scope[clearValues[x]] = "";
            sessionStorage.setItem(clearValues[x], JSON.stringify(""));
        }
        $scope.admissionTestSearchStatus = [];
        $scope.admissionTestcurrentAdmissionTestsPage = parseInt(sessionStorage.getItem("currentAdmissionTestsPage"))
    };

    $scope.storeFieldValue = function (fieldName) {
        if (fieldName !== null && fieldName !== undefined) {
            sessionStorage.setItem(fieldName, JSON.stringify($scope[fieldName]));
        } else {
            sessionStorage.removeItem(fieldName);
        }
    };

    $scope.loadFieldValue = function (fieldName) {
        var loc = sessionStorage.getItem(fieldName);
        if (loc && loc !== "undefined" && loc !== "null") {
            var value = JSON.parse(loc);
            if (value) {
                $scope[fieldName] = value;
            }
        }
    };

    $scope.$watch('admissionTestSearch["yearCourse"]', function (newValue) {
        $('.table tbody > tr').empty();
        $('.table tbody > tr').remove();
        $scope.getAdmissionTests(newValue, $scope.admissionTestSearchResults);
    });

    $scope.admissionTestCsv = function () {
        var response = {"vavoCollege": $scope.intake['vavoCollege']};
        response.admissionTests = $scope.admissionTestFilteredResults.map(function (enrolment, index) {
            return enrolment.uuid;
        });
        response.year = $scope.admissionTestSearch["yearCourse"];

        var requestUrl;
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/getCsv";
        } else {
            requestUrl = "/.rest/admissiontest/v1/getCsv";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(response),
            success: function (response) {
                var data = new Blob([response], {type: 'text/csv'});
                FileSaver.saveAs(data, 'export.csv');
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
            },
        });
    };

    $scope.admissionTestLoadPagination = function () {
        return $scope.admissionTestFilteredResults != null && $scope.calculateAdmissionTestsPages() > 1;
    };

    $scope.getAdmissionTestsPage = function () {
        if (sessionStorage.getItem("currentAdmissionTestsPage") === null) {
            $scope.currentAdmissionTestsPage = 1
            $scope.storeFieldValue("currentAdmissionTestsPage")
        }
        if ($scope.emptyAdmissionTestsFilter()) {
            $scope.currentAdmissionTestsPageWithFilter = 1;
            $scope.currentAdmissionTestsPage = parseInt(sessionStorage.getItem("currentAdmissionTestsPage"));
            if ($scope.currentAdmissionTestsPage > $scope.calculateAdmissionTestsPages() && $scope.calculateAdmissionTestsPages() !== 0) {
                $scope.currentAdmissionTestsPage = 1;
                $scope.storeFieldValue("currentAdmissionTestsPage")
            }
            return sessionStorage.getItem("currentAdmissionTestsPage")
        } else {
            if ($scope.currentAdmissionTestsPageWithFilter > $scope.calculateAdmissionTestsPages()) {
                $scope.currentAdmissionTestsPageWithFilter = 1;
            }
            return $scope.currentAdmissionTestsPageWithFilter;
        }
    }

    $scope.emptyAdmissionTestsFilter = function () {
        if (sessionStorage.getItem("searchAdmissionTestText") === null || sessionStorage.getItem("searchAdmissionTestText") === undefined) {
            $scope.admissionTestClearFilter();
        }
        if (sessionStorage.getItem("searchAdmissionTestText").length <= 2 && sessionStorage.getItem("searchAdmissionTestIsCalled").length <= 2 &&
            sessionStorage.getItem("searchAdmissionTestNewAppointment").length <= 2 && sessionStorage.getItem("searchAdmissionTestCourseName").length <= 2 &&
            sessionStorage.getItem("searchAdmissionTestDate").length <= 2 && sessionStorage.getItem("searchAdmissionTestTime").length <= 2 &&
            sessionStorage.getItem("searchAdmissionTestIsMaterialSent").length <= 2 && sessionStorage.getItem("searchAdmissionTestTaken").length <= 2) {
            $scope.currentAdmissionTestsPageWithFilter = 1;
            return true;
        } else {
            return false;
        }
    }

    $scope.replaceMonthBack = function (val) {
        switch (val) {
            case "januari":
                return '01';
            case "februari":
                return '01';
            case "maart":
                return '03';
            case "april":
                return '04';
            case "mei":
                return '05';
            case "juni":
                return '06';
            case "juli":
                return '07';
            case "augustus":
                return '08';
            case "september":
                return '09';
            case "oktober":
                return '10';
            case "november":
                return '11';
            case "december":
                return '12';
        }
        return val;
    }

    $scope.getAdmissionTests = function (uuid) {
        var vavoCollege = encodeURIComponent($scope.intake['vavoCollege']);

        let requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/getAdmissionTests?vavoCollege=" + vavoCollege + "&year=" + $scope.admissionTestSearch["yearCourse"];
        } else {
            requestUrl = "/.rest/admissiontest/v1/getAdmissionTests?vavoCollege=" + vavoCollege + "&year=" + $scope.admissionTestSearch["yearCourse"];
        }
        console.log(requestUrl);
        $.ajax({
            url: requestUrl,
            type: "get",
            contentType: "application/json",
            success: function (res) {
                console.log(res)
                for (let i = 0; i < res.admissionTestList.length; i++) {

                    if (res.admissionTestList[i].date != null) {
                        testDateString = res.admissionTestList[i].date;
                        var date_arr = testDateString.split("-");
                        testDate = new Date();
                        testDate.setFullYear(date_arr[2], $scope.replaceMonthBack(date_arr[1]) - 1, date_arr[0]);
                        res.admissionTestList[i].testDate = testDate;
                    }

                    $scope.admissionTestSearchResults.push(res.admissionTestList[i]);
                }
                $scope.admissionTestTotalSearchResults = $scope.admissionTestSearchResults.length;
                $scope.$apply();

            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + JSON.stringify(error)
                );
            },
        });

    };

    $scope.redirect = function (url) {
        console.log('url', url)
        window.location.href = url;
    }

    $scope.loadAdmissionTestsPagination = function () {
        return $scope.admissionTestFilteredResults != null && $scope.calculateAdmissionTestsPages() > 1;
    };

    $scope.calculateAdmissionTestsPages = function () {
        if ($scope.admissionTestFilteredResults != null) {
            return Math.ceil($scope.admissionTestFilteredResults.length / 25);
        } else {
            return 0;
        }
    };

    $scope.hasNextAdmissionTestsPage = function () {
        if ($scope.emptyAdmissionTestsFilter()) {
            return $scope.currentAdmissionTestsPage != null && $scope.currentAdmissionTestsPage < $scope.calculateAdmissionTestsPages();
        } else {
            return $scope.currentAdmissionTestsPageWithFilter != null && $scope.currentAdmissionTestsPageWithFilter < $scope.calculateAdmissionTestsPages();
        }
    };

    $scope.nextAdmissionTestsPage = function () {
        if ($scope.hasNextAdmissionTestsPage()) {
            if ($scope.emptyAdmissionTestsFilter()) {
                $scope.currentAdmissionTestsPage += 1;
            } else {
                $scope.currentAdmissionTestsPageWithFilter += 1;
            }
            $scope.storeFieldValue("currentAdmissionTestsPage")
        }
    };

    $scope.previousAdmissionTestsPage = function () {
        if ($scope.emptyAdmissionTestsFilter() && $scope.currentAdmissionTestsPage > 1) {
            $scope.currentAdmissionTestsPage -= 1;
            $scope.storeFieldValue("currentAdmissionTestsPage")
        } else {
            if ($scope.currentAdmissionTestsPageWithFilter > 1) {
                $scope.currentAdmissionTestsPageWithFilter -= 1;
            }
        }
    };

}];



},{}],40:[function(require,module,exports){
module.exports = ['$scope', 'appointmentApiService', function ($scope, appointmentApiService) {
    let $ctrl = this;
    $ctrl.counter = 0
    $ctrl.selectedSlots = []

    function callBack(success, res) {
        if ($ctrl.global.debug){
            console.log("<res @ saveAppointment_callback>")
            console.log(res)
            console.log("</res @ saveAppointment_callback>")
        }

        if (success) {
            $ctrl.global.saveResult.saved = true
            $ctrl.global.saveResult.saving = false
            $ctrl.global.saveResult.success = true
            $ctrl.global.saveResult.appointment.ID = res.appointmentID
            $ctrl.global.saveResult.appointment.time = res.time
            $ctrl.global.saveResult.appointment.date = res.date
            $ctrl.global.saveResult.appointment.name = res.slotNames
        } else {
            $ctrl.global.saveResult.saved = false
            $ctrl.global.saveResult.saving = false
            $ctrl.global.saveResult.success = false
        }
        $ctrl.global.reset = true
        $scope.$apply();
    }

    $ctrl.save = function () {
        if ($ctrl.data.slotIds.length > 0) {
            $ctrl.global.saveResult.saving = true
            appointmentApiService.saveAppointment($ctrl.global.enrolmentID, $ctrl.data.slotIds, $ctrl.global.year, $ctrl.global.type, $ctrl.global.status, $ctrl.global.appointmentID, callBack)
        }
    }

    $ctrl.reset = function () {
        $ctrl.global.reset = true;
    }

    function callBackDeleteAppointment() {
        $ctrl.global.saveResult.saved = true
        $ctrl.global.saveResult.saving = false
        $ctrl.global.saveResult.success = true
        $ctrl.global.saveResult.appointment.ID = ""
        $ctrl.global.saveResult.appointment.time = ""
        $ctrl.global.saveResult.appointment.date = ""
        $ctrl.global.saveResult.appointment.name = ""
        $ctrl.global.current = null
        $ctrl.global.reset = true
    }


    $ctrl.delete = function () {
        if ($ctrl.global.current.id !== undefined && $ctrl.global.current.id !== "") {
            appointmentApiService.deleteAppointment($ctrl.global.current.id, callBackDeleteAppointment)
        }
    }


    $ctrl.hasCurrent = function () {
        if ($ctrl.global.current === undefined) return false
        if ($ctrl.global.current === null) return false
        if ($ctrl.global.current.id === undefined) return false
        return $ctrl.global.current.id < 2
    }

}];

},{}],41:[function(require,module,exports){
module.exports = ['$scope', 'appointmentApiService', function ($scope, appointmentApiService) {
    let $ctrl = this;

    $ctrl.fromintake = undefined;
    $ctrl.global = {
        year: $scope.$parent.year,
        status: $scope.$parent.status,
        vavoCollege: $scope.$parent.vavoCollege,
        enrolmentID: $scope.$parent.enrolmentId,
        reset: false,
        saveResult: {
            saved: false, saving: false, success: true, appointment: {}
        },
        columnCount: 4,
        intake: $ctrl.fromintake,
        extraDateNotificationCutOff: 10,
        debug: true,
        ready: {
            candidates: false, slots: false, times: false
        },
        showSpinner : true
    }
    $ctrl.dateData = {
        availableOptions: [], selectedOption: {id: "", name: "Maak een keuze"}
    };

    $ctrl.data = {dateData: {value: $ctrl.date, timeData: $ctrl.slots}}

    $ctrl.$onInit = function (){
        $ctrl.fromintake.isFromGraphicalAppointmentModule=true
    }

    $scope.$watch('$ctrl.global.saveResult.appointment', function (newValue, oldValue) {
        $ctrl.fromintake.ID = $ctrl.global.saveResult.appointment.ID
        $ctrl.fromintake.time = $ctrl.global.saveResult.appointment.time
        $ctrl.fromintake.date = $ctrl.global.saveResult.appointment.date
        $ctrl.fromintake.name = $ctrl.global.saveResult.appointment.name
    }, true)

    // Change "appointmentData" in enrolmentEditController.js
    $scope.$parent.$watch('appointmentData', function (newValue, oldValue) {
        if (oldValue.status + "" !== newValue.status + "") {
            $ctrl.global.status = newValue.status
            resetData()
        }
    }, true)

    // Change "special_intake" in enrolmentEditController.js
    $scope.$parent.$watch('special_intake', function (newValue, oldValue) {
        if (oldValue + "" !== newValue + "") {
            resetData()
        }
    }, true)

    // Change "uitbesteed" in enrolmentEditController.js
    $scope.$parent.$watch('uitbesteed', function (newValue, oldValue) {
        if (oldValue + "" !== newValue + "") {
            resetData()
        }
    }, true)

    // Change "rutteGesprekAfgerond" in enrolmentEditController.js
    $scope.$parent.$watch('rutteGesprekAfgerond', function (newValue, oldValue) {
        if (oldValue + "" !== newValue + "") {
            resetData()
        }
    }, true)

    $scope.$watch('$ctrl.dateData.selectedOption.id', function (newValue, oldValue) {
        if (oldValue + "" !== newValue + "") {
            resetData()
        }
    })

    $scope.$watch('$ctrl.global.reset', function (newValue, oldValue) {
        if ($ctrl.global.reset) {
            resetData()
        }
        $ctrl.global.reset = false
    })

    $scope.$watch('$ctrl.global.ready', function (newValue, oldValue) {
        if (newValue.candidates && newValue.slots && newValue.times )
        {
            setSlots()
            setCurrentAppointmentInSlots()
            setSelectable(true)
            $ctrl.global.showSpinner = false
        } else {
            $ctrl.global.showSpinner = true
        }
    }, true)

    $ctrl.global.reset = true

    $scope.$watch('$ctrl.data.dateData.timeData', function (newValue, oldValue) {
        if (newValue === undefined) return
        $ctrl.global.selected.slotIds = []
        $ctrl.global.selected.slots = []
        for (const [key, value] of Object.entries(newValue)) {
            value.forEach(slot => {
                if (slot.selected) {
                    $ctrl.global.selected.slotIds.push(slot.id)
                    $ctrl.global.selected.slots.push(slot)
                }
            })
        }
        setSelectable()
        $ctrl.global.requirementsForCandidateForfilled = checkCandidates()
    }, true);

    function objectIsEmpty(object){
        let exit = true
        for (let property in object ) {
            exit = false
        }
        return exit;
    }


    function callBackToSetDates(val) {
        $ctrl.dateData.availableOptions = []
        $ctrl.dateData.availableOptionsForDatePicker = []
        $ctrl.dateData.firstPossibleAppointmentDateInTimestamp = Date.parse((new Date(new Date().setFullYear(new Date().getFullYear() + 2))).toString());
        $ctrl.dateData.lastPossibleAppointmentDateInTimestamp = Date.parse((new Date(new Date().setFullYear(new Date().getFullYear() - 2))).toString());
        $ctrl.dateData.availableOptions.push({id: "", name: "Maak een keuze"})
        for (const [key, value] of Object.entries(val)) {
            $ctrl.dateData.availableOptions.push({id: key, name: value})
            $ctrl.dateData.availableOptionsForDatePicker.push(key)
            setMinMaxDates(key)
        }
        if (!objectIsEmpty(val)) setDatePicker()
    }

    function callBackToSetTimes(val) {
        $ctrl.global.times = val
        $ctrl.global.ready.times = true
    }

    function setMinMaxDates(date) {
        let currentDate = parseDateToTimestamp(date);

        if (currentDate < $ctrl.dateData.firstPossibleAppointmentDateInTimestamp) {
            $ctrl.dateData.firstPossibleAppointmentDateInTimestamp = currentDate;
        }
        if (currentDate > $ctrl.dateData.lastPossibleAppointmentDateInTimestamp) {
            $ctrl.dateData.lastPossibleAppointmentDateInTimestamp = currentDate;
        }
    }

    function parseDateToTimestamp(str) {
        const parts = str.split("-");
        const dt = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
        return dt.getTime()
    }

    function callbackToSetSlots(val) {
        $ctrl.slotsFromServer = val

        $ctrl.global.ready.slots = true

    }
    function setSlots(){
        if ($ctrl.slotsFromServer.length !== 0) {
            $ctrl.slots = appointmentApiService.orderSlots($ctrl.slotsFromServer.slots, $ctrl)
        } else {
            $ctrl.slots = []
        }
        $ctrl.data = {dateData: {value: $ctrl.date, timeData: $ctrl.slots}}

        let root = document.documentElement;
        let addColumn = 0
        if ($ctrl.global.columnCount > $ctrl.global.extraDateNotificationCutOff) {
            addColumn = 1

        }
        root.style.setProperty('--column-count', $ctrl.global.columnCount + addColumn);

    }

    function callbackToSetCandidates(val) {
        $ctrl.candidates = val.candidates
        if ($ctrl.global.debug) {
            console.log("<val.candidates>")
            console.log(val.candidates)
            console.log("</val.candidates>")
        }
        $ctrl.global.ready.candidates = true
    }

    function callbackToSetCurrentAppointment(val) {

        $ctrl.global.current = val.appointment
        if ($ctrl.dateData.selectedOption !== null && $ctrl.dateData.selectedOption.id.length < 2 && val.appointment !== null) {
            $ctrl.dateData.selectedOption.id = val.appointment.date
        }
    }

    function resetData() {
        setType()
        if ($ctrl.fromintake.ID === undefined) {
            $ctrl.global.appointmentID = $scope.$parent.appointmentID
        } else {
            $ctrl.global.appointmentID = $ctrl.fromintake.ID
        }

        appointmentApiService.fetchAppointment($ctrl.global.appointmentID, callbackToSetCurrentAppointment)
        $ctrl.status = $scope.$parent.status
        appointmentApiService.fetchDates($ctrl.global.year, $ctrl.status, callBackToSetDates);

        if ($ctrl.dateData.selectedOption && $ctrl.dateData.selectedOption.id !== "") {
            getAndSetTimes()
            getAndSetSlots()
            if ($ctrl.global.type !== "") getAndSetCandidates();
        } else {
            getAndSetTimes([])
            callbackToSetSlots([])
            callbackToSetCandidates([])
        }
        clearSelected()
    }

    function getAndSetTimes() {
        $ctrl.global.ready.times = false
        appointmentApiService.fetchTimes($ctrl.global.year, $ctrl.dateData.selectedOption.id, callBackToSetTimes);
    }

    function getAndSetSlots() {
        $ctrl.global.ready.slots = false
        appointmentApiService.fetchSlots($ctrl.global.year, $ctrl.dateData.selectedOption.id, $ctrl.global.status, $ctrl.global.type, callbackToSetSlots);
    }

    function getAndSetCandidates() {
        $ctrl.global.ready.candidates = false
        appointmentApiService.fetchCandidates($ctrl.global.year, $ctrl.dateData.selectedOption.id, $ctrl.global.status, $ctrl.global.type, callbackToSetCandidates)
    }


    //TODO This is client logic and should be moved to the backend
    function setType() {
        $ctrl.global.type = ""
        $ctrl.appointmentData = $scope.$parent.appointmentData
        if ($scope.$parent.special_intake === "Ja" && $ctrl.global.vavoCollege === "roc-groningen") {
            $ctrl.global.type = "long"
        }
        let afgerond = ( undefined !== $scope.$parent.rutteGesprekAfgerond && ($scope.$parent.rutteGesprekAfgerond === "Ja"))
        if ($scope.$parent.uitbesteed === "true"  && $ctrl.global.vavoCollege === "roc-amsterdam" && !afgerond) {
            $ctrl.global.type = "rutte"
        }
        if ($ctrl.global.debug) {
            console.log("<type>")
            console.log($ctrl.global.type)
            console.log("</type>")
        }
    }

    function clearSelected() {
        $ctrl.global.selected = {slots: [], slotIds: [], candidateIds: [], lastCandidateSlotList: []}
    }

    function setSelectable(clearSelectedSlot) {
        if ($ctrl.global.type === undefined || $ctrl.global.type === "") return
        let hasSelected = ($ctrl.global.selected.slotIds !== undefined && ($ctrl.global.selected.slotIds).length > 0)
        unsetCandidateSlots()
        $ctrl.global.selected.candidateIds = []
        $ctrl.global.selected.candidates = []
        for (const [key, value] of Object.entries($ctrl.data.dateData.timeData)) {
            for (let slotNr in $ctrl.data.dateData.timeData[key]) {
                let slot = $ctrl.data.dateData.timeData[key][slotNr]
                if (clearSelectedSlot) {
                    slot.selected = false
                }
                if (isCandidateSlot(slot.id, hasSelected)) {
                    slot.isSelectable = true
                    slot.isCandidate = true
                }
            }
        }
    }

    function setCurrentAppointmentInSlots() {
        if ($ctrl.global.current == null) return

        for (const [key, value] of Object.entries($ctrl.data.dateData.timeData)) {
            for (let slotNr in $ctrl.data.dateData.timeData[key]) {
                let slot = $ctrl.data.dateData.timeData[key][slotNr]
                if ($ctrl.global.current.timeSlotsUUIDs.includes(slot.id)) {
                    slot.current = true
                }
            }
        }
    }

    function unsetCandidateSlots() {
        for (const [key, value] of Object.entries($ctrl.data.dateData.timeData)) {
            for (let slotNr in $ctrl.data.dateData.timeData[key]) {
                let slot = $ctrl.data.dateData.timeData[key][slotNr]
                slot.isSelectable = false

            }
        }
    }

    function isCandidateSlot(uuid, mustMachCurrentCandidates) {
        let returnValue = false
        if ($ctrl.candidates === undefined) return false
        $ctrl.candidates.forEach(candidate => {
            let currentCandidatesMach = true
            for (let idsKey in $ctrl.global.selected.slotIds) {
                let id = $ctrl.global.selected.slotIds[idsKey]
                if (!candidate.timeSlotsUUIDs.includes(id)) {
                    currentCandidatesMach = false
                }
            }
            if (candidate.timeSlotsUUIDs.includes(uuid) && (!mustMachCurrentCandidates || currentCandidatesMach)) {
                returnValue = true
                if (!$ctrl.global.selected.candidateIds.includes(candidate.tempId)) {
                    $ctrl.global.selected.candidateIds.push(candidate.tempId)
                    $ctrl.global.selected.candidates.push(candidate)
                }
            }
        })
        return returnValue
    }

    function checkCandidates() {
        if ($ctrl.candidates === undefined) {
            return false
        }
        if ($ctrl.global.selected.candidates === undefined) {
            return true
        }
        if ($ctrl.global.selected.candidates.length < 1) {
            return true
        } else if ($ctrl.global.selected.candidates.length === 1) {
            for (id of $ctrl.global.selected.candidates[0].timeSlotsUUIDs) {
                if (!$ctrl.global.selected.slotIds.includes(id)) {
                    $ctrl.global.selected.lastCandidate = undefined
                    return false
                }
            }
            $ctrl.global.selected.lastCandidate = $ctrl.global.selected.candidates[0]
            return true
        } else {
            $ctrl.global.selected.lastCandidate = undefined
            return false
        }
    }

    function available(date) {
        let dmy = date.getDate().toString().padStart(2, '0') + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getFullYear();
        if ($.inArray(dmy, $ctrl.dateData.availableOptionsForDatePicker) !== -1) {
            return [true, "", "Available"];
        } else {
            return [false, "", "unAvailable"];
        }
    }

    function setDatePicker() {

        let first = new Date($ctrl.dateData.firstPossibleAppointmentDateInTimestamp);
        let last = new Date($ctrl.dateData.lastPossibleAppointmentDateInTimestamp);
        let startDateFrom = new Date(first.getFullYear(), first.getMonth(), 1);
        let startDateTo = new Date(last.getFullYear(), last.getMonth() + 1, 0);

        let data = {
            changeMonth: true,
            changeYear: false,
            yearRange: "-1:+1",
            dateFormat: "dd-mm-yy",
            minDate: startDateFrom,
            maxDate: startDateTo,
            beforeShowDay: available
        }

        $("#dateSelectNewAppointment").datepicker(data).datepicker("option", "minDate", startDateFrom).datepicker("option", "maxDate", startDateTo);
    }
}]


},{}],42:[function(require,module,exports){
module.exports = ['$scope', 'appointmentApiService', function ($scope, appointmentApiService) {
    let $ctrl = this;

    $scope.$watch('$ctrl.data.timeData', function (newValue, oldValue) {
        if (newValue===undefined)return
        let names = []
        let slots = Object.values(newValue)[0]
        for (let slot in slots ){
            names.push(slots[slot].name)
        }
        $ctrl.names = names
    }, true);

}];

},{}],43:[function(require,module,exports){
module.exports = ['$scope', 'appointmentApiService', function ($scope, appointmentApiService) {
    let $ctrl = this;

    $ctrl.selectthis = function () {


        let enter = (this.data.available) && ((this.data.isSelectable || this.global.requirementsForCandidateForfilled) || (this.global.type === undefined || this.global.type === ""))

        if (!enter) return

        if ($ctrl.global.debug) {
            console.log("<$ctrl.data>")
            console.log($ctrl.data)
            console.log("</$ctrl.data>")
        }

        this.data.selected = !this.data.selected;
    }

    $ctrl.$onInit = function () {
        $ctrl.tooltip = "";

        if ($ctrl.data !== undefined && $ctrl.data.time !== undefined) {
            $ctrl.tooltip = $ctrl.data.time.replace("-", ":") + " - " + $ctrl.data.name
        }
    }

    $ctrl.slotPlaceholder = function () {
        return !(this.data.possibleStatuses !== undefined && this.data.possibleStatuses.length > 0);
    }

    $ctrl.freeForStatus = function () {
        return (this.global.type === undefined || this.global.type === "") || this.global.requirementsForCandidateForfilled
    }
    $ctrl.getId = function () {
        return $ctrl.data.id
    }
}];

},{}],44:[function(require,module,exports){
module.exports = ['$scope', 'appointmentApiService', function ($scope, appointmentApiService) {
    var $ctrl = this;

    $ctrl.$onInit = function () {
        this.selectedSlot = $ctrl.selectedSlot || 'na';
        this.now = this.data.value;
    }

    $ctrl.respondtotime = function (responsedata) {
        this.selectedSlot = responsedata;
        $ctrl.respondtodate({responsedata: responsedata})
    }

    $ctrl.halfHour = function (time){
        return time.slice(-2) === "30";
    }

    $ctrl.addTimeAtEnd = function (){
        return $ctrl.data.length >= $ctrl.global.extraDateNotificationCutOff;
    }

}];

},{}],45:[function(require,module,exports){
module.exports = ['$scope', '$http', 'courseConfigService', function ($scope, $http, courseConfigService) {
    $scope.currentStep = 'beoogdDiplomaFormulierOverview';
    $scope.data = [];
    $scope.intake = {};
    $scope.intakeProperties = {};
    $scope.originalProfileChoices = {};
    $scope.automatedFulltimeParttime = false;
    $scope.fulltimeAmount = 0;
    $scope.lesuren = 0;
    $scope.printForm = false;
    $scope.showMathWarning = false;

    let chosenProfileOption;

    $(".enrolment-step").first().show();

    let element1 = document.getElementById("intakeVerslagNederlandsAnderstalig0");
    if (null != element1) {
        element1.addEventListener("change", (event) => {
            $scope.intake["intakeVerslagNederlandsAnderstalig"] = "Ja"
            $scope.calculateVoltijdDeeltijd()
        })
    }

    let element2 = document.getElementById("intakeVerslagNederlandsAnderstalig1");
    if (null != element2) {
        element2.addEventListener("change", (event) => {
            $scope.intake["intakeVerslagNederlandsAnderstalig"] = "Nee"
            $scope.calculateVoltijdDeeltijd()
        })
    }

    $scope.setNederlandsQuestion = function (enrolmentId) {
        let elementExtraNederlandsCheckBox = document.getElementById("intakeVerslagNederlandsAnderstaligCheck-_ms_-0");
        if (null != elementExtraNederlandsCheckBox) {
            elementExtraNederlandsCheckBox.addEventListener("change", (event) => {
                if (event.target.checked){
                    $scope.intake["intakeVerslagNederlandsAnderstalig"] = "Ja"
                    $scope.calculateVoltijdDeeltijd()
                }else{
                    $scope.intake["intakeVerslagNederlandsAnderstalig"] = "Nee"
                    $scope.calculateVoltijdDeeltijd()
                }
            })
            if ($scope.intake["intakeVerslagNederlandsAnderstalig"]===undefined){
                $scope.intake.intakeVerslagNederlandsAnderstalig = "Nee";
            }else{
                elementExtraNederlandsCheckBox.checked = ($scope.intake.intakeVerslagNederlandsAnderstalig === "Ja")
            }
        }
    }

    $scope.formId = makeid();
    var selectedProfileCourses = [];
    $scope.isSelectedProfileCourse = function (id) {
        var selected = false;
        angular.forEach(selectedProfileCourses, function (selectedProfileCourse) {
            if (selectedProfileCourse.id === id) {
                selected = true;
                return true;
            }
        });
        return selected;
    };

    $scope.initVariables = function (enrolmentId) {
        //TODO: Get enrolmentinfo + set scope correctly.
        var requestUrl = "";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getEnrolment?uuid=" + enrolmentId;
        } else {
            requestUrl = "/.rest/intake/v1/getEnrolment?uuid=" + enrolmentId;
        }

        $http({
            url: requestUrl,
            method: "GET",

        }).then(function (response) {
            var data = response.data.properties;
            angular.forEach(data, function (_v, _k) {
                if (_v.id === "vavoCollege") {
                    $scope.intake["vavoCollege"] = _v.value;
                }
                $scope.intakeProperties[_v.id] = {};
                $scope.intakeProperties[_v.id].label = _v.label;
                var checkField = "";
                if (_v.id.substring(0, 4) !== "mgnl") {
                    checkField = $('#' + _v.id + '[data-reset-value=true]');
                }
                if ((checkField).length > 0) {
                    $scope.intake[_v.id] = "";
                } else {

                    if (_v.value === "Eerste keus" || _v.value === "Tweede keus" || _v.value === "Derde keus") {
                        $scope.intake[_v.id] = _v.label;

                    } else {
                        $scope.intake[_v.id] = _v.value;
                    }

                }
                if (_v.id === "chosenProfileOption") {
                    $scope.intake['chosenProfileOptions'] = _v.value;
                }
                if (_v.id === "voSchool") {
                    $scope.intake['voSchool'] = _v.value;
                }
                if (_v.id === "intakeVerslagNederlandsAnderstalig") {
                    $scope.intake['intakeVerslagNederlandsAnderstalig'] = _v.value;
                    $scope.setNederlandsQuestion()
                }
            });
            if ($scope.intake['intakeVerslagNederlandsAnderstalig']===undefined){
                $scope.intake['intakeVerslagNederlandsAnderstalig']="Nee";
                $scope.setNederlandsQuestion();
            }

            if (response.data.courseConfig) {
                selectedProfileCourses = getSelectedProfileCourses(response.data.courseConfig);
            }
            $scope.getProfileOptions();
            $scope.initOptionalFields();
            $scope.initTrajectOptions();
        });
    };

    $scope.isValidCheckboxGroup = function (_currentStep) {
        var form = $("#form-" + _currentStep);
        var checkboxGroups = form.find(".checkbox-group.required");
        var groupsAreValid = true;
        checkboxGroups.each(function() {
            var element = $(this).find(':checkbox').get(0);
            if($(this).find(':checkbox:checked').length <= 0){
                element.setCustomValidity('Selecteer een of meerdere waarde(s)');
                try {
                    element.reportValidity();
                } catch (e) {
                    element.focus();
                }
                groupsAreValid = false;
                return false;
            }
            element.setCustomValidity("");
            element.reportValidity();
        });
        return groupsAreValid;
    }

    $scope.isValidFileUpload = function (_currentStep) {
        var form = $("#form-" + _currentStep);
        var fileuploadLists = form.find(".input-fileupload.required");
        var groupsAreValid = true;
        fileuploadLists.each(function() {
            var element = $(this).find('.fileInput').get(0);
            if($(this).find('li').length <= 0){
                element.setCustomValidity('Selecteer een of meerdere bestanden.');
                try {
                    element.reportValidity();
                } catch (e) {
                    element.focus();
                }
                groupsAreValid = false;
                return false;
            }
            element.setCustomValidity("");
            element.reportValidity();
        });
        return groupsAreValid;
    }

    $scope.isValidBSN = function (_currentStep) {

        var form = $("#form-" + _currentStep);

        var bsnErrors = form.find(".bsnError");
        if (bsnErrors.length > 0) {
            //Previous element has to be the BSN input field
            var element = $(bsnErrors[0].parentElement.previousElementSibling).children().filter('input[type="text"]').get(0);
            element.setCustomValidity('Dit is een ongeldig BSN.');
            try {
                element.reportValidity();
            } catch (e) {
                element.focus();
            }

            return false;
        }
        return true;
    };

    /**
     * Loop through the forums and check what the last valid form is
     * @param numberOfForms {String} the number of forums
     * @returns {number} The max valid step
     */
    $scope.maxValidStep = function (numberOfForms) {
        for (let i = 0; i <= parseInt(numberOfForms); i++) {
            if (!$("#form-" + i)[0].checkValidity()) {
                return i;
            }
        }
        return maxStep;
    }

    /**
     * Check if the new form step is allowed
     * @param newStep
     * @param _currentStep
     * @param numberOfForms {String} the number of forums
     */
    $scope.validStep = function (newStep, _currentStep, numberOfForms) {
        if (this.isValidBSN(_currentStep) && (parseInt(newStep) - 1) <= this.maxValidStep(numberOfForms)) {
            this.changeStep(newStep, _currentStep);
        }
    }

    $scope.nextStep = function (_number) {
        if (maxStep <= (parseInt(_number) + 1)) {
            maxStep = maxStep + 1;
        }
        var thisStep = $(".enrolment-step[step = " + _number + "]").first();
        thisStep.hide();
        var nextStep = thisStep.next();
        nextStep.show();
    };

    $scope.previousStep = function (_number) {
        if (_number === 0) {
            window.history.go(-1);
        }
        var thisStep = $(".enrolment-step[step = " + _number + "]").first();
        var prevStep = thisStep.prev();
        thisStep.hide();
        prevStep.show();
    };

    /**
     * Get the max step of the forum
     * @returns {number} maxStep
     */
    $scope.getMaxStep = function () {
        return maxStep;
    }

    let maxStep = 1;

    /**
     * Change the step in the form
     * @param newStep Current number
     * @param _currentStep The step to hide
     */
    $scope.changeStep = function (newStep, _currentStep) {
        if (newStep <= maxStep) {
            if (parseInt(newStep) === maxStep) {
                let thisStep = $(".enrolment-step[step = " + (maxStep - 2) + "]").first();
                let hideStep = $(".enrolment-step[step = " + _currentStep + "]").first();
                let nextStep = thisStep.next();
                hideStep.hide();
                nextStep.show();
            } else {
                let thisStep = $(".enrolment-step[step = " + newStep + "]").first();
                let hideStep = $(".enrolment-step[step = " + _currentStep + "]").first();
                let nextStep = thisStep.prev(newStep);
                hideStep.hide();
                nextStep.show();
            }

            $('input[id*="submit-button"]').removeAttr('disabled');
            $('#error').hide();
        }
    };

    /**
     * Checks if the current form is valid
     * @param formStep String formStep
     * @returns {boolean} true if the form is valid
     */
    $scope.isFormValid = function (formStep) {
        return $("#form-" + parseInt(formStep))[0].checkValidity()
    }

    $scope.isFinalStep = function (_number) {
        return _number == ($(".enrolment-step").length - 1);
    };

    $scope.isValidBdfCourse = function (required, traject, grade) {
        if (required) {
            return ((traject === undefined || traject === null || 0 === traject.length));
        } else {
            return false;
        }
    };

    $scope.$watch('intake["graduation"]', function () {
        if ($scope.intake['graduation'] && $scope.intake['educationType'] && $scope.intake['vavoCollege']) {
            $scope.getProfileOptions($scope.intake['vavoCollege']);
        }
        if ($scope.intake['graduation'] == 'certificaat') {
            delete $scope.intake['chosenProfileOption'];
        }
    });

    $scope.$watch('intake["educationType"]', function () {
        if ($scope.intake['graduation'] && $scope.intake['educationType'] && $scope.intake['vavoCollege']) {
            $scope.profileOptions = '';
            $scope.getProfileOptions($scope.intake['vavoCollege']);
            $scope.initOptionalFields();
            $scope.initTrajectOptions();
        }
    });

    $scope.back = function () {
        window.history.back();
    };


    $scope.doCourseChecks=function (profile,intake){
        $scope.checkException(profile);
        $scope.checkMath(intake.educationType,profile);
    }


    $scope.checkException = function (profile) {
        var exceptionArray = [];
        for (var profileProp in profile) {
            // skip loop if the property is from prototype
            if (!profile.hasOwnProperty(profileProp)) continue;

            var section = profile[profileProp];
            for (var sectionProp in section) {
                if (!section.hasOwnProperty(sectionProp)) continue;
                var option = section[sectionProp];

                if (option.course && option.course.selected) {
                    if (option.course.selected.exceptionID != 0) {
                        exceptionArray.push(option.course.selected.exceptionID);
                    }
                }
            }
        }
        $scope.coursesFilter = exceptionArray;
    };

    $scope.checkMath = function (educationType, profile) {
        if (undefined === profile) return false;
        let checkForCourses = ["Wiskunde","Wiskunde A","Wiskunde B","Rekenen"]
        let containsWiskundeOrRekenen = false;
        for (let profileProp in profile) {
            let section = profile[profileProp];
            for (let sectionProp in section) {
                let option = section[sectionProp];
                if (option.course && option.course.selected && option.course.selected.title) {
                    if (checkForCourses.includes(option.course.selected.title)) {
                        containsWiskundeOrRekenen = true;
                    }
                }
            }
        }
        $scope.showMathWarning = !containsWiskundeOrRekenen;
    }

    /**
     * Return true because beoogddiploma doens't have gradeList
     * @param formStep Current formStep
     * @returns {boolean}
     */
    $scope.checkUploadedFiles = function (formStep) {
        return true;
    }

    $scope.initTrajectOptions = function () {
        if ($scope.intake['vavoCollege'] && $scope.intake['educationType']) {
            var vavoCollege = encodeURIComponent($scope.intake['vavoCollege']);
            var education = encodeURIComponent($scope.intake['educationType']);
            let requestUrl = "";
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getTrajectOptions?vavoCollege=" + vavoCollege + "&year=" + $scope.intake['yearName']  + "&educationType=" + education;
            } else {
                requestUrl = "/.rest/intake/v1/getTrajectOptions?vavoCollege=" + vavoCollege + "&year=" + $scope.intake['yearName']  +"&educationType=" + education;
            }
            $http({
                url: requestUrl,
                method: "GET"

            }).then(function (response) {
                $scope.trajectOptions = {};
                if (response.data.trajectOptions) {
                    Object.keys(response.data.trajectOptions).forEach(function (key) {
                        $scope.trajectOptions[key] = response.data.trajectOptions[key];
                    });
                }
            });
        }
    };
    $scope.genName = function (id, name) {
        return id + ' ' + name;
    };

    filterCourseConfig = function (courseConfig) {
        if (typeof courseConfig == "string" || typeof courseConfig == "number") {
            return courseConfig
        }

        for (var key in courseConfig) {
            if (courseConfig.hasOwnProperty(key)) {
                if (key == 'course' || key == 'selected') {
                    delete courseConfig[key].gradeAlert
                    delete courseConfig[key].gradeAlertText
                }
                if (!courseConfig[key]) {
                    break;
                } else {
                    filterCourseConfig(courseConfig[key])
                }
            }
        }
        return courseConfig
    }

    $scope.updateSelectLabel = function (id) {
        const itemLabel = $("[id='" + id + "']").children('option:selected').attr('label')
        $scope.intakeProperties[id].label = itemLabel
    }

    $scope.saveForm = function (enrolmentId, returnLink, stepId) {
        $('#save-button-' + stepId).attr('disabled', 'disabled');
        $('#save-button-' + stepId).css('cursor', 'wait');
        $scope.printForm = false;
        setTimeout(function () {
            $scope.saveFormCalls(enrolmentId, returnLink, stepId);
        }, 100);
    };

    $scope.savePrintForm = function (enrolmentId, returnLink, stepId) {
        $('#save-button-' + stepId).attr('disabled', 'disabled');
        $('#save-button-' + stepId).css('cursor', 'wait');
        $scope.printForm = true;
        setTimeout(function () {
            $scope.saveFormCalls(enrolmentId, returnLink, stepId);
        }, 100);
    };

    $scope.returnToOverview = function (returnLink, enrolmentId) {
        window.location.href = returnLink + "?enrolmentId=" + enrolmentId;
    }

    const firstChoice = "eerstekeus"
    const secondChoice = "tweedekeus"
    const thirdChoice = "derdekeus"
    const dutchStudent = "nederlandstaligeLeerlingen"
    const foreignStudent = "anderstaligeLeerling"

    $scope.getCorrectCourseNotation = function (value) {
        switch (value) {
            case firstChoice:
                return "Eerste keus"
            case secondChoice:
                return "Tweede keus"
            case thirdChoice:
                return "Derde keus"
            case dutchStudent  :
                return "Ondersteuningsvak Nederlands"
            case foreignStudent  :
                return "Ondersteuningsvak Nederlands"
            default:
                return "Onbekend label"
        }
    }

    $scope.saveFormCalls = function (enrolmentId, returnLink, stepId, mailIntake) {
        //disable button and show loader.
        $('#endLoader').show();
        $('#endLoader').css('display', 'inline-block');
        $('#save-button-' + stepId).hide();
        $('#back-button-' + stepId).hide();
        $scope.submitForm = {};
        $scope.submitForm['uuid'] = "";
        $scope.submitForm['vavoCollege'] = $scope.intake["vavoCollege"];
        $scope.submitForm['formId'] = $scope.formId;
        let temp = filterCourseConfig($scope.courseConfig);
        $scope.submitForm['courseConfig'] = temp;
        $scope.submitForm['properties'] = [];

        $scope.submitForm['properties'].push(
            {
                "id": "enrolment",
                "value": enrolmentId,
                "label": "enrolment"
            });

        $.each($scope.intake, function (_key, _value) {
            var label = 'Onbekend label.';
            let value = _value;
            let id = _key
            if ($scope.intakeProperties && $scope.intakeProperties[_key]) {
                label = $scope.intakeProperties[_key].label;
            }

            if (_key === firstChoice || _key === secondChoice || _key === thirdChoice || _key === dutchStudent || _key === foreignStudent) {
                label = $scope.intakeProperties[_key].label;
                if (label) {
                    label = $scope.getCorrectCourseNotation(_key)

                } else {
                    value = undefined;
                }
            }

            $scope.submitForm['properties'].push(
                {
                    "id": id,
                    "value": value,
                    "label": label
                });
        });
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/save";
        } else {
            requestUrl = "/.rest/intake/v1/save";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            async: false,
            contentType: "application/json",
            data: JSON.stringify($scope.submitForm),
            success: function (response) {
                intakeId = response.uuid;
                if (!mailIntake && $scope.printForm === false){
                    window.location.href = returnLink + "?enrolmentId=" + enrolmentId;
                } else if ($scope.printForm === true) {
                    window.open(response.generatedPdf, '');
                    $scope.notifyFormDownload(stepId);
                }
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
            },
        });
        return enrolmentId
    };

    $scope.mailIntakeReport = function (enrolmentId, returnLink) {
        $scope.mailForm = {};
        $scope.mailForm["uuid"] = intakeId;
        var requestUrl = "/.rest/intake/v1/sendIntakeReport";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/sendIntakeReport";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            async: false,
            data: JSON.stringify($scope.mailForm),
            success: function (response) {
                console.log("Mail sent!");
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
            },
        });
        if ($scope.printForm === false) {
            window.location.href = returnLink + "?enrolmentId=" + enrolmentId;
        }
    }


    $scope.saveFormAndMailIntakeReport = function (enrolmentId, returnLink, stepId) {
        $('#sendReport').attr('disabled', 'disabled');
        $('#sendReport').css('cursor', 'wait');
        $scope.printForm = false;
        setTimeout(function () {
            let uuid = $scope.saveFormCalls(enrolmentId, returnLink, stepId, true);
            $scope.mailIntakeReport(uuid, returnLink)
        }, 100);

    }

    $scope.saveFormPrintAndMailIntakeReport = function (enrolmentId, returnLink, stepId) {
        $('#sendReport').attr('disabled', 'disabled');
        $('#sendReport').css('cursor', 'wait');
        $scope.printForm = true;
        setTimeout(function () {
            let uuid = $scope.saveFormCalls(enrolmentId, returnLink, stepId, true);
            $scope.mailIntakeReport(uuid, returnLink)
        }, 100);

    }

    $scope.notifyFormDownload = function (stepId) {
        $("#notificationContent-" + stepId).html("");
        $("#notificationContent-" + stepId).append();

        $("#downloadNotification-" + stepId).fadeIn(500);
        $("#downloadNotification-" + stepId).css('display', 'flex');
    }

    $scope.coronaChanged = function (enabled) {

    }

    $scope.initOptionalFields = function () {
        var elems = $('.optional-form h1');
        for (var i = 0; i < elems.length; i++) {
            var id = elems[i].getAttribute("for");

            //in optional fields mag je geen ; toevoegen
            //de split is omdat de waarde multivalue kan zijn, als in waarde;anderewaarde
            var valA = elems[i].getAttribute("option-a").split(";");
            var valB = elems[i].getAttribute("option-b").split(";");
            var valC = elems[i].getAttribute("option-c").split(";");
            var valD = elems[i].getAttribute("option-d").split(";");
            var valE = elems[i].getAttribute("option-e").split(";");
            var valF = elems[i].getAttribute("option-f").split(";");
            var valG = elems[i].getAttribute("option-g").split(";");
            var valH = elems[i].getAttribute("option-h").split(";");

            $scope.correspondingOptions[0][id] = valA.includes($scope.intake[id]);
            $scope.correspondingOptions[1][id] = valB.includes($scope.intake[id]);
            $scope.correspondingOptions[2][id] = valC.includes($scope.intake[id]);
            $scope.correspondingOptions[3][id] = valD.includes($scope.intake[id]);
            $scope.correspondingOptions[4][id] = valE.includes($scope.intake[id]);
            $scope.correspondingOptions[5][id] = valF.includes($scope.intake[id]);
            $scope.correspondingOptions[6][id] = valG.includes($scope.intake[id]);
            $scope.correspondingOptions[7][id] = valH.includes($scope.intake[id]);
        }
    }

    $scope.checkConditionalField = function (currentValue,
                                             correspondingList,
                                             ids,
                                             id) {
        correspondingList[0] = correspondingList[0] || [];
        correspondingList[1] = correspondingList[1] || [];
        correspondingList[2] = correspondingList[2] || [];
        correspondingList[3] = correspondingList[3] || [];
        correspondingList[4] = correspondingList[4] || [];
        correspondingList[5] = correspondingList[5] || [];
        correspondingList[6] = correspondingList[6] || [];
        correspondingList[7] = correspondingList[7] || [];

        for (var i = 0; i < correspondingList.length; i++) {
            correspondingList[i] = correspondingList[i] || [];
            var match = correspondingList[i].includes(currentValue);
            $scope.correspondingOptions[i][id] = match;
            if (ids[i] != "") {
                $("#" + ids[i] + " input, #" + ids[i] + " select, #" + ids[i] + " textarea").each(function () {
                    $(this).prop('required', match);
                });
            }
        }

        for (let fieldId of ids) {
            if($scope.intake[fieldId] && fieldId !== 'voSchool') {
                delete $scope.intake[fieldId];
            }
        }
    }

    $scope.getProfileOptions = function () {
        var college = $scope.intake["vavoCollege"];
        if (college == 0) {
            return;
        }
        var vavoCollege = encodeURIComponent(college);
        var education = 'none';
        if ($scope.intake['educationType']) {
            education = encodeURIComponent($scope.intake['educationType']);
        }
        var requestUrl = "";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/config/educationProfile?vavoCollege=" + vavoCollege + "&education=" + education;
        } else {
            requestUrl = "/.rest/enrolment/v1/config/educationProfile?vavoCollege=" + vavoCollege + "&education=" + education;
        }

        $http({
            url: requestUrl,
            method: "GET",

        }).then(function (response) {
            $scope.manipulateEducationProfile(response.data);
        });

    };

    $scope.calculateVoltijdDeeltijd = function () {
        if ($scope.automatedFulltimeParttime) {
            var count = 0.0;
            var countString = "";

            angular.forEach($scope.courseConfig, function (profile, profileName) {
                angular.forEach(profile, function (opties, stroomName) {
                    angular.forEach(opties, function (course, optieName) {
                        if ($scope.intake['graduation'] == "diploma") {
                            if (course["course"] && course["course"]["traject"] && course["course"]["selected"]) {

                                var hrs = course["course"]["selected"]["coursehours"];
                                var overrides = course["course"]["selected"]["coursehoursOverrides"];
                                var traject = course["course"]["traject"].toLowerCase();

                                var selectedTraject = $scope.trajectOptions[course["course"]["selected"]["track"]];

                                if (overrides && overrides[traject]) {
                                    hrs = overrides[traject];
                                }

                                for (var i in selectedTraject) {
                                    if (selectedTraject[i]["title"] === course["course"]["traject"]) {
                                        if (selectedTraject[i]["calculation"] === "true") {
                                            count += parseFloat(hrs);
                                            countString += "<div class='row'><p>" + course["course"]["label"] + ":</p><p class='hour-padding'>- " + parseFloat(hrs) + " uur </p></div>";
                                        }
                                    }
                                }
                            }
                        } else {
                            angular.forEach(course, function (realCourse, courseName) {
                                if (realCourse.checked) {
                                    count += parseFloat(realCourse["coursehours"]);
                                    countString += "<div class='row'><p>" + realCourse["label"] + ":</p><p class='hour-padding'>- " + parseFloat(realCourse["coursehours"]) + " uur </p></div>";
                                }
                            });
                        }
                    });


                });
            });

            if ($scope.intake["intakeVerslagNederlandsAnderstalig"] === 'Ja') {
                count = count + 2;
                let infoTekst = "check Extra Nederlands?"
                if ($scope.intakeProperties["intakeVerslagNederlandsAnderstalig"]!==undefined){
                    infoTekst = $scope.intakeProperties["intakeVerslagNederlandsAnderstalig"].label
                }
                countString += "<div class='row'><p>" + infoTekst + ":</p><p class='hour-padding'>- 2 uur </p></div>";
            }
            $scope.lesuren = count;
            $scope.lesurenUitleg = countString;
            if (count < $scope.fulltimeAmount) {
                $scope.intake["voltijdDeeltijd"] = "deeltijd";
            } else {
                $scope.intake["voltijdDeeltijd"] = "voltijd";
            }
            $scope.safeApply();
        }
    };

    $scope.safeApply = function(fn) {
        let phase = this.$root.$$phase;
        if(phase === '$apply' || phase === '$digest') {
            if(fn && (typeof(fn) === 'function')) {
                fn();
            }
        } else {
            this.$apply(fn);
        }
    };

    $scope.manipulateEducationProfile = function (data) {
        var filteredProfileOptions = [];
        if ($scope.intake['graduation'] == "diploma") {
            for (var _profileProp in data) {
                // skip loop if the property is from prototype
                if (!data.hasOwnProperty(_profileProp)) continue;
                var section = data[_profileProp];
                filteredProfileOptions.push(section);
                for (var _profile in section) {
                    if (!section.hasOwnProperty(_profile)) continue;
                    var profile = section[_profile];
                    if (profile.toLowerCase() == 'sectorloos' || profile.toLowerCase() == 'profielloos') {
                        delete data[_profileProp][_profile];
                        break;
                    }
                }
            }
        } else {
            for (var _profileProp in data) {
                // skip loop if the property is from prototype
                if (!data.hasOwnProperty(_profileProp)) continue;
                var section = data[_profileProp];
                filteredProfileOptions.push(section);
                for (var _profile in section) {
                    if (!section.hasOwnProperty(_profile)) continue;
                    var profile = section[_profile];
                    if (profile.toLowerCase() != 'sectorloos' && profile.toLowerCase() != 'profielloos') {
                        delete data[_profileProp][_profile];
                    }
                }
            }
        }

        $scope.profileOptions = data;
        $scope.setProfileOptions();
    };

    $scope.setProfileOptions = function () {
        if ($scope.intake['chosenProfileOption'] === undefined && $scope.intake['chosenProfileOptions'] !== undefined) {
            $scope.intake['chosenProfileOption'] = $scope.intake['chosenProfileOptions'];
            delete $scope.intake['chosenProfileOptions'];
        }
        chosenProfileOption = encodeURIComponent($scope.intake['chosenProfileOption']);
        var education = encodeURIComponent($scope.intake['educationType']);
        var vavoCollege = encodeURIComponent($scope.intake['vavoCollege']);
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/config/profileChoices?vavoCollege=" + vavoCollege + "&education=" + education + "&profileOption=" + chosenProfileOption;
        } else {
            requestUrl = "/.rest/enrolment/v1/config/profileChoices?vavoCollege=" + vavoCollege + "&education=" + education + "&profileOption=" + chosenProfileOption;
        }
        $http({
            url: requestUrl,
            method: "GET"

        }).then(function (response) {
            $scope.courseConfig = {};
            $scope.courseConfig[$scope.intake['chosenProfileOption']] = {};

            angular.forEach(response.data, function (profileOption, profileOptions) {
                angular.forEach(profileOption, function (section, sections) {
                    angular.forEach(section, function (options, _options) {
                        angular.forEach(options, function (option, _k) {
                            angular.forEach(option, function (courses, _courses) {
                                angular.forEach(courses, function (val, _key) {
                                    var matchedExistingChoice = false;
                                    var _selectedProfileCourse = null;
                                    angular.forEach(selectedProfileCourses, function (selectedProfileCourse) {
                                        if (selectedProfileCourse.id === val.id) {
                                            _selectedProfileCourse = selectedProfileCourse;
                                            matchedExistingChoice = true;
                                        }
                                    });
                                    //Always add the options and title, to preserve order
                                    if (!$scope.courseConfig[$scope.intake['chosenProfileOption']][section.title]) {
                                        $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title] = {};
                                    }
                                    if (option.title != undefined && option.title != null) {
                                        if (!$scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]) {
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title] = {};
                                        }
                                    }
                                    if ((courses.length === 1 && val && val.follow) || (courses.length > 1 && matchedExistingChoice)) {
                                        if ($scope.intake['graduation'] == "diploma") {
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'] = {};
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].label = val.title;
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].id = val.id;
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].gradeAlert = val.gradeAlert;
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].gradeAlertText = val.gradeAlertText;
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].selected = val;
                                            if (_selectedProfileCourse) {
                                                $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].grade = _selectedProfileCourse.grade;
                                                $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].traject = _selectedProfileCourse.traject;

                                                $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].ce = _selectedProfileCourse.ce;
                                                $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].se = _selectedProfileCourse.se;
                                                $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title]['course'].ceCorona = _selectedProfileCourse.ceCorona;

                                            }
                                        } else {
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title][val.title] = {};
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title][val.title].label = val.title;
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title][val.title].id = val.id;
                                            $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title][val.title].selected = val;
                                            if (_selectedProfileCourse) {
                                                $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title][val.title].checked = _selectedProfileCourse.checked;
                                            } else {
                                                $scope.courseConfig[$scope.intake['chosenProfileOption']][section.title][option.title][val.title].checked = false;
                                            }
                                        }
                                    }
                                    if (val) {
                                        if (val.follow == 'N') {
                                            //NOT
                                            val.displayLabel = val.title + '***';
                                        } else if (val.follow == 'A') {
                                            //EVENING
                                            val.displayLabel = val.title + '**';
                                        } else if (val.follow == 'D') {
                                            //DAY
                                            val.displayLabel = val.title + '*';
                                        } else {
                                            val.displayLabel = val.title;
                                        }
                                    }
                                });
                            });
                        });
                    });
                });
            });

            $scope.profileChoices = response.data;
        });
    };

    $scope.capitalize = function (id) {
        if ($scope.intake[id]) {
            var words = $scope.intake[id].split(" ");
            var uppercaseWord = "";
            for (var i = 0; i < words.length; i++) {
                if (words[i].length >= 1) {
                    uppercaseWord += words[i].substring(0, 1).toUpperCase() + words[i].substring(1).toLowerCase() + " ";
                }
            }
            $scope.intake[id] = uppercaseWord.trim();
        }
    };

    $scope.showWhenTrue = function(value) {
        if(value === "false" || value === "Nee" || !value) {
            return false;
        } else {
            return true;
        }
    }

    $scope.containsGrade = function (list, grade) {
        if (list == null) {
            return false
        }
        return list.includes(grade)
    }

    $scope.viewOnlyOverrideValue = function (value, truevalue, falsevalue) {
        if (truevalue !== null && truevalue !== "" && value === "true") {
            return truevalue;
        } else if (falsevalue !== "" && falsevalue != null && value === "false") {
            return falsevalue;
        } else {
            return value;
        }
    }

    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 20; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    function getSelectedProfileCourses(courseConfig) {
        var chosenProfileOption = $scope.intake['chosenProfileOption'];

        $scope.courseConfig = {};
        $scope.courseConfig[chosenProfileOption] = {};


        var retrievedProfileSections = courseConfig[chosenProfileOption];
        var selectedProfileCourses = [];

        angular.forEach(retrievedProfileSections, function (profileSection) {
            var retrievedProfileCourses = profileSection;
            angular.forEach(retrievedProfileCourses, function (course) {
                selectedProfileCourses.push(course);
            });
        });

        return selectedProfileCourses;
    }

    function getOptionTitle(courseId) {

        if (!$scope.originalProfileChoices.length) {
            var chosenProfileOption = encodeURIComponent($scope.intake['chosenProfileOption']);
            var education = encodeURIComponent($scope.intake['educationType']);
            var vavoCollege = encodeURIComponent($scope.intake['vavoCollege']);

            var requestUrl = '';
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/config/profileChoices?vavoCollege=" + vavoCollege + "&education=" + education + "&profileOption=" + chosenProfileOption;
            } else {
                requestUrl = "/.rest/enrolment/v1/config/profileChoices?vavoCollege=" + vavoCollege + "&education=" + education + "&profileOption=" + chosenProfileOption;
            }
            return $http({
                url: requestUrl,
                method: "GET",

            });
        }
    }
}];


/*angular.forEach(courseConfig, function(profileOption , profileOptionTitle) {
    console.log("console.log(profileOptionTitle);");
    console.log(profileOptionTitle);
    if (!$scope.courseConfig[profileOptionTitle]) {
        $scope.courseConfig[profileOptionTitle] = {};
    }
    angular.forEach(profileOption, function(section, sectionTitle) {
        if (!$scope.courseConfig[profileOptionTitle][sectionTitle]) {
            $scope.courseConfig[profileOptionTitle][sectionTitle] = {};
        }
        angular.forEach(section, function(course, courseId) {
            if (!$scope.courseConfig[profileOptionTitle][sectionTitle]['course']) {
                $scope.courseConfig[profileOptionTitle][sectionTitle]['course'] = {};
            }
            console.log('course');
            console.log(course);
            console.log('courseId');
            console.log(courseId);

            $scope.courseConfig[profileOptionTitle][sectionTitle]['course'].label = "Algemene natuurwetenschappen***";// course.label + "*";
        });
    });
});*/



},{}],46:[function(require,module,exports){
module.exports = ['$scope', '$attrs', 'courseConfigService', function ($scope, $attrs, courseConfigService) {

    $scope.showGrades = !($attrs.courseShowGrades === 'false');

    function updateCourseConfig() {
        courseConfigService.update($scope.$parent.profileChoice.title, $scope.formOption.title, $scope.state);
    }


    $scope.state = {
        course: null,
        follow: false,
        grade: null,
        disable: false
    };

    $scope.followMandatory = function () {
        if ($scope.state.course.mandatoryGrades != null) {
            if ($scope.state.grade != null) {
                if ($scope.state.course.mandatoryGrades.includes($scope.state.grade)) {
                    $scope.state.follow = true;
                    updateCourseConfig();
                    return true;
                }
            }
        }
        return false;
    };


    $scope.getCourses = function () {
        return $scope.formOption.courses;
    };


    if ($scope.formOption.courses.length === 1) {
        $scope.state.course = $scope.getCourses()[0];
        updateCourseConfig();
    }

    // $scope.debug = function() {
    //     console.log($scope.formOption.courses);
    // }

    /**
     * Custom rules for Math when choosing a subject
     */
    $scope.checkMath = function () {
        if ($scope.$parent.$parent.$parent.intake.educationType === "HAVO") {
            $scope.checkMathHavo()
        } else if ($scope.$parent.$parent.$parent.intake.educationType === "VMBO") {
            $scope.checkMathVmbo()
        }
    }

    $scope.selectFieldsHasMaths = function () {
        for (let i = 0; i < 8; i++) {
            try {
                let select = angular.element(document.getElementById('select' + i)).scope();
                if (select !== undefined && select.state.course !== null) {
                    if (select.state.course['title'].includes("Wiskunde")) {
                        return true;
                    }
                }
            } catch (e) {
                console.log(e.message)
            }
        }
        return false;
    }


    $scope.checkMathHavo = function () {
        let freeChoice0 = angular.element(document.getElementById('freeChoice0')).scope();
        let freeChoice1 = angular.element(document.getElementById('freeChoice1')).scope();
        //check if the required field isn't null and doesn't contain Wiskunde
        if (freeChoice0.state.course !== undefined && freeChoice0.state.course !== null && !freeChoice0.state.course['title'].includes("Wiskunde") &&
            !$scope.selectFieldsHasMaths()) {
            freeChoice1.setMathCourse();
        } else {
            //Check if the input is disabled and if the require choice is null
            if (freeChoice1.state.disable === true ||
                (freeChoice0.state.course === null && freeChoice1.state.disable === true)) {
                freeChoice1.resetMathCourse();
            }
        }
    }

    $scope.checkMathVmbo = function () {
        let freeChoice0 = angular.element(document.getElementById('freeChoice0')).scope();
        let freeChoice1 = angular.element(document.getElementById('freeChoice1')).scope();
        let freeChoice2 = angular.element(document.getElementById('freeChoice2')).scope();
        //check if the required fields aren't null and don't contain Wiskunde
        if ((freeChoice0.state.course !== undefined && freeChoice0.state.course !== null &&
                !freeChoice0.state.course['title'].includes("Wiskunde")) &&
            (freeChoice1.state.course !== undefined && freeChoice1.state.course !== null &&
                !freeChoice1.state.course['title'].includes("Wiskunde")) && !$scope.selectFieldsHasMaths()) {
            freeChoice2.setMathCourse();
        } else {
            //Check if the input is disabled and if the require choices are null
            if (freeChoice2.state.disable === true ||
                (freeChoice0.state.course === null && freeChoice2.state.disable === true) &&
                (freeChoice1.state.course === null && freeChoice2.state.disable === true)) {
                freeChoice2.resetMathCourse();
            }
        }
    }

    $scope.setMathCourse = function () {
        if ($scope.getMathIndex() !== null) {
            this.state.course = this.getCourses()[$scope.getMathIndex()]
            this.state.disable = true;
            this.state.follow = true;
            updateCourseConfig();

        }
    }
    $scope.resetMathCourse = function () {
        this.state.course = null;
        this.state.disable = false;
        this.state.follow = false;
        updateCourseConfig();
    }

    $scope.getMathIndex = function () {
        for (let i = 0; i < $scope.getCourses().length; i++) {
            if ($scope.getCourses()[i].title.toLowerCase() === "rekenen") {
                return i;
            }
        }
        return null;
    }

    $scope.getId = function () {
        if ($scope.$parent.profileChoice.title === "Vrije deel") {
            return "freeChoice"
        } else {
            return "select"
        }
    };
    /**
     * End Custom rules for Math when choosing a subject
     */

    $scope.isRequiredAddon = function () {
        if ($scope.showGrades === false) {
            return false;
        }
        var required = ($scope.formOption.required === true),
            follow = $scope.state.follow,
            grade = $scope.state.grade;
        if (required) {
            return ((!follow) && (grade === undefined || grade === null || 0 === grade.length));
        } else {
            if ($scope.state.course !== null && $scope.state.course !== '') {
                return ((!follow) && (grade === undefined || grade === null || 0 === grade.length));
            }
            return false;
        }
    };


    $scope.$watch('state', function (newState, oldState) {
        if (oldState.course === null && !newState.disable || oldState.course && newState.course && newState.course.id !== oldState.course.id) {
            $scope.state.follow = false;
            $scope.state.grade = null;
        }
        updateCourseConfig();
    }, true);

    $scope.getExceptionIDs = courseConfigService.getExceptionIDs;

}
]
;

},{}],47:[function(require,module,exports){
module.exports = ['$scope', '$http', function ($scope, $http) {

    $scope.intakeLocatie = "";
    $scope.intakeDate = "";
    $scope.intakeTime = "";
    $scope.intakeRDate = "";
    $scope.intakeRTime = "";
    $scope.intakeTimeInit = "";
    $scope.intakeDateInit = "";
    $scope.mailAdres = "";
    $scope.status = "";
    $scope.enrolmentId = "";
    $scope.appointments = "";
    $scope.appointmentHasTimeslot = true;
    $scope.mailTemplate = "";
    $scope.intakeDates = [];
    $scope.intakeTimeSlots = [];
    $scope.intakeRutteTimeSlots = [];
    $scope.previousRemarksList = [];
    $scope.appointmentSelected = false;
    $scope.currentSelectedTime = "";
    $scope.currentSelectedClass = "";
    $scope.currentSelectedRutteClass = "";
    $scope.currentSelectedRutteSlot = "";
    $scope.special_intake = "";
    $scope.short_intake = "";
    $scope.uitbesteed = "";
    $scope.rutteGesprekAfgerond = "";
    $scope.appHistory = [];
    $scope.statusList = [];
    $scope.wachtmapStatusList = [];
    $scope.statusListAfspraken = [];
    $scope.statusListAfsprakenList = "";
    $scope.vavoCollege = "";
    $scope.remarks = "";
    $scope.appStatus = "";
    $scope.newRemarkUser = "";
    $scope.isRemarkEditing = false;
    $scope.selectedRemark = "";
    $scope.selectedRemarkText = "";
    $scope.showDeleteRemarkConfirmation = false;
    $scope.unavailability = false;
    $scope.unavailableFrom = "";
    $scope.unavailableTo = "";
    $scope.unavailable = false;
    $scope.custom = false;
    $scope.bdfMail = false;
    $scope.subject = "";
    $scope.mailText = "";
    $scope.formId = "";
    $scope.dateLoading;
    $scope.dateLoadingText = "Maak een Keuze";
    $scope.sortedDateList = []
    $scope.appointmentID = "00"
    $scope.appointmentData = {ID: "", date: "", time: "", name: "" , isFromGraphicalAppointmentModule:false}

    $('#mailOk').css('display', 'none');

    $scope.$watch('appointmentID', function (newValue, oldValue) {
        console.log("appointmentID")
        console.log(newValue)
        $scope.appointmentData.ID = newValue
    })

    $scope.beoogddiplomaformulier = function (enrolmentId, url) {
        window.location.href = url + "?enrolmentId=" + enrolmentId;
    };
    $scope.uploadFilesAndGetFormId = function (inputId, formId) {
        if (formId == "") {
            formId = makeId();
        }
        $scope.files['formId'] = formId;
        $scope.formId = formId;
        $scope.uploadFiles(inputId);
    };

    $("#wachtmapDatum").datepicker({
        changeMonth: true, changeYear: true, yearRange: "-1:+1", dateFormat: "dd/mm/yy"
    });

    $scope.files = {};
    $scope.files['files'] = [];

    $scope.back = function () {
        window.history.back();
    }

    $scope.save = function () {
        this.save("no");
    }


    function makeId() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 20; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    $scope.moveFile = function (path, index) {

        if (confirm("Weet je zeker dat je dit bestand wil verwijderen?")) {
            let requestUrl = '';
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/removeFile?path=" + path;
            } else {
                requestUrl = "/.rest/enrolment/v1/removeFile?path=" + path;
            }
            $.ajax({
                url: requestUrl,
                type: "post",
                contentType: "application/json",
                data: JSON.stringify($scope.submitForm),
                success: function (res) {
                    document.getElementById("file" + index).style.display = 'none'
                },
                error: function (error) {
                    console.error("The following error occurred: " + JSON.stringify(error));
                },
            });
        }

    }

    $scope.save = function (isFromMail) {
        $scope.showDeleteRemarkConfirmation = false;
        $scope.isRemarkEditing = false;
        if (isFromMail == undefined) isFromMail = "no";
        var formValid = document.forms["form-editEnrolment"].checkValidity();
        if (!formValid) {
            return formValid;
        }
        $('#save').attr('disabled', 'disabled');
        $('#save').css('cursor', 'wait');
        setTimeout(function () {
            $('#save').removeAttr('disabled');
            $('#save').css('cursor', 'pointer');
        }, 1000);
        var appointment = {};

        if ($scope.intakeTime === "") {
            $scope.intakeDate = $scope.intakeDateInit;
            $scope.intakeTime = $scope.intakeTimeInit;
            $scope.intakeName = $scope.intakeNameInit;
        } else {
            $scope.intakeDateInit = $scope.intakeDate;
            $scope.intakeTimeInit = $scope.intakeTime;
            $scope.intakeNameInit = $scope.intakeName;
        }
        appointment.addDate = $scope.intakeDate;
        appointment.addTime = $scope.intakeTime;
        appointment.addName = $scope.intakeName;
        if ($scope.uitbesteed === "true") {
            appointment.addRDate = $scope.intakeRDate;
            appointment.addRTime = $scope.intakeRTime;
        } else {
            appointment.addRDate = null;
            appointment.addRTime = null;
        }
        appointment.uuid = $scope.enrolmentId;
        appointment.isPrinted = $scope.isPrinted;
        appointment.status = $scope.status;
        if(typeof $scope.newRemark !== 'undefined') {
            appointment.remarks = $scope.newRemark.replaceAll("<br/>", "").replaceAll("'", "`").replaceAll('"', '”');
        }
        appointment.remarksUser = $scope.newRemarkUser;
        appointment.location = $scope.intakeLocatie;
        appointment.mailAdres = $scope.mailAdres;
        appointment.isSeptembertraject = $scope.septembertraject;
        appointment.admissionTestsAllDone = $scope.admissionTestsAllDone;
        appointment.admissionTestsCalledStudent = $scope.admissionTestsCalledStudent;
        appointment.isTopsport = $scope.topsport;
        appointment.isSpecialIntake = $scope.special_intake;
        appointment.isShortIntake = $scope.short_intake;
        appointment.rutteGesprekAfgerond = $scope.rutteGesprekAfgerond;
        appointment.isSchakelleerling = $scope.schakelleerling;
        appointment.isOwnStudent = $scope.ownStudent;
        appointment.meetingLink = $scope.meetingLink;
        appointment.instaptoets = $scope.instaptoets;
        appointment.wachtmapDatum = $scope.wachtmapDatum

        if ($scope.appointmentData.isFromGraphicalAppointmentModule){
            appointment.isFromGraphicalAppointmentModule="true"
        } else {
            appointment.isFromGraphicalAppointmentModule="false"
        }

        if ($scope.appointmentData.ID !== undefined &&
            $scope.appointmentData.ID.length > 1) {
            appointment.appointmentID = $scope.appointmentData.ID
            appointment.addDate = $scope.appointmentData.date;
            appointment.addTime = $scope.appointmentData.time;
            appointment.addName = $scope.appointmentData.name;
        }

        appointment.isFromMail = isFromMail;
        appointment.year = $scope.year;
        var requestUrlAppointment = '';
        if (location.hostname === "localhost") {
            requestUrlAppointment = "/vavo-intake-webapp/.rest/enrolment/v1/updateAppointment";
        } else {
            requestUrlAppointment = "/.rest/enrolment/v1/updateAppointment";
        }

        $.ajax({
            url: requestUrlAppointment,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(appointment),
            success: function (response) {
                $scope.getRemarks();
                $scope.getAppHistory();
                $scope.checkAppointments();
            },
            error: function (error) {
                console.error("The following error occurred: " + error);
            },
        })
        if ($scope.formId !== "") {
            $scope.files['vavoCollege'] = $scope.vavoCollege;
            var requestUrlFiles = '';
            if (location.hostname === "localhost") {
                requestUrlFiles = "/vavo-intake-webapp/.rest/enrolment/v1/uploadFiles";
            } else {
                requestUrlFiles = "/.rest/enrolment/v1/uploadFiles";
            }

            $.ajax({
                url: requestUrlFiles,
                type: "post",
                contentType: "application/json",
                data: JSON.stringify($scope.files),
                success: function (response) {
                    var requestUrl = '';
                    $scope.submitForm = {};
                    $scope.submitForm['uuid'] = $scope.enrolmentId;
                    $scope.submitForm['formId'] = $scope.formId;
                    if (location.hostname === "localhost") {
                        requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/updateFilesInEnrolment";
                    } else {
                        requestUrl = "/.rest/enrolment/v1/updateFilesInEnrolment";
                    }

                    $.ajax({
                        url: requestUrl,
                        type: "post",
                        contentType: "application/json",
                        data: JSON.stringify($scope.submitForm),
                        success: function (ajaxresponse) {
                            location.reload();
                        },
                        error: function (error) {
                            console.error("The following error occurred: " + JSON.stringify(error));
                        },
                    });
                },
                error: function (error) {
                    console.error("The following error occurred: " + error);
                },
            });

        }
    }

    $scope.getRemarks = function () {
        var getRemarks = {};
        getRemarks.uuid = $scope.enrolmentId;
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getRemarks";
        } else {
            requestUrl = "/.rest/intake/v1/getRemarks";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(getRemarks),
            success: function (response) {
                $scope.previousRemarks = response.remarks;
                $scope.previousRemarksList = response.remarks.split("<br/>");
                $scope.newRemark = "";
                $scope.$apply();
            },
            error: function (error) {
                console.error("The following error occurred: " + error);
            },
        })
    }

    $scope.deleteRemarkConfirmation = function (remark) {
        $scope.isRemarkEditing = false;
        $scope.selectedRemarkText = "";
        $scope.selectedRemark = remark;
        $scope.showDeleteRemarkConfirmation = true;
    }

    $scope.cancelDeleteRemark = function () {
        $scope.selectedRemark = "";
        $scope.showDeleteRemarkConfirmation = false;
    }

    $scope.deleteRemark = function (remark) {
        $scope.showDeleteRemarkConfirmation = false;
        let index = $scope.previousRemarksList.indexOf(remark);
        if (index !== -1) {
            $scope.previousRemarksList.splice(index, 1);
        }
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/updateRemarks";
        } else {
            requestUrl = "/.rest/intake/v1/updateRemarks";
        }
        var remarks = {}
        remarks.remark = $scope.previousRemarksList.join("<br/>");
        remarks.uuid = $scope.enrolmentId;

        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(remarks),
            success: function (response) {
                $scope.previousRemarks = response.remarks;
                $scope.previousRemarksList = response.remarks.split("<br/>");
                $scope.$apply();
            },
            error: function (error) {
                console.error("The following error occurred: " + JSON.stringify(error));
            },
        })
    }

    $scope.editRemark = function (remark) {
        $scope.showDeleteRemarkConfirmation = false;
        $scope.selectedRemark = remark;
        $scope.selectedRemarkText = remark.split("</b>")[1].trim();
        $scope.isRemarkEditing = true;
        // (#editRemarkModal)
        // $("#editRemarkModal").html("");
        // $("#editRemarkModal").append(response.html);
        // $scope.bdfMail = true;

    }

    $scope.cancelEditRemark = function () {
        $scope.isRemarkEditing = false;
        $scope.selectedRemark = "";
        $scope.selectedRemarkText = "";
    }

    $scope.saveEditRemark = function (oldRemark, newRemarkText) {
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/addRemark";
        } else {
            requestUrl = "/.rest/intake/v1/addRemark";
        }
        var remarks = {}
        let index = $scope.previousRemarksList.indexOf(oldRemark);
        if (index !== -1) {
            $scope.previousRemarksList.splice(index, 1);
        }
        remarks.newRemarkString = $scope.previousRemarksList.join("<br/>");
        remarks.remark = newRemarkText.replaceAll("<br/>", "").replaceAll("'","`").replaceAll('"', '”');
        remarks.uuid = $scope.enrolmentId;
        remarks.remarkUser = $scope.newRemarkUser;

        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(remarks),
            success: function (response) {
                $scope.previousRemarks = response.remarks;
                $scope.previousRemarksList = response.remarks.split("<br/>");
                $scope.$apply();
            },
            error: function (error) {
                console.error("The following error occurred: " + JSON.stringify(error));
            },
        })
        $scope.isRemarkEditing = false;
    }

    $scope.getAppHistory = function () {
        var getAppHistory = {};
        getAppHistory.uuid = $scope.enrolmentId;
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getAppHistory";
        } else {
            requestUrl = "/.rest/intake/v1/getAppHistory";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(getAppHistory),
            success: function (response) {
                var hist = response.history;
                $scope.appHistory = hist.slice(0, 5);
                $scope.$apply();
            },
            error: function (error) {
                console.error("The following error occurred: " + error);
            },
        })
    }

    $scope.changeStatus = function () {
        $scope.checkBeforeStatusChange();

        $scope.appointmentData.status = $scope.status

        $scope.fetchDates();
        if ($scope.uitbesteed === "true") {
            $scope.fetchRutteDates();
        }
        $scope.checkAvailability();
        $scope.checkAppointments();

    }

    $scope.checkBeforeStatusChange = function (){
        $scope.checkAppointmentFromModal($scope.appointmentID,$scope.presentOptionToDelete)
    }


    $scope.presentOptionToDelete = function (response){
        if (!response) return;
        let modal = document.getElementById("myModal");
        let spanClose = document.getElementsByClassName("statusChangeModal-close")[0];
        let spanDelete = document.getElementsByClassName("statusChangeModal-delete")[0];
        spanClose.onclick = function() {
            modal.style.display = "none";
        }
        spanDelete.onclick = function() {
            $scope.deleteAppointmentFromModal($scope.appointmentID)
            modal.style.display = "none";
        }
        modal.style.display = "block";
    }
    function baseURL() {
        let requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl += "/vavo-intake-webapp";
        }
        return requestUrl + "/.rest/enrolment/v1/";
    }

    $scope.checkAppointmentFromModal = function (id, setVal) {
        let requestUrl = baseURL() + "appointments/checkAppointmentIsInFuture";
        requestUrl += "?id=" + id ;
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            setVal(response.data);
        });
    }

    $scope.deleteAppointmentFromModal = function (id) {
        let requestUrl = baseURL() + "appointments/deleteAppointment";
        requestUrl += "?id=" + id ;
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
        });
    }

    $scope.changeDate = function () {
        $scope.intakeTime = "";
        $scope.currentSelectedTime = "";
        $scope.appointmentSelected = false;
        let selectedSlots = document.getElementsByClassName("selected-slot");
        if (selectedSlots.length > 0) {
            selectedSlots[0].classList.remove("selected-slot");
        }
        $scope.checkAppointments();
    }

    $scope.checkAppointments = function () {
        $scope.dateLoading = "loading";
        $scope.dateLoadingText = "Maak een Keuze (loading)";

        if ($scope.intakeTime && $scope.intakeDate && $scope.status) {
            var requestUrl = '';
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/config/amountOfAppointments";
            } else {
                requestUrl = "/.rest/enrolment/v1/config/amountOfAppointments";
            }
            requestUrl += "?year=" + $scope.year + "&vavoCollege=" + $scope.vavoCollege + "&date=" + $scope.intakeDate + "&time=" + $scope.intakeTime + "&status=" + $scope.status;
            $http({
                url: requestUrl, method: "GET",
            }).then(function (response) {
                $scope.appointments = response.data;
                $scope.dateLoading = "ready";
                $scope.dateLoadingText = "Maak een Keuze";

            })
        } else {
            $scope.appointments = "";
            $scope.dateLoading = "ready";
            $scope.dateLoadingText = "Maak een Keuze";
        }
        $scope.checkAppointmentsForAllStatuses();
    }


    $scope.checkAppointmentsForAllStatuses = function () {
        if ($scope.intakeTime && $scope.intakeDate) {
            var requestUrlBase = '';
            if (location.hostname === "localhost") {
                requestUrlBase = "/vavo-intake-webapp/.rest/enrolment/v1/config/amountOfAppointments";
            } else {
                requestUrlBase = "/.rest/enrolment/v1/config/amountOfAppointments";
            }

            for (let statusLocal in $scope.statusList) {

                let requestUrl = requestUrlBase + "?year=" + $scope.year + "&vavoCollege=" + $scope.vavoCollege + "&date=" + $scope.intakeDate + "&time=" + $scope.intakeTime + "&status=" + statusLocal;
                $scope.getstatus(requestUrl, statusLocal)
            }

        } else {
            for (let statusLocal in $scope.statusList) {
                $scope.statusListAfspraken[statusLocal] = "";
            }
            $scope.CreateOverviewAppointments();
        }
    }

    $scope.getstatus = function (requestUrl, thisStatus) {

        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            if (response.data[0] != 0 || response.data[1] != 0) {

                $scope.statusListAfspraken[thisStatus] = $scope.statusList[thisStatus] + " : " + response.data[1] + " dit uur, " + response.data[0] + " deze dag"
            } else {
                $scope.statusListAfspraken[thisStatus] = "";
            }
            $scope.CreateOverviewAppointments();
        })
    }


    $scope.CreateOverviewAppointments = function () {
        let myString = "";
        if ($scope.appointmentHasTimeslot) {
            for (let statusLocal in $scope.statusList) {
                if ($scope.statusListAfspraken[statusLocal] !== undefined) {
                    if (myString !== "" && $scope.statusListAfspraken[statusLocal] !== "") myString += " / ";
                    myString += $scope.statusListAfspraken[statusLocal]
                }
            }
        } else {
            myString = "*** afspraak zonder tijdslot *** planning informatie niet beschikbaar ***"
        }
        $scope.statusListAfsprakenList = myString;

    }


    $scope.initLocation = function (location) {
        $scope.intakeLocatie = location;
        $scope.fetchDates();
        $scope.fetchRutteDates();
    }

    $scope.getNumberSlots = function (num) {
        if (num === '0') return new Array(8);
        let number = parseInt(num);
        return new Array(number);
    }

    $scope.isDisabledRow = function (id) {
        if (id === -1) return true;
        let element = document.getElementById("rutte-" + id);
        if (element != null) {
            return element.classList.contains("disabledRutteSlot") || element.classList.contains("used-" + id) || element.classList.contains("myRAppointmentSlot");
        }
        return false;
    }

    $scope.clickTimeSlots = function (data, time, id) {
        let current = $scope.intakeTimeSlots[$scope.intakeDate][time];
        let currentElement = document.getElementById("row-" + time);
        let usedSlots = parseInt(current['usedSlots']);
        if (usedSlots < 12 && !currentElement.classList.contains("disabled-row")) {
            if ($scope.currentSelectedTime !== time && $scope.currentSelectedTime !== "") {
                if (document.getElementsByClassName("selected-slot").length > 0) {
                    document.getElementsByClassName("selected-slot")[0].classList.remove("selected-slot");
                }

                if ($scope.uitbesteed === 'true' && $scope.rutteGesprekAfgerond === 'Nee') {
                    let currentSelectedRutteTime = document.querySelector(".selected-rutte-slot").value;
                    let currentRutteUsedSlots = $scope.intakeRutteTimeSlots[$scope.intakeDate][currentSelectedRutteTime]['usedSlots'];
                    currentRutteUsedSlots = (parseInt(currentRutteUsedSlots) - 1).toString();
                    //Remove selected class from rutte agenda
                    document.getElementById($scope.currentSelectedRutteClass).classList.remove("selected-rutte-slot");
                }

                $scope.appointmentSelected = false;
            }
            if (!$scope.appointmentSelected && $scope.currentSelectedTime !== time) {
                let selectedClass = "row-" + time;
                //Add selected class to slot of normal agenda
                document.getElementById(selectedClass).children["slot-" + usedSlots].classList.add("selected-slot");
                if ($scope.uitbesteed === 'true' && $scope.rutteGesprekAfgerond === 'Nee') {
                    let selectedRutteClass = "rutte-" + (id - 1),
                        selectedRutteSlot = document.getElementById(selectedRutteClass),
                        selectedRutteUsedSlots = parseInt($scope.intakeRutteTimeSlots[$scope.intakeDate][selectedRutteSlot.value]['usedSlots']);
                    //Add 1 of the rutte slots used
                    selectedRutteSlot.classList.add("selected-rutte-slot");
                    $scope.currentSelectedRutteClass = selectedRutteClass;
                    $scope.currentSelectedRutteSlot = selectedRutteSlot;
                    //Set intake date & time for Rutte student
                    $scope.intakeRDate = $scope.intakeDate;
                    $scope.intakeRTime = selectedRutteSlot.value;
                }
                $scope.currentSelectedClass = selectedClass;
                $scope.intakeTime = time;
                $scope.appointmentSelected = true;
                $scope.currentSelectedTime = time;
            }
        }
    }

    $scope.checkIfTimesContainSlots = function (array) {
        for (let element in array) {
            if (array[element]['slots'] && element !== "1:00") {
                return true;
            }
        }
        return false;
    }

    $scope.fetchDates = function () {

        $scope.dateLoading = "loading";
        $scope.dateLoadingText = "Maak een Keuze (loading)";

        if ($scope.status && $scope.intakeLocatie) {
            var requestUrl = '';
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/config/appointmentDates";
            } else {
                requestUrl = "/.rest/enrolment/v1/config/appointmentDates";
            }
            let newAppointmentTable = document.getElementById("appointment-new");
            if (newAppointmentTable !== null) {
                requestUrl += "?vavoCollege=" + $scope.vavoCollege + "&location=" + $scope.intakeLocatie + "&year=" + $scope.year + "&status=" + $scope.status + "&variant=" + "2";
            } else {
                requestUrl += "?vavoCollege=" + $scope.vavoCollege + "&location=" + $scope.intakeLocatie + "&year=" + $scope.year + "&status=" + $scope.status + "&variant=" + "null";
            }
            $http({
                url: requestUrl, method: "GET",
            }).then(function (response) {
                $scope.intakeDates = {};
                $scope.intakeTimeSlots = {};
                $scope.sortedDateList = [];
                var today = new Date();
                today.setHours(0, 0, 0, 0);
                let hasDate = $scope.hasKey(response.data, $scope.intakeDate);
                if (hasDate || $scope.intakeDate === "") {
                    $scope.appointmentHasTimeslot = true;
                } else {
                    $scope.appointmentHasTimeslot = false;
                }
                // Add only dates that are in the future.
                Object.keys(response.data).forEach(function (date) {
                    var comparedate = $scope.getJSDateFromText(date);
                    var intakeDate = $scope.getJSDateFromText($scope.intakeDate);
                    if (!hasDate && comparedate > intakeDate && $scope.appStatus === $scope.status) {
                        $scope.intakeDates[$scope.intakeDate] = [$scope.intakeTimeInit];
                        $scope.intakeTimeSlots[$scope.intakeDate] = [$scope.intakeTimeInit];
                    }
                    if (comparedate >= today) {
                        $scope.intakeDates[date] = (response.data[date]);
                        $scope.intakeTimeSlots[date] = (response.data[date]);
                    }

                    if (intakeDate < today && $scope.intakeDates[$scope.intakeDate] == null) {
                        $scope.intakeDates[$scope.intakeDate] = response.data[date];
                        $scope.intakeTimeSlots[$scope.intakeDate] = response.data[date];
                    }
                });

                angular.forEach($scope.intakeDates, function (value, key) {
                    $scope.sortedDateList.push(key)
                    if (key === $scope.intakeDateInit) {
                        let hasValue = false;
                        Object.values($scope.intakeDates[key]).forEach(function (valueL) {
                            if (valueL === $scope.intakeTimeInit) {
                                hasValue = true;
                            }
                        })

                        if (!hasValue && $scope.appStatus === $scope.status) {
                            $scope.intakeDates[key].push($scope.intakeTimeInit)
                            $scope.appointmentHasTimeslot = false;
                        }
                    }
                })

                $scope.sortedDateList.sort(function (newDate, oldDate) {
                    return $scope.getJSDateFromText(newDate) - $scope.getJSDateFromText(oldDate)
                })
                $scope.CreateOverviewAppointments();

                $scope.dateLoading = "ready";
                $scope.dateLoadingText = "Maak een Keuze";

            });
        }
    };

    $scope.fetchRutteDates = function () {
        if ($scope.status && $scope.intakeLocatie) {
            let requestUrl = '';
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/config/appointmentDates";
            } else {
                requestUrl = "/.rest/enrolment/v1/config/appointmentDates";
            }
            requestUrl += "?vavoCollege=" + $scope.vavoCollege + "&location=" + $scope.intakeLocatie + "&year=" + $scope.year + "&status=r&variant=2";

            $http({
                url: requestUrl, method: "GET",
            }).then(function (response) {
                $scope.intakeRutteTimeSlots = {};
                let today = new Date();
                today.setHours(0, 0, 0, 0);
                let hasDate = $scope.hasKey(response.data, $scope.intakeDate);
                $scope.appointmentHasTimeslot = hasDate || $scope.intakeDate === "";
                Object.keys(response.data).forEach(function (date) {
                    let compareDate = $scope.getJSDateFromText(date);
                    let intakeDate = $scope.getJSDateFromText($scope.intakeDate);
                    if (!hasDate && compareDate > intakeDate && $scope.appStatus === $scope.status) {
                        $scope.intakeRutteTimeSlots[$scope.intakeDate] = [$scope.intakeTimeInit];
                    }
                    if (compareDate >= today) {
                        $scope.intakeRutteTimeSlots[date] = (response.data[date]);
                    }
                    if (intakeDate < today && $scope.intakeDates[$scope.intakeDate] == null) {
                        $scope.intakeRutteTimeSlots[$scope.intakeDate] = response.data[date];
                    }
                });
                console.log('Response data: ', response.data);
                console.log('IntakeRutteTimeSlots: ', $scope.intakeRutteTimeSlots);
            });
        }
    }

    $scope.hasKey = function (arr, value) {
        let hasKey = false;
        Object.keys(arr).forEach(function (key) {
            if (key === value) {
                hasKey = true;
            }
        })
        return hasKey
    }

    $scope.getJSDateFromText = function (date) {
        debugger
        if (date != null) {
            var splittedFrom = date.split(" ");
            var monthint = $scope.getMonthNumber(splittedFrom[1]);
            return new Date(parseInt(splittedFrom[2]), monthint, parseInt(splittedFrom[0]));
        }
    };

    $scope.getMonthNumber = function (month) {
        if (month != null) {
            month = month.toLowerCase();
            var months = ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
            return months.indexOf(month);
        }
    };

    $scope.isDateSelected = function (input) {
        return ($scope.selectedDate && $scope.selectedDate === input);
    };

    $scope.getBDFMail = function () {
        $scope.save("Student");
        $scope.mailForm = {};
        $scope.mailForm["uuid"] = $scope.enrolmentId;
        $scope.mailForm["intakeTime"] = $scope.intakeTime;
        $scope.custom = false;
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/prepareBDFEmail";
        } else {
            requestUrl = "/.rest/intake/v1/prepareBDFEmail";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify($scope.mailForm),
            success: function (response) {
                $("#mailContent").html("");
                $("#mailContent").append(response.html);
                $scope.bdfMail = true;
                $("#mailTemplate").fadeIn(500);
                $("#mailTemplate").css('display', 'flex');
                $('#mailOk').css('display', 'none');
            },
            error: function (error) {
                console.error("The following error occurred: " + error);
            },
        });
    };

    $scope.getMailStudent = function () {
        // if ($scope.enrolmentId == "" || $scope.status == "" || $scope.intakeLocatie == "") {
        //     return;
        // }
        // Save before get email
        $scope.save("Student");
        $scope.mailForm = {};
        $scope.mailForm["uuid"] = $scope.enrolmentId;
        $scope.mailForm["status"] = $scope.status;
        $scope.mailForm["intakeTime"] = $scope.intakeTime;
        $scope.custom = false;
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/prepareEmail";
        } else {
            requestUrl = "/.rest/intake/v1/prepareEmail";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify($scope.mailForm),
            success: function (response) {
                $("#mailContent").html("");
                $("#mailContent").append(response.html);

                $("#mailTemplate").fadeIn(500);
                $("#mailTemplate").css('display', 'flex');
                $('#mailOk').css('display', 'none');
            },
            error: function (error) {
                console.error("The following error occurred: " + error);
            },
        });
    };

    $scope.prepareCustomMail = function () {
        if ($scope.enrolmentId == "" || $scope.status == "") {
            return;
        }
        // Save before get email
        $scope.save("Custom");
        $scope.mailForm = {};
        $scope.mailForm["uuid"] = $scope.enrolmentId;
        $scope.mailForm["status"] = $scope.status;
        $scope.mailForm["intakeTime"] = $scope.intakeTime;

        var requestUrl = "/.rest/intake/v1/prepareCustomEmail";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/prepareCustomEmail";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify($scope.mailForm),
            success: function (response) {
                $scope.custom = true;
                $("#beforeCustomMail").html("");
                $("#beforeCustomMail").append(response.beforeHtml);

                $("#afterCustomMail").html("");
                $("#afterCustomMail").append(response.afterHtml);
            },
            error: function (error) {
                console.error("The following error occurred: " + error);
            },
        });
    };

    $scope.mailIntakeReport = function (uuid) {
        $("#sendReport").css("cursor", "wait");
        setTimeout(function () {
            $("#sendReport").css("cursor", "pointer");
        }, 1000);
        $scope.mailForm = {};
        $scope.mailForm["uuid"] = uuid;
        var requestUrl = "/.rest/intake/v1/sendIntakeReport";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/sendIntakeReport";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify($scope.mailForm),
            success: function (response) {
                console.log("Mail sent!");
                $scope.custom = false;
                $scope.bdfMail = false;
                $("#intakeConfirmed").html("Verstuurd")
                $("#sendReport").hide();
                $scope.$apply();
            },
            error: function (error) {
                $("#sendReport").removeAttr("disabled");
                console.error("The following error occurred: " + error);
            },
        });
    };

    $scope.mailStudent = function () {
        $scope.mailForm = {};
        $scope.mailForm["uuid"] = $scope.enrolmentId;
        var requestUrl = '';
        if ($scope.custom) {
            $scope.mailForm["status"] = $scope.status;
            $scope.mailForm["subject"] = $scope.subject;
            $scope.mailForm["customMail"] = $scope.mailtext;
            requestUrl = "/.rest/intake/v1/sendCustomEmail";
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/intake/v1/sendCustomEmail";
            }
        } else if ($scope.bdfMail) {
            requestUrl = "/.rest/intake/v1/sendBDFEmail";
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/intake/v1/sendBDFEmail";
            }
        } else {
            $scope.mailForm["status"] = $scope.status;
            requestUrl = "/.rest/intake/v1/sendEmail";
            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/intake/v1/sendEmail";
            }
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify($scope.mailForm),
            success: function (response) {
                $('#mailStudent').attr('disabled', 'disabled');
                $('#mailStudent').css('display', 'none');
                $('#mailOk').css('display', 'inline');
                console.log("Mail sent!");
                $scope.custom = false;
                $scope.bdfMail = false;
                $("#mailContent").html("De e-mail is succesvol verstuurd");
                if (requestUrl.includes("sendBDFEmail")) {
                    $("#bdfConfirmed").html("Verstuurd")
                    $("#sendBDF").hide();
                }
                $scope.$apply();
            },
            error: function (error) {
                $("#mailContent").html("Er is iets misgegaan met het versturen van de mail");
                $('#mailOk').css('display', 'none');
                console.error("The following error occurred: " + error);
            },
        });
    };

    $scope.cancelMail = function () {
        $("#mailTemplate").fadeOut(2000);
        setTimeout(function () {
            $('#mailStudent').removeAttr('disabled');
            $('#mailStudent').css('display', 'inline');
            $scope.custom = false;
            $scope.bdfMail = false;
        }, 2000);
    };

    $scope.generatePdf = function (uuid) {
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/generateIntakePdf?uuid=" + uuid;
        } else {
            requestUrl = "/.rest/intake/v1/generateIntakePdf?uuid=" + uuid;
        }

        $.ajax({
            url: requestUrl, type: "post", contentType: "application/json", success: function (response) {
                $("#generatePdf-" + uuid).hide();
                $("#pdfGenerated-" + uuid).attr("href", response.url);
                $("#pdfGenerated-" + uuid).show();
            }, error: function (error) {
                console.error("The following error occurred: " + error);
            },
        })
    }

    $scope.printEnrolment = function () {
        $scope.form = {};
        $scope.form["uuid"] = $scope.enrolmentId;
        var requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getPdf?uuid=" + $scope.enrolmentId;
        } else {
            requestUrl = "/.rest/intake/v1/getPdf?uuid=" + $scope.enrolmentId;
        }
        window.open(requestUrl);
    };

    $scope.checkAvailability = function () {
        var intakeDate = $scope.getJSDateFromText($scope.intakeDate);

        var splittedFrom = $scope.unavailableFrom.split("/");
        var unavailableFrom = new Date(parseInt(splittedFrom[2]), parseInt(splittedFrom[1]) - 1, parseInt(splittedFrom[0]));

        var splittedTo = $scope.unavailableTo.split("/");
        var unavailableTo = new Date(parseInt(splittedTo[2]), parseInt(splittedTo[1]) - 1, parseInt(splittedTo[0]));

        if ($scope.intakeDate && $scope.unavailability) {
            if (intakeDate >= unavailableFrom && intakeDate <= unavailableTo) {
                if (intakeDate >= unavailableFrom && intakeDate <= unavailableTo) {
                    $scope.unavailable = true;
                } else {
                    $scope.unavailable = false;
                }
            } else {
                $scope.unavailable = false;
            }
        }
    }


    $scope.uploadFiles = function (inputId) {
       if (!$scope.checkFileSizes(document.getElementById(inputId).files))
       {
           document.getElementById(inputId).value = ""
       }

        var f = document.getElementById(inputId).files;
        if (f.length > 0) {
            for (var i = 0; i < f.length; i++) {
                $scope.readAndPushFile(f[i]);
            }
        }

    };


    $scope.checkFileSizes = function (files) {
        for(let file of files ){
            let size = file.size
            if (size > 15000000) {
                alert("Bestand is te groot!");
                return false;
            }
        }
        return true
    }


    $scope.readAndPushFile = function (file) {
        var currentFile = {};
        var found = $scope.files['files'].some(function (el) {
            return el.name === file.name;
        });
        if (!found) {
            currentFile['name'] = file.name;
            var r = new FileReader();
            r.readAsArrayBuffer(file)
            r.onloadend = function (e) {
                var data = e.target.result;
                var binary_string = ''
                var bytes = new Uint8Array(data);
                for (var i = 0; i < bytes.byteLength; i++) {
                    binary_string += String.fromCharCode(bytes[i]);
                }
                var base64_string = window.btoa(binary_string);
                currentFile['data'] = base64_string;
                $scope.files['files'].push(currentFile);
                $scope.$apply();
            };
        }
    };

    $scope.admissionTestGoToAdmissionTest = function (uuid, url) {
        window.location.href = url + "?enrolmentId=" + uuid;
    };

    $scope.isWachtmapStatus = function () {
        return $scope.wachtmapStatusList.includes($scope.status);
    }

    const formEditEnrolment = document.getElementById("form-editEnrolment");
    formEditEnrolment.addEventListener('keypress', function(e) {
        if (e.key === "Enter" && document.activeElement === document.getElementById("selectedRemarkField")) {
            e.preventDefault();
            $scope.saveEditRemark($scope.selectedRemark, $scope.selectedRemarkText);
        }
    });

}];

},{}],48:[function(require,module,exports){
var QRCode = require('qrcode');
module.exports = ['$scope', '$http', '$sanitize', 'courseConfigService', 'apiService', function ($scope, $http, $sanitize, courseConfigService, apiService) {

    $("#gebDatum").datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "-100:+0",
        dateFormat: "dd/mm/yy"
    });

    $scope.setAsDateField = function (id) {
        $("#" + id).datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: "-100:+50",
            dateFormat: "dd/mm/yy"
        });
    };

    $scope.setDateFieldDefaultDate = function (id, date) {
        $("#" + id).datepicker("option", "defaultDate", date);
    };

    $scope.setDateFieldValue = function (id, date) {
        $scope.intake[id] = date;
        $("#" + id).datepicker("setDate", date);
    }

    $("section .icon").click(function () {
        $(this).parent().find('.information-tooltip').toggle();
    });

    $("#inline-image").click(function () {
        $("#popup-image").show();
    });

    $("#close-popup").click(function () {
        $("#popup-image").hide();
    })

    // meh
    var qrCanvas = document.getElementById('qrCanvas');
    if (qrCanvas) {
        var otpAuth = qrCanvas.dataset.otpauth;
        QRCode.toCanvas(qrCanvas, otpAuth, {width: '300'}, function (error) {
            if (error) console.error(error);
        });
    }

    $scope.objSize = function (obj) {
        if (obj) {
            return size = Object.keys(obj).length;
        } else {
            return undefined;
        }
    };
    $scope.getFirstObject = function (obj) {
        if (obj) {
            return Object.values(obj)[0];
        } else {
            return undefined;
        }
    };

    $scope.onlyNumberKey = function (event) {
        charCode = (event.query) ? event.query : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    $scope.formId = makeid();
    $scope.intake = {};
    $scope.intakeProperties = {};
    $scope.underEighteen = true;
    $scope.underSixteen = true;
    $scope.showUitbestedingAboveEighteen = '';
    $scope.files = {};
    $scope.files['formId'] = $scope.formId;
    $scope.files['files'] = [];
    $scope.checkboxes = [];
    $scope.currentYear = '';
    $scope.triedAlready = false;
    $scope.forceBSN = false;
    $scope.forceParticipantNumber = false;
    $scope.availabilityError = "";

    $scope.getLabel = function (name) {
        var label = null;
        if ($scope.intakeProperties[name]) {
            label = $scope.intakeProperties[name].label;
        }
        return label;
    };

    $scope.getValue = function (name) {
        var value = $scope.intake[name];
        if (value === true || value === 'true') {
            value = "Ja";
        } else if (value === false || value === 'false') {
            value = "Nee";
        }
        return value;
    };

    $scope.hideVoSchoolMisc = function (id) {
        return id === 'nameVoSchoolMisc' && $scope.intake['voSchool'] !== '' && $scope.intake['voSchool'] !== 'Anders, namelijk';
    }

    $scope.isVOValueFilledByModel = function (id) {
        if ($scope.intake['attendDifferentVOSchool'] === 'false') return false;
        switch (id) {
            case "decaan":
            case "nameVoSchoolMisc":
            case "voSchool":
            case "contactPerson":
            case "contactPersonEmail":
                return !!$scope.intake[id];
            default:
                return false;
        }
    }

    $scope.hasLabel = function (name) {
        return $scope.getLabel(name) != null
    };

    $scope.tableWithIdHasRows = function (id) {
        return $("#" + id + " tr").length > 0;

    };

    if (!$('#decaanRequired').val()) {
        $scope.decaanRequired = false;
    } else {
        $scope.decaanRequired = JSON.parse($('#decaanRequired').val());
    }

    if (!$('#contactRequired').val()) {
        $scope.contactPersonRequired = false;
    } else {
        $scope.contactPersonRequired = JSON.parse($('#contactRequired').val());
    }

    if (!$('#voRequired').val()) {
        $scope.voRequired = false;
    } else {
        $scope.voRequired = JSON.parse($('#voRequired').val());
    }
    $('#error').hide();
    $(".enrolment-step").first().show();

    function onStepEnterCalls(stepNumber) {
        stepNumber = parseInt(stepNumber);
        switch (stepNumber) {
            case 1:
                $scope.populateEducationProfiles($scope.intake.vavoCollege);
                break;
            default:
                break;
        }
    }

    $scope.checkAvailabilityDate = function () {
        if (!$scope.intake['studentUnavailabilityTo'] && $scope.intake['studentUnavailabilityFrom']) {
            this.setDateFieldValue('studentUnavailabilityTo', $scope.intake['studentUnavailabilityFrom']);
        }
        if ($scope.intake['studentUnavailabilityTo'] && $scope.intake['studentUnavailabilityFrom']) {
            var to_array = $scope.intake['studentUnavailabilityTo'].split("/");
            var to = new Date(to_array[2], to_array[1] - 1, to_array[0]);
            var from_array = $scope.intake['studentUnavailabilityFrom'].split("/");
            var from = new Date(from_array[2], from_array[1] - 1, from_array[0]);
            if (to < from) {
                $scope.intake['studentUnavailabilityTo'] = null;
                this.setDateFieldDefaultDate('studentUnavailabilityTo', $scope.intake['studentUnavailabilityFrom'])
                $scope.availabilityError = "De datum \"Niet beschikbaar tot\" moet na de datum \"Niet beschikbaar vanaf\" liggen";
            } else {
                $scope.availabilityError = null;
            }
        } else {
            $scope.availabilityError = null;
        }
    };


    $scope.checkedCourses = function () {
        var courseChecked = 0;
        $('.vak_volgen').each(function () {
            if ($(this).is(':checked')) {
                courseChecked++;
            }
        });
        if (courseChecked > 0) {
            return true;
        }
        $('#error').show();
        $('#error').css('color', 'red');
        return false;
    };

    $scope.isValidCheckboxGroup = function (_currentStep) {
        var form = $("#form-" + _currentStep);
        var checkboxGroups = form.find(".checkbox-group.required");
        var groupsAreValid = true;
        checkboxGroups.each(function() {
            var element = $(this).find(':checkbox').get(0);
            if($(this).find(':checkbox:checked').length <= 0){
                element.setCustomValidity('Selecteer een of meerdere waarde(s)');
                try {
                    element.reportValidity();
                } catch (e) {
                    element.focus();
                }
                groupsAreValid = false;
                return false;
            }
            element.setCustomValidity("");
            element.reportValidity();
        });
        return groupsAreValid;
    }

    $scope.isValidFileUpload = function (_currentStep) {
        var form = $("#form-" + _currentStep);
        var fileuploadLists = form.find(".input-fileupload.required");
        var groupsAreValid = true;
        fileuploadLists.each(function() {
            var element = $(this).find('.fileInput').get(0);
            if($(this).find('li').length <= 0){
                element.setCustomValidity('Selecteer een of meerdere bestanden.');
                try {
                    element.reportValidity();
                } catch (e) {
                    element.focus();
                }
                groupsAreValid = false;
                return false;
            }
            element.setCustomValidity("");
            element.reportValidity();
        });
        return groupsAreValid;
    }

    $scope.isValidBSN = function (_currentStep) {

        var form = $("#form-" + _currentStep);

        var bsnErrors = form.find(".bsnError");
        if (bsnErrors.length > 0) {
            //Previous element has to be the BSN input field
            var element = $(bsnErrors[0].parentElement.previousElementSibling).children().filter('input[type="text"]').get(0);
            element.setCustomValidity('Dit is een ongeldig BSN.');
            try {
                element.reportValidity();
            } catch (e) {
                element.focus();
            }

            return false;
        }
        return true;
    };


    let maxStep = 1;

    /**
     * Loop through the forums and check what the last valid form is
     * @param numberOfForms {String} the number of forums
     * @returns {number} The max valid step
     */
    $scope.maxValidStep = function (numberOfForms) {
        for (let i = 0; i <= parseInt(numberOfForms); i++) {
            if (!$("#form-" + i)[0].checkValidity()) {
                return i;
            }
        }
        return maxStep;
    }

    /**
     * Check if the new form step is allowed
     * @param newStep
     * @param _currentStep
     * @param numberOfForms {String} the number of forums
     */
    $scope.validStep = function (newStep, _currentStep, numberOfForms) {
        if (this.isValidBSN(_currentStep) && (parseInt(newStep) - 1) <= this.maxValidStep(numberOfForms) && this.checkUploadedFiles(parseInt(newStep - 1))) {
            this.changeStep(newStep, _currentStep);
        }
    }

    $scope.nextStep = function (_number) {
        if (maxStep <= (parseInt(_number) + 1)) {
            maxStep = maxStep + 1;
        }
        if (_number === '2') {
            if ($scope.intake['chosenProfileOption']) {
                if (!$scope.checkedCourses()) {
                    return;
                }
            }
        }

        if (this.checkUploadedFiles(_number)) {
            var thisStep = $(".enrolment-step[step = " + _number + "]").first();
            thisStep.hide();
            var nextStep = thisStep.next();
            nextStep.show();
            onStepEnterCalls(nextStep.attr('step'));
            window.scrollTo(0, 0);
        }

        document.getElementById('submit-button-' + _number).removeAttribute('accesskey');
        document.getElementById('submit-button-' + (parseInt(_number) + 1)).setAttribute('accesskey', 'v');
    };

    /**
     * Get the max step of the forum
     * @returns {number} maxStep
     */
    $scope.getMaxStep = function () {
        return maxStep;
    }


    $scope.previousStep = function (_number) {
        var thisStep = $(".enrolment-step[step = " + _number + "]").first();
        var prevStep = thisStep.prev();
        thisStep.hide();
        prevStep.show();
        onStepEnterCalls(prevStep.attr('step'));
        $('input[id*="submit-button"]').removeAttr('disabled');
        $('#error').hide();
    };

    /**
     * Change the step in the form
     * @param newStep The stepNumber to change to
     * @param _currentStep The step to hide
     */
    $scope.changeStep = function (newStep, _currentStep) {
        if (newStep <= maxStep) {
            if (parseInt(newStep) === maxStep) {
                let thisStep = $(".enrolment-step[step = " + (maxStep - 2) + "]").first();
                let hideStep = $(".enrolment-step[step = " + _currentStep + "]").first();
                let nextStep = thisStep.next();
                hideStep.hide();
                nextStep.show();
                onStepEnterCalls(nextStep.attr('step'));
            } else {
                let thisStep = $(".enrolment-step[step = " + newStep + "]").first();
                let hideStep = $(".enrolment-step[step = " + _currentStep + "]").first();
                let nextStep = thisStep.prev(newStep);
                hideStep.hide();
                nextStep.show();
                onStepEnterCalls(nextStep.attr('step'));
            }

            $('input[id*="submit-button"]').removeAttr('disabled');
            $('#error').hide();
        }
    };


    $scope.checkGebDate = function (e, doActions) {
        if (doActions) {
            $('#' + e).find('input, select, textarea').not('#gebDatum, input[id*="button"]').val('');
        }

        let selectedDate = new Date();
        if($scope.intake['gebDatum']) {
            $scope.intake['gebDatum'] = $scope.intake['gebDatum'].replaceAll('-','/');
            let from = $scope.intake['gebDatum'].split("/");
            selectedDate = new Date(from[2], from[1] - 1, from[0]);
        }
        let magnoliaDate = $("#minDate").text();
        let minDate = new Date(magnoliaDate.toString()); //Text as served by magnolia
        let diffDate = minDate - selectedDate; //calculate diff between magnolia date and selected date
        //31556952000 is a whole year in milliseconds.
        if (Math.floor(diffDate / 31556952000) >= 18) {
            if (doActions) {
                $scope.setVo();
            }
            $scope.underSixteen = false;
            $scope.underEighteen = false;
            delete $scope.intake['cbDownloadFormulier'];
        } else if (Math.floor(diffDate / 31556952000) >= 16 && Math.floor(diffDate / 31556952000) < 18) {
            if (doActions) {
                $scope.setOutsourcing();
            }
            $scope.underSixteen = false;
            $scope.underEighteen = true;
            delete $scope.intake['cbDownloadFormulier'];
        } else {
            if (doActions) {
                $scope.setTooYoung();
            }
            $scope.underSixteen = true;
            $scope.underEighteen = true;
        }
    }

    $scope.setVo = function () {
        $('#tooYoungNote').hide();
        $('#tooYoungAlert').hide();
        $('.content-section').not('#tooYoungAlert').show();
        $('#outsourcing-doNotShow').hide();
        $('#VO').show();
        $('#VOintro').show();
        $('#outsourcing-details').hide();
        $('#rijksfinanciering').show();
        $("#VOdetails :input").prop('required', true);
        $("#nameVoSchoolMisc").prop('required', false);
        if ($scope.voRequired) {
            $("#voSchool").prop('required', true);
        } else {
            $("#voSchool").prop('required', false);
        }
        if ($scope.decaanRequired) {
            $("#decaan").prop('required', true);
        } else {
            $("#decaan").prop('required', false);
        }
        if ($scope.contactPersonRequired) {
            $("#contactPerson").prop('required', true);
        } else {
            $("#contactPerson").prop('required', false);
        }

        $("#cbDownloadFormulier").prop('required', false);
        if ($scope.showUitbestedingAboveEighteen == 'true' && $scope.intake['attendDifferentVOSchool'] == 'true') {
            $('#outsourcing-details').show();
            $("#cbDownloadFormulier-details").prop('required', true);
            $("#cbDownloadFormulier-doNotShow").prop('required', false);
            $('#rijksfinanciering').hide();
        } else if ($scope.showUitbestedingAboveEighteen == 'true') {
            $('#outsourcing-details').show();
            $("#cbDownloadFormulier-details").prop('required', true);
            $("#cbDownloadFormulier-doNotShow").prop('required', false);
            $('#rijksfinanciering').hide();
        } else {
            $('#outsourcing-details').hide();
            $("#cbDownloadFormulier-details").prop('required', false);
            $("#cbDownloadFormulier-doNotShow").prop('required', false);
        }
        $scope.enableNext();
    };

    $scope.setOutsourcing = function () {
        $('#tooYoungNote').hide();
        $('#tooYoungAlert').hide();
        $('.content-section').not('#tooYoungAlert').show();
        $('#outsourcing-details').hide();
        $('#outsourcing-doNotShow').show();
        $('#VO').show();
        ($("#newAgeCheck").text() === 'true') ? $('#VOintro').show() : $('#VOintro').hide();
        $('#VOdetails').show();
        $('#rijksfinanciering').hide();
        $("#VOdetails :input").prop('required', false);
        if ($scope.voRequired) {
            $("#voSchool").prop('required', true);
        } else {
            $("#voSchool").prop('required', false);
        }
        if ($scope.decaanRequired) {
            $("#decaan").prop('required', true);
        } else {
            $("#decaan").prop('required', false);
        }
        if ($scope.contactPersonRequired) {
            $("#contactPerson").prop('required', true);
        } else {
            $("#contactPerson").prop('required', false);
        }
        $("#cbDownloadFormulier-details").prop('required', false);
        $("#cbDownloadFormulier-doNotShow").prop('required', true);
        $scope.enableNext();
    };

    $scope.setTooYoung = function () {
        $('#tooYoungNote').show();
        $('#tooYoungAlert').show();
        $('.content-section').not('#tooYoungAlert').hide();
        $('#outsourcing-details').hide();
        $('#outsourcing-doNotShow').hide();
        $('#VO').hide();
        $('#rijksfinanciering').hide();
        $("#VOdetails :input").prop('required', false);
        $scope.disableNext();
    }

    $scope.$watch('intake["attendDifferentVOSchool"]', function (newValue) {
        if (newValue == "true") {
            $('#VOdetails').show();
            if ($scope.showUitbestedingAboveEighteen == 'true') {
                $('#outsourcing-details').show();
                $('#outsourcing-doNotShow').hide();
                $("#cbDownloadFormulier-details").prop('required', true);
            } else {
                $('#outsourcing-details').hide();
                $("#cbDownloadFormulier-details").prop('required', false);
                $("#cbDownloadFormulier-doNotShow").prop('required', false);
            }
            $scope.intake['cbDownloadFormulier-GovernmentFunding'] = undefined;
            $("#cbDownloadFormulier-GovernmentFunding").prop('required', false);

            $('#rijksfinanciering').hide();
            $("#VOdetails :input").prop('required', true);
            $("#nameVoSchoolMisc").prop('required', false);
            if ($scope.voRequired) {
                $("#voSchool").prop('required', true);
            } else {
                $("#voSchool").prop('required', false);
            }
            if ($scope.decaanRequired) {
                $("#decaan").prop('required', true);
            } else {
                $("#decaan").prop('required', false);
            }
            if ($scope.contactPersonRequired) {
                $("#contactPerson").prop('required', true);
            } else {
                $("#contactPerson").prop('required', false);
            }
        } else if (newValue == "false") {
            $('#VOdetails').hide();
            $('#outsourcing-details').hide();
            $('#rijksfinanciering').show();
            $("#cbDownloadFormulier-details").prop('required', false);
            $("#cbDownloadFormulier-doNotShow").prop('required', false);
            $("#voSchool").prop('required', false);
            $("#VOdetails :input").prop('required', false);
            $scope.intake['cbDownloadFormulier'] = undefined;
            $("#cbDownloadFormulier-GovernmentFunding").prop('required', true);
            $scope.enableNext();
        }
    });

    $scope.disableNext = function () {
        $('input[id*="submit-button"]').attr('disabled', 'disabled');
        $('input[id*="back-button"]').attr('disabled', 'disabled');
    }
    $scope.enableNext = function () {
        $('input[id*="submit-button"]').removeAttr('disabled');
        $('input[id*="back-button"]').removeAttr('disabled');
    }

    $scope.profileChoices = null;


    $scope.populateEducationProfiles = function (college) {
        var educationProfile = apiService.getEducationProfiles(college, $scope.intake['educationType'], $scope.intake['graduation']);
        if (educationProfile) {
            educationProfile.then(function (_result) {
                $scope.profileOptions = _result;
            });
        }
    };

    $scope.isValidCourse = function (required, checked, grade) {
        if (required) {
            return ((!checked) && (grade === undefined || grade === null || 0 === grade.length));
        } else {
            return false;
        }
    };

    $scope.populateProfileChoices = function () {
        var profileChoices = apiService.getProfileChoices($scope.intake['chosenProfileOption'], $scope.intake['educationType'], $scope.intake['vavoCollege'], $scope.intake['graduation']);
        profileChoices.then(function (_result) {
            courseConfigService.reset();
            courseConfigService.setProfile($scope.intake['chosenProfileOption']);
            courseConfigService.setFromExistingConfigObject(_result.newCourseConfig);
            $scope.profileChoices = null;
            setTimeout(function () {
                $scope.profileChoices = _result.profileChoices;
                $scope.$apply();
            }, 0);
        });
    };

    $scope.initCourseConfig = function (newValue) {
        document.getElementById('submit-button-0').setAttribute('accesskey', 'v');
        $('.course-config-form').removeClass("hide-dots");
        $('.course-config-form').removeClass("hide-profile");
        if (newValue) {
            $scope.populateProfileChoices();
            if (newValue != 'undefined') {
                if (newValue != 'Profielloos' && newValue != 'Sectorloos') {
                    $('.course-config-form').addClass("hide-dots");
                } else {
                    $('.course-config-form').addClass("hide-profile");
                }
            }
        } else {
            courseConfigService.reset();
            courseConfigService.setProfile($scope.intake['chosenProfileOption']);
            $scope.profileChoices = null;
        }
    };

    $scope.$watch('intake.chosenProfileOption', $scope.initCourseConfig);

    $scope.checkConditionalField = function (currentValue,
                                             correspondingList,
                                             ids,
                                             id) {
        correspondingList[0] = correspondingList[0] || [];
        correspondingList[1] = correspondingList[1] || [];
        correspondingList[2] = correspondingList[2] || [];
        correspondingList[3] = correspondingList[3] || [];
        correspondingList[4] = correspondingList[4] || [];
        correspondingList[5] = correspondingList[5] || [];
        correspondingList[6] = correspondingList[6] || [];
        correspondingList[7] = correspondingList[7] || [];

        for (var i = 0; i < correspondingList.length; i++) {
            correspondingList[i] = correspondingList[i] || [];
            var match = correspondingList[i].includes(currentValue);

            $scope.correspondingOptions[i][id] = match;
            if (ids[i] != "") {
                $("#" + ids[i] + " input, #" + ids[i] + " select, #" + ids[i] + " textarea").each(function () {
                    $(this).prop('required', match);
                });
            }
        }
    };


    $scope.submitEndForm = function (vavoCollege, thankYouLink, stepId) {
        $('.errorOnSave').html("");
        //disable button and show loader.
        $('#endLoader').show();
        $('#endLoader').css('display', 'inline-block');
        $('#loaderMessage').show();
        $('#loaderMessage').css('display', 'inline-block');
        $('#submit-button-' + stepId).hide();
        $('#back-button-' + stepId).hide();

        let bsnUrl = '';
        let blacklistBsnUrl = '';
        if (location.hostname === "localhost") {
            bsnUrl = "/vavo-intake-webapp/.rest/enrolment/v1/checkBSN?year=" + $scope.currentYear + "&vavoCollege=" + vavoCollege + "&bsn=" + $scope.intake["bsn"];
            blacklistBsnUrl = "/vavo-intake-webapp/.rest/enrolment/v1/checkBlacklist?vavoCollege=" + vavoCollege + "&bsn=" + $scope.intake["bsn"];
        } else {
            bsnUrl = "/.rest/enrolment/v1/checkBSN?year=" + $scope.currentYear + "&vavoCollege=" + vavoCollege + "&bsn=" + $scope.intake["bsn"];
            blacklistBsnUrl = "/.rest/enrolment/v1/checkBlacklist?vavoCollege=" + vavoCollege + "&bsn=" + $scope.intake["bsn"];
        }

        if (!$scope.forceParticipantNumber && !$scope.forceBSN && $scope.triedAlready) { //No checks and tried already
            actuallySubmit(vavoCollege, thankYouLink, stepId)
        }
        else if($scope.forceParticipantNumber && !$scope.forceBSN && $scope.triedAlready) { //Only forceParticipantNumber check and didn't try already
            checkParticipantNumber(vavoCollege, stepId, function(result) {
                if(result) {
                    actuallySubmit(vavoCollege, thankYouLink, stepId)
                }
            })
        }
        else {
            //BSN Duplicate check:
            //  Not duplicate:
            //      BSN Blacklist check:
            //          Is blacklisted:
            //              forceParticipantNumber on:
            //                  Participant number check:
            //                      Is duplicate:
            //                          Show error, don't submit the form
            //                      Not duplicate:
            //                          Submit the form
            //              forceParticipantNumber off:
            //                  Submit the form
            //          Not blacklisted:
            //              Show error, don't submit the form
            //  Is duplicate:
            //      forceBSN on:
            //          Show warning, if submit button is clicked again let it submit
            //      forceBSN off:
            //          Show error, don't submit the form

            $.ajax({
                url: bsnUrl,
                type: "GET",

                success: function (response) {
                    if (response) {
                        $.ajax({
                            url: blacklistBsnUrl,
                            type: "GET",

                            success: function (response) {
                                if (response) {
                                    if($scope.forceParticipantNumber) {
                                        checkParticipantNumber(vavoCollege, stepId, function(participantNrResult) {
                                            if(participantNrResult) {
                                                actuallySubmit(vavoCollege, thankYouLink, stepId);
                                            }
                                        })
                                    }else {
                                        actuallySubmit(vavoCollege, thankYouLink, stepId);
                                    }
                                } else {
                                    $scope.triedAlready = false;
                                    $('#endLoader').hide();
                                    $('#loaderMessage').hide();
                                    $('.errorOnSave').html("Het is op dit moment niet mogelijk om je met jouw BSN aan te melden. Neem voor meer informatie contact op met de school");

                                    $('#submit-button-' + stepId).hide();
                                    $('#back-button-' + stepId).show();

                                }
                            },
                            error: function (error) {
                                console.error(
                                    "The following error occurred: " + JSON.stringify(error)
                                );
                                $('#endLoader').hide();
                                $('#loaderMessage').hide();
                                $('.errorOnSave').html("Controleer of je je gegevens goed hebt ingevuld en probeer het opnieuw, als deze foutmelding blijft, ga dan terug naar de startpagina en log je opnieuw in");
                                $('#submit-button-' + stepId).show();
                                $('#back-button-' + stepId).show();
                            },
                        });

                    } else {
                        $scope.triedAlready = true;
                        $('#endLoader').hide();
                        $('#loaderMessage').hide();
                        if ($scope.forceBSN) {
                            $('.errorOnSave').html("Er is al een inschrijving met jouw BSN dit jaar. Controleer of je BSN nummer juist is");
                        } else {
                            $('.errorOnSave').html("Er is al een inschrijving met jouw BSN dit jaar. Controleer of het de bedoeling is voordat je nog een keer op verstuur drukt");
                        }
                        $('#submit-button-' + stepId).show();
                        $('#back-button-' + stepId).show();

                    }
                },
                error: function (error) {
                    console.error(
                        "The following error occurred: " + JSON.stringify(error)
                    );
                    $('#endLoader').hide();
                    $('#loaderMessage').hide();
                    $('.errorOnSave').html("Controleer of je je gegevens goed hebt ingevuld en probeer het opnieuw, als deze foutmelding blijft, ga dan terug naar de startpagina en log je opnieuw in");
                    $('#submit-button-' + stepId).show();
                    $('#back-button-' + stepId).show();
                },
            });


        }
        // Fire off the request to /form.php

    };

    $scope.getCourseConfig = function () {
        $scope.courseConfig = courseConfigService.getRawCourseConfig();
        return $scope.courseConfig;
    }

    function checkParticipantNumber(vavoCollege, stepId, callback) {
        let participantNumberUrl = '';
        if (location.hostname === "localhost") {
            participantNumberUrl = "/vavo-intake-webapp/.rest/enrolment/v1/checkParticipantNumber?year=" + $scope.currentYear + "&vavoCollege=" + vavoCollege + "&participantNumber=" + $scope.intake["deelnemernr"];
        } else {
            participantNumberUrl = "/.rest/enrolment/v1/checkParticipantNumber?year=" + $scope.currentYear + "&vavoCollege=" + vavoCollege + "&participantNumber=" + $scope.intake["deelnemernr"];
        }

        $.ajax({
            url: participantNumberUrl,
            type: "GET",

            success: function (response) {
                if (!response) {
                    $('#endLoader').hide();
                    $('#loaderMessage').hide();
                    let errorMessage = $('.errorOnSave').first().attr('data-participantNumberError');
                    if(errorMessage) {
                        $('.errorOnSave').html(errorMessage);
                    }else {
                        $('.errorOnSave').html('Je hebt je dit jaar al aangemeld voor het VAVO.');
                    }

                    $('#submit-button-' + stepId).hide();
                    $('#back-button-' + stepId).show();
                }
                callback(response);
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + JSON.stringify(error)
                );
                $('#endLoader').hide();
                $('#loaderMessage').hide();
                $('.errorOnSave').html("Controleer of je je gegevens goed hebt ingevuld en probeer het opnieuw, als deze foutmelding blijft, ga dan terug naar de startpagina en log je opnieuw in");
                $('#submit-button-' + stepId).show();
                $('#back-button-' + stepId).show();
                callback(false);
            },
        });
    }

    function getNameFromCamboEnrolmentUuid(callback) {
        let getNameUrl = ''
        if(!$scope.intake["camboEnrolmentUuid"]) {
            callback("");
        }
        if (location.hostname === "localhost") {
            getNameUrl = "/vavo-intake-webapp/.rest/enrolment/v1/getNameForEnrolmentUuid?uuid=" + $scope.intake["camboEnrolmentUuid"];
        } else {
            getNameUrl = "/.rest/enrolment/v1/getNameForEnrolmentUuid?uuid=" + $scope.intake["camboEnrolmentUuid"];
        }

        $.ajax({
            url: getNameUrl,
            type: "GET",

            success: function (response) {
                // if (!response) {
                //     $('#endLoader').hide();
                //     let errorMessage = $('.errorOnSave').first().attr('data-participantNumberError');
                //     if(errorMessage) {
                //         $('.errorOnSave').html(errorMessage);
                //     }else {
                //         $('.errorOnSave').html('Je hebt je dit jaar al aangemeld voor het VAVO.');
                //     }
                //
                //     $('#submit-button-' + stepId).hide();
                //     $('#back-button-' + stepId).show();
                // }
                callback(response);
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + JSON.stringify(error)
                );
                // $('#endLoader').hide();
                // $('.errorOnSave').html("Controleer of je je gegevens goed hebt ingevuld en probeer het opnieuw, als deze foutmelding blijft, ga dan terug naar de startpagina en log je opnieuw in");
                // $('#submit-button-' + stepId).show();
                // $('#back-button-' + stepId).show();
                callback("");
            },
        });
    }

    function actuallySubmit(vavoCollege, thankYouLink, stepId) {

        var completeLink = thankYouLink;
        $scope.submitForm = {};
        $scope.submitForm['uuid'] = "";
        if($scope.intake['camboEnrolmentUuid']) {
            $scope.submitForm['uuid'] = $scope.intake['camboEnrolmentUuid']
            $scope.files['enrolmentId'] = $scope.intake['camboEnrolmentUuid']
        }

        $scope.submitForm['vavoCollege'] = vavoCollege;
        $scope.submitForm['properties'] = [];
        $scope.submitForm['courseConfig'] = courseConfigService.getCourseConfig();
        $scope.submitForm['formId'] = $scope.formId;
        $scope.files['vavoCollege'] = vavoCollege;

        $.each($scope.intake, function (_key, _value) {
            var label = 'Onbekende label.';
            if ($scope.intakeProperties && $scope.intakeProperties[_key]) {
                label = $scope.intakeProperties[_key].label;
            }
            $scope.submitForm['properties'].push(
                {
                    "id": _key,
                    "value": _value,
                    "label": label
                });
        });

        var requestUrlFiles = '';
        if (location.hostname === "localhost") {
            requestUrlFiles = "/vavo-intake-webapp/.rest/enrolment/v1/uploadFiles";
        } else {
            requestUrlFiles = "/.rest/enrolment/v1/uploadFiles";
        }

        $.ajax({
            url: requestUrlFiles,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify($scope.files),
            success: function (response) {
                var requestUrl = '';
                if (location.hostname === "localhost") {
                    requestUrl = "/vavo-intake-webapp/.rest/enrolment/v1/create";
                } else {
                    requestUrl = "/.rest/enrolment/v1/create";
                }

                $.ajax({
                    url: requestUrl,
                    type: "post",
                    contentType: "application/json",
                    data: JSON.stringify($scope.submitForm),
                    success: function (response) {
                        if (response.entity.success === true){
                            window.location.href = completeLink;
                        }else {
                            console.error(
                                "The following error occurred: " + JSON.stringify(error)
                            );
                            $('#endLoader').hide();
                            $('#loaderMessage').hide();
                            $('.errorOnSave').html("Controleer of je je gegevens goed hebt ingevuld en probeer het opnieuw, als deze foutmelding blijft, ga dan terug naar de startpagina en log je opnieuw in");
                            $('#submit-button-' + stepId).show();
                            $('#back-button-' + stepId).show();
                        }
                    },
                    error: function (error) {
                        console.error(
                            "The following error occurred: " + JSON.stringify(error)
                        );
                        $('#endLoader').hide();
                        $('#loaderMessage').hide();
                        $('.errorOnSave').html("Controleer of je je gegevens goed hebt ingevuld en probeer het opnieuw, als deze foutmelding blijft, ga dan terug naar de startpagina en log je opnieuw in");
                        $('#submit-button-' + stepId).show();
                        $('#back-button-' + stepId).show();
                    },
                });
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
                $('#endLoader').hide();
                $('#loaderMessage').hide();
                $('.errorOnSave').html("Er is een probleem opgetreden, controleer of je je gegevens goed hebt ingevuld en probeer het opnieuw");
                $('#submit-button-' + stepId).show();
                $('#back-button-' + stepId).show();
            },
        });
    }


    $scope.checkFileSizes = function (files) {
        for (let file of files) {
            let size = file.size
            if (size > 15000000) {
                alert("Bestand is te groot!");
                return false;
            }
        }
        return true
    }

    $scope.uploadFiles = function (inputId) {

        if (!$scope.checkFileSizes(document.getElementById(inputId).files)) {
            document.getElementById(inputId).value = ""
        }

        var f = document.getElementById(inputId).files;
        if (f.length > 0) {
            for (var i = 0; i < f.length; i++) {
                $scope.readAndPushFile(f[i], inputId);
            }
        }
    };

    $scope.removeFile = function (file, formId) {
        var index = $scope.files['files'].indexOf(file);
        if (index > -1) {
            $scope.files['files'].splice(index, 1);
        }
        if ($scope.files['files'].length < 1) {
            document.getElementById(formId).value = '';
        }
    };

    $scope.readAndPushFile = function (file, inputId) {
        var currentFile = {};
        var found = $scope.files['files'].some(function (el) {
            return el.name === file.name;
        });
        if (!found) {
            currentFile['name'] = file.name;
            currentFile['inputId'] = inputId;
            var r = new FileReader();
            r.readAsArrayBuffer(file)
            r.onloadend = function (e) {
                var data = e.target.result;
                var binary_string = ''
                var bytes = new Uint8Array(data);
                for (var i = 0; i < bytes.byteLength; i++) {
                    binary_string += String.fromCharCode(bytes[i]);
                }
                var base64_string = window.btoa(binary_string);
                currentFile['data'] = base64_string;
                $scope.files['files'].push(currentFile);
                $scope.$apply();
            };
        }
    };

    $scope.getCheckboxes = function (name) {
        var checkboxes = [];
        if (name) {
            angular.forEach($scope.intake, function (intakeValue, intakeKey) {
                if (intakeValue === "true" && intakeKey.indexOf(name) !== -1 && intakeKey.indexOf("_ms_") !== -1) {
                    checkboxes.push(intakeKey);
                }
            });
        }
        return checkboxes;
    };

    /**
     * Checks if the current form is valid
     * @param formStep String formStep
     * @returns {boolean} true if the form is valid
     */
    $scope.isFormValid = function (formStep) {
        return $("#form-" + parseInt(formStep))[0].checkValidity()
    }

    /**
     * Checks if there are files uploaded
     * @param formStep Current formStep
     * @returns {boolean}
     */
    $scope.checkUploadedFiles = function (formStep) {
        //return true because this check broke enrolment page
        //Didn't remove method due to possibility of breaking stuff
        return true;
    }

    $scope.isCheckboxList = function (name) {
        var retval = false;
        if ($scope.checkboxes && $scope.checkboxes.length > 0) {
            if (name) {
                $scope.checkboxes.forEach(function (checkbox) {
                    if (name.indexOf(checkbox) !== -1) {
                        retval = true;
                    }
                });
            }
        }
        return retval;
    };


    $scope.sanitize = function (str) {
        return $sanitize(str);
    };

    $scope.getCheckboxName = function (name) {
        var retval = name;
        if ($scope.checkboxes && $scope.checkboxes.length > 0) {

            if (name) {
                $scope.checkboxes.forEach(function (checkbox) {
                    if (name.indexOf(checkbox) !== -1) {
                        retval = checkbox;
                    }
                });
            }
        }
        return retval;

    };

    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 20; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    $scope.alreadyRegistered = function () {
        $(".enrolment-step").hide();
        $("#alreadyRegistered").show();
    };

    $scope.capitalize = function (id) {
        if ($scope.intake[id]) {
            var words = $scope.intake[id].split(" ");
            var uppercaseWord = "";
            for (var i = 0; i < words.length; i++) {
                if (words[i].length >= 1) {
                    uppercaseWord += words[i].substring(0, 1).toUpperCase() + words[i].substring(1) + " ";
                }
            }
            $scope.intake[id] = uppercaseWord.trim();
        }
    }

    $scope.getEducationTypeByCourseCode = function (vavoCollege, courseCode) {
        let requestUrlEducationType = '/.rest/enrolment/v1/getEducationTypeByCourseCode?vavoCollege=' + vavoCollege + '&courseCode=' + courseCode;

        if (location.hostname === "localhost") {
            requestUrlEducationType = '/vavo-intake-webapp/.rest/enrolment/v1/getEducationTypeByCourseCode?vavoCollege=' + vavoCollege + '&courseCode=' + courseCode;
        }

        let result;

        $.ajax({
            url: requestUrlEducationType,
            type: "GET",
            async: false,
            success: function (response) {
                result = response;
            },
            error: function (error) {
                console.error(
                    "The following error occurred: ", error
                );

            },
        });

        return result;

    }

    $scope.getUrlParameters = function (vavoCollege, magnoliaUrlParameters) {

        const queryString = window.location.search;
        let CamboParams = {};
        if (queryString) {
            const urlParams = new URLSearchParams(window.location.search);
            let changeURL = false;
            for (const param of urlParams.entries()) {
                if(param[0] === "camboEnrolmentUuid"){
                    $scope.intake["camboEnrolmentUuid"] = param[1];
                    getNameFromCamboEnrolmentUuid(function(result) {
                        if(result) {
                            $scope.intake["gebDatum"] = result.gebDatum;
                            $scope.intake["firstName"] = result.firstName;
                            $scope.intake["educationType"] = result.educationType;
                            $scope.intake["email"] = result.email;
                            $scope.$apply();
                            $scope.checkGebDate('form-1', true);
                        } else {
                            console.error("Error in callback function, no result found");
                        }
                    })
                    changeURL = true;
                }

                if (magnoliaUrlParameters.includes(param[0])) {
                    CamboParams[param[0]] = param[1];
                    $scope.intake[param[0]] = param[1];
                    if (param[0] === 'gebDatum') {
                        $scope.intake[param[0]] = param[1].replaceAll('-', '/');
                        changeURL = true;
                    } else if (param[0] === 'educationType') {
                        $scope.intake[param[0]] = $scope.getEducationTypeByCourseCode(vavoCollege, param[1]);
                        changeURL = true;
                    }
                }
            }

            // Obsolete with new cambo signup through mail?
            // $scope.intake["CamboParams"]=JSON.stringify(CamboParams);

            if(changeURL) {
                window.history.replaceState({}, document.title, "/" + vavoCollege + "/aanmelden");

                if (location.hostname === "localhost") {
                   window.history.replaceState({}, document.title, "/vavo-intake-webapp/" + vavoCollege + "/aanmelden");
                }
            }
        }
    }
}];

},{"qrcode":11}],49:[function(require,module,exports){
module.exports = ['$scope', '$http', 'Blob', 'FileSaver', function ($scope, $http, Blob, FileSaver) {
    $scope.courseConfig = {};
    $scope.enrolments = [];
    $scope.search = {};
    $scope.searchFilters = {};
    $scope.sortType = '';
    $scope.sortReverse = false;
    $scope.searchResults = [];
    $scope.totalSearchResults = 0;
    $scope.searchSchakelklasOfVbjOptions = [];
    $scope.searchEducationOptions = [];
    $scope.searchLocationOptions = [];
    $scope.searchIsPrintedOptions = [];
    $scope.searchIsSchakelleerlingOptions = [];
    $scope.searchAdmissionTestsCalledStudentOptions = [];
    $scope.searchAdmissionTestsAllDoneOptions = [];
    $scope.currentPage = 1;
    $scope.currentPageWithFilter = 1;
    $scope.searchIsUitbesteedOptions = [];
    $scope.searchSpecialIntakeOptions = [];
    $scope.searchShortIntakeOptions = [];
    $scope.searchOwnStudentOptions = [];
    $scope.filteredResults = null;
    $scope.searchSeptemberTrajectOptions = [];
    $scope.searchWachtmapDatumOptions = [];
    $scope.searchTopsportOptions = [];
    $scope.xlsFiles = {};
    $scope.xlsFiles['formId'] = $scope.formId;
    $scope.xlsFiles['files'] = [];
    $scope.showImportAppointments = false;
    $scope.showImportAppointmentsButton = false;
    $scope.showImportAppointmentsSpinner = false;
    $scope.currentYear = '';


    $("#enrolmentDate").datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "-1:+1",
        dateFormat: "dd MM yy",
        regional: "nl"
    });

    $("#intakeDate").datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "-1:+1",
        dateFormat: "dd MM yy",
        regional: "nl"
    });

    $("#birthDate").datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "-150:+1",
        dateFormat: "dd MM yy",
        regional: "nl"
    });

    $scope.addEnrolment = function (enrolment) {
        $scope.enrolments.push(enrolment);
    };

    $scope.goToIntake = function (enrolment, url) {
        window.location.href = url + "?enrolmentId=" + enrolment["enrolmentId"];
    };

    $scope.clearSearch = function () {
        var clearValues = ["searchText", "searchEducation", "searchLocation", "searchDate",
            "searchBirthDate", "searchIsPrinted", "searchIsUitbesteed", "searchStatus",
            "searchOwnStudent", "searchSpecialIntake", "searchShortIntake", "searchSeptemberTraject",
            "searchEnrolmentDate", "searchIsSchakelleerling", "searchTopsport", "searchWachtmapDatum",
            "searchAdmissionTestsCalledStudent", "searchAdmissionTestsAllDone", "searchSchakelklasOfVbj"];

        for (var x = 0; x < clearValues.length; x++) {
            $scope[clearValues[x]] = "";
            localStorage.setItem(clearValues[x], JSON.stringify(""));
        }
        $scope.searchStatus = [];
        $scope.currentPage = parseInt(localStorage.getItem("currentPage"))
    };

    $scope.storeFieldValue = function (fieldName) {
        if (fieldName !== null && fieldName !== undefined) {
            localStorage.setItem(fieldName, JSON.stringify($scope[fieldName]));
        } else {
            localStorage.removeItem(fieldName);
        }
    };

    $scope.loadFieldValue = function (fieldName) {
        var loc = localStorage.getItem(fieldName);
        if (loc && loc !== "undefined" && loc !== "null") {
            var value = JSON.parse(loc);
            if (value) {
                $scope[fieldName] = value;
            }
        }
    };

    $scope.setSortType = function (columnName) {
        this.sortType = columnName;
        localStorage.setItem("sortType", columnName);
    };

    $scope.getSortType = function () {
        let sortType = localStorage.getItem('sortType');
        if (sortType == null) {
            sortType = "enrolmentDate";
        }
        return sortType;
    }

    $scope.setSortOrder = function (sortReverse) {
        this.sortReverse = sortReverse;
        localStorage.setItem('sortReverse', sortReverse);
    };

    $scope.getSortOrder = function () {
        // booleans are stored as string, so we need additional parsing here
        return (localStorage.getItem('sortReverse') === 'true');
    }

    $scope.$watch('search["yearCourse"]', function (newValue) {
        $('.table tbody > tr').empty();
        $('.table tbody > tr').remove();
        $scope.getEnrolments(newValue, $scope.intake['vavoCollege']);
    });

    $scope.getCsv = function () {
        var response = {"vavoCollege": $scope.intake['vavoCollege']};
        response.enrolments = $scope.filteredResults.map(function (enrolment, index) {
            return enrolment.enrolmentId;
        });
        response.year = $scope.search["yearCourse"];

        var requestUrl = "";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getCsv";
        } else {
            requestUrl = "/.rest/intake/v1/getCsv";
        }

        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(response),
            success: function (response) {
                var data = new Blob([response], {type: 'text/csv'});
                FileSaver.saveAs(data, 'export.csv');
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
            },
        });
    };

    $scope.getPlanningCsv = function () {
        var response = {"vavoCollege": $scope.intake['vavoCollege']};
        response.enrolments = $scope.filteredResults.map(function (enrolment, index) {
            return enrolment.enrolmentId;
        });
        response.year = $scope.search["yearCourse"];

        var requestUrl = "";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getPlanningCsv";
        } else {
            requestUrl = "/.rest/intake/v1/getPlanningCsv";
        }

        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(response),
            success: function (response) {
                var data = new Blob([response], {type: 'text/csv'});
                FileSaver.saveAs(data, 'planning.csv');
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
            },
        });
    };

    $scope.getCompleteCsv = function () {
        var response = {"vavoCollege": $scope.intake['vavoCollege']};
        response.enrolments = $scope.filteredResults.map(function (enrolment, index) {
            return enrolment.enrolmentId;
        });

        response.year = $scope.search["yearCourse"];

        var requestUrl = "";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getCompleteCsv";
        } else {
            requestUrl = "/.rest/intake/v1/getCompleteCsv";
        }
        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(response),
            success: function (response) {
                var data = new Blob([response], {type: 'text/csv'});
                FileSaver.saveAs(data, 'complete.csv');
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
            },
        });
    };

    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 20; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    $scope.setAppointmentXls = function (inputId) {

        if (!$scope.checkFileSizes(document.getElementById(inputId).files)) {
            document.getElementById(inputId).value = ""
            return
        }


        $scope.xlsFiles = {};
        $scope.xlsFiles['formId'] = makeid();
        $scope.xlsFiles['files'] = [];
        $scope.xlsFiles['vavoCollege'] = $scope.intake['vavoCollege'];

        $scope.xlsFiles['year'] = $scope.currentYear;

        var f = document.getElementById(inputId).files;
        if (f.length === 1) {
            $scope.showImportAppointmentsButton = true;
            $scope.$apply();
        }
        $scope.sendAppointmentXls(inputId);
    };

    $scope.sendAppointmentXls = function (inputId) {
        var f = document.getElementById(inputId).files;
        $scope.readAndPushXls(f[0]);
    };

    $scope.readAndPushXls = function (file) {
        if (!confirm("Bestaande items worden overschreven \n\rDeze actie kan niet ongedaan gemaakt worden \n\rDoorgaan ?")) {
            document.getElementById('fileUpload').value = '';
            $scope.showImportAppointmentsButton = false;
            $scope.showImportAppointments = false
            $scope.showImportAppointmentsSpinner = false;
            $scope.$apply();
            return
        }
        var currentFile = {};

        currentFile['name'] = file.name;
        var r = new FileReader();
        r.readAsArrayBuffer(file);
        r.onloadend = function (e) {
            var data = e.target.result;
            var binary_string = ''
            var bytes = new Uint8Array(data);
            for (var i = 0; i < bytes.byteLength; i++) {
                binary_string += String.fromCharCode(bytes[i]);
            }
            var base64_string = window.btoa(binary_string);
            currentFile['data'] = base64_string;
            $scope.xlsFiles['files'].push(currentFile);

            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/intake/v1/uploadAppointments";
            } else {
                requestUrl = "/.rest/intake/v1/uploadAppointments";
            }

            document.getElementById('fileUpload').value = '';
            $scope.showImportAppointmentsButton = false;
            $scope.showImportAppointments = false
            $scope.showImportAppointmentsSpinner = true;
            $scope.$apply();
            $.ajax({
                url: requestUrl,
                type: "post",
                contentType: "application/json",
                // data: JSON.stringify(response),
                data: JSON.stringify($scope.xlsFiles),
                success: function (response) {

                    console.info("received : " + response.status);
                    console.info("received : " + response.success);


                    if (response.success) {
                        alert("Planning succesvol ingelezen");
                    } else {
                        alert("Inlezen Planning mislukt");
                    }

                    $scope.showImportAppointmentsSpinner = false;
                    $scope.xlsFiles = {};
                    $scope.$apply();
                },
                error: function (error) {
                    $scope.showImportAppointmentsSpinner = false;
                    $scope.$apply();

                    alert("Inlezen Planning mislukt \n\r Foutmelding : " + error);
                    console.error(
                        "The following error occurred: " + error.responseText
                    );
                },
            });
        };

    };


    $scope.checkFileSizes = function (files) {
        for (let file of files) {
            let size = file.size
            if (size > 15000000) {
                alert("Bestand is te groot!");
                return false;
            }
        }
        return true
    }

    $scope.setTestSlotsXls = function (inputId) {

        if (!$scope.checkFileSizes(document.getElementById(inputId).files)) {
            document.getElementById(inputId).value = ""
            return
        }

        $scope.xlsFiles = {};
        $scope.xlsFiles['formId'] = makeid();
        $scope.xlsFiles['files'] = [];
        $scope.xlsFiles['vavoCollege'] = $scope.intake['vavoCollege'];
        $scope.xlsFiles['year'] = $scope.currentYear;

        var f = document.getElementById(inputId).files;
        if (f.length === 1) {
            $scope.showImportTestSlotsButton = true;
            $scope.$apply();
        }
        $scope.sendTestSlotsXls(inputId);
    };

    $scope.sendTestSlotsXls = function (inputId) {
        var f = document.getElementById(inputId).files;
        $scope.readAndPushTestSlotsXls(f[0]);
    };

    $scope.readAndPushTestSlotsXls = function (file) {
        if (!confirm("Bestaande items worden overschreven \n\rDeze actie kan niet ongedaan gemaakt worden \n\rDoorgaan ?")) {
            document.getElementById('fileUpload').value = '';
            $scope.showImportTestSlotsButton = false;
            $scope.showImportTestSlots = false
            $scope.showImportTestSlotsSpinner = false;
            $scope.$apply();
            return
        }
        var currentFile = {};

        currentFile['name'] = file.name;
        var r = new FileReader();
        r.readAsArrayBuffer(file);
        r.onloadend = function (e) {
            var data = e.target.result;
            var binary_string = ''
            var bytes = new Uint8Array(data);
            for (var i = 0; i < bytes.byteLength; i++) {
                binary_string += String.fromCharCode(bytes[i]);
            }
            var base64_string = window.btoa(binary_string);
            currentFile['data'] = base64_string;
            $scope.xlsFiles['files'].push(currentFile);

            if (location.hostname === "localhost") {
                requestUrl = "/vavo-intake-webapp/.rest/admissiontest/v1/uploadTestSlots";
            } else {
                requestUrl = "/.rest/admissiontest/v1/uploadTestSlots";
            }

            document.getElementById('fileUpload').value = '';
            $scope.showImportTestSlotsButton = false;
            $scope.showImportTestSlots = false
            $scope.showImportTestSlotsSpinner = true;
            $scope.$apply();
            $.ajax({
                url: requestUrl,
                type: "post",
                contentType: "application/json",
                // data: JSON.stringify(response),
                data: JSON.stringify($scope.xlsFiles),
                success: function (response) {

                    console.info("received : " + response.status);
                    console.info("received : " + response.success);


                    if (response.success) {
                        alert("Planning succesvol ingelezen");
                    } else {
                        alert("Inlezen Planning mislukt");
                    }

                    $scope.showImportTestSlotsSpinner = false;
                    $scope.xlsFiles = {};
                    $scope.$apply();
                },
                error: function (error) {
                    $scope.showImportTestSlotsSpinner = false;
                    $scope.$apply();

                    alert("Inlezen Planning mislukt \n\r Foutmelding : " + error);
                    console.error(
                        "The following error occurred: " + error.responseText
                    );
                },
            });
        };

    };


    $scope.loadPagination = function () {
        return $scope.filteredResults != null && $scope.calculatePages() > 1;
    };

    $scope.calculatePages = function () {
        if ($scope.filteredResults != null) {
            return Math.ceil($scope.filteredResults.length / 25);
        } else {
            return 0;
        }
    };

    $scope.hasNextPage = function () {
        if ($scope.emptyFilter()) {
            return $scope.currentPage != null && $scope.currentPage < $scope.calculatePages();
        } else {
            return $scope.currentPageWithFilter != null && $scope.currentPageWithFilter < $scope.calculatePages();
        }
    };

    $scope.nextPage = function () {
        if ($scope.hasNextPage()) {
            if ($scope.emptyFilter()) {
                $scope.currentPage += 1;
            } else {
                $scope.currentPageWithFilter += 1;
            }
            $scope.storeFieldValue("currentPage")
        }
    };

    $scope.previousPage = function () {
        if ($scope.emptyFilter() && $scope.currentPage > 1) {
            $scope.currentPage -= 1;
            $scope.storeFieldValue("currentPage")
        } else {
            if ($scope.currentPageWithFilter > 1) {
                $scope.currentPageWithFilter -= 1;
            }
        }
    };

    $scope.getPage = function () {
        if (localStorage.getItem("currentPage") === null) {
            $scope.currentPage = 1
            $scope.storeFieldValue("currentPage")
        }
        if ($scope.emptyFilter()) {
            $scope.currentPageWithFilter = 1;
            $scope.currentPage = parseInt(localStorage.getItem("currentPage"));
            if ($scope.currentPage > $scope.calculatePages() && $scope.calculatePages() !== 0) {
                $scope.currentPage = 1;
                $scope.storeFieldValue("currentPage")
            }
            return localStorage.getItem("currentPage")
        } else {
            if ($scope.currentPageWithFilter > $scope.calculatePages()) {
                $scope.currentPageWithFilter = 1;
            }
            return $scope.currentPageWithFilter;
        }
    }

    $scope.emptyFilter = function () {
        if (localStorage.getItem("searchBirthDate") === null) {
            $scope.clearSearch();
            return false;
        }
        let searchFields = [
            "searchBirthDate",
            "searchSeptemberTraject",
            "searchIsUitbesteed",
            "searchOwnStudent",
            "searchText",
            "searchEducation",
            "searchDate",
            "searchStatus",
            "searchEnrolmentDate",
            "searchSpecialIntake",
            "searchIsPrinted",
            "searchLocation",
            "searchIsSchakelleerling",
            "searchTopsport",
            "searchWachtmapDatum",
            "searchAdmissionTestsAllDone",
            "searchAdmissionTestsCalledStudent",
            "searchShortIntake",
            "searchSchakelklasOfVbjOptions"
        ];
        for (let i = 0; i < searchFields.length; i++) {
            if (localStorage.getItem(searchFields[i]) == null) {
                localStorage.setItem(searchFields[i], '""');
            }
            if (localStorage.getItem(searchFields[i]).length > 2) {
                return false;
            }
        }
        return true;
    }

    $scope.replaceMonth = function (val) {
        var retval = null;
        switch (val) {
            case "01":
                retval = "januari";
                break;
            case "02":
                retval = "februari";
                break;
            case "03":
                retval = "maart";
                break;
            case "04":
                retval = "april";
                break;
            case "05":
                retval = "mei";
                break;
            case "06":
                retval = "juni";
                break;
            case "07":
                retval = "juli";
                break;
            case "08":
                retval = "augustus";
                break;
            case "09":
                retval = "september";
                break;
            case "10":
                retval = "oktober";
                break;
            case "11":
                retval = "november";
                break;
            case "12":
                retval = "december";
                break;
        }
        return retval;
    }

    $scope.getEnrolments = function (year, college) {
        $scope.currentYear = year;
        if (college == 0) {
            return;
        }
        $scope.searchResults = [];
        var vavoCollege = encodeURIComponent(college);
        var requestUrl = "";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/overview/v1/getUsers?year=" + year;
        } else {
            requestUrl = "/.rest/overview/v1/getUsers?year=" + year;
        }


        $http({
            url: requestUrl,
            method: "GET",
        }).then(function (response) {
            var data = response.data;
            var users = data.user;
            var educationTypes = data.educationOptions;
            var locations = data.locationOptions;
            var isPrinted = ["Ja", "Nee"];
            angular.forEach(users, function (_v, _k) {
                var user = {};
                user["statusEnrolment"] = _v["status"];
                user["name"] = _v["name"];
                user["gebDate"] = _v["gebDatum"];
                user["educationType"] = _v["education"];
                user["location"] = _v["appLocation"];
                var enrolmentDate = null;
                var enrolmentDateString = null;
                if (_v["registrationDate"] != null) {
                    var date_arr = _v["registrationDate"].split("-");
                    enrolmentDate = new Date();
                    enrolmentDate.setFullYear(date_arr[2], date_arr[1] - 1, date_arr[0]);
                    enrolmentDateString = date_arr[0].toString() + " " + $scope.replaceMonth(date_arr[1]) + " " + date_arr[2].toString();
                }
                user["enrolmentDate"] = enrolmentDate;
                user["searchDate"] = enrolmentDateString;
                user["appDate"] = _v["appDate"];
                user["isSeptembertraject"] = _v["isSeptembertraject"];
                user["isTopsport"] = _v["isTopsport"];
                user["isPrinted"] = _v["isPrinted"];
                user["isSpecialIntake"] = _v["isSpecialIntake"];
                user["isShortIntake"] = _v["isShortIntake"];
                user["isSchakelleerling"] = _v["isSchakelleerling"];
                user["enrolmentId"] = _v["enrolmentId"];
                user["admissionTestsAllDone"] = _v["admissionTestsAllDone"];
                user["admissionTestsCalledStudent"] = _v["admissionTestsCalledStudent"];
                user["schakelklasOfVbjKeuze"] = _v["schakelklasOfVbjKeuze"];
                if (_v["cbDownloadFormulier"]) {
                    user["uitbesteed"] = "Ja";
                } else {
                    user["uitbesteed"] = _v["cbDownloadFormulier"];
                }

                var wachtmapDate = null;
                if (_v["wachtmapDatum"] != null && _v["wachtmapDatum"] !== "") {
                    var date_arr = _v["wachtmapDatum"].split("-");
                    wachtmapDate = new Date();
                    wachtmapDate.setFullYear(date_arr[2], date_arr[1] - 1, date_arr[0]);
                }
                user["wachtmapDatum"] = wachtmapDate;
                user["wachtmapDatumString"] = wachtmapDate;

                var statusOneDate = null;
                if (_v["statusOneDate"] != null && _v["statusOneDate"] !== "") {
                    var date_arr = _v["statusOneDate"].split("-");
                    statusOneDate = new Date();
                    statusOneDate.setFullYear(date_arr[2], date_arr[1] - 1, date_arr[0]);
                }
                user["statusOneDate"] = statusOneDate;

                user["ownStudent"] = _v["ownStudent"];
                if (!user.isSeptembertraject || user.isSeptembertraject == "Nee") {
                    user.isSeptembertraject = "Nee";
                } else {
                    user.isSeptembertraject = "Ja";
                }

                if (!user.isTopsport || user.isTopsport == "Nee") {
                    user.isTopsport = "Nee";
                } else {
                    user.isTopsport = "Ja";
                }

                if (!user.isSpecialIntake || user.isSpecialIntake == "Nee") {
                    user.isSpecialIntake = "Nee";
                } else {
                    user.isSpecialIntake = "Ja";
                }

                if (!user.isShortIntake || user.isShortIntake == "Nee") {
                    user.isShortIntake = "Nee";
                } else {
                    user.isShortIntake = "Ja";
                }

                if (!user.isSchakelleerling || user.isSchakelleerling == "Nee") {
                    user.isSchakelleerling = "Nee";
                } else {
                    user.isSchakelleerling = "Ja";
                }

                if (!user.ownStudent || user.ownStudent == "Nee") {
                    user.ownStudent = "Nee";
                } else {
                    user.ownStudent = "Ja";
                }

                if (!user.isPrinted || user.isPrinted == "Nee") {
                    user.isPrinted = "Nee";
                } else {
                    user.isPrinted = "Ja";
                }

                if (!user.admissionTestsAllDone || user.admissionTestsAllDone == "Nee") {
                    user.admissionTestsAllDone = "Nee";
                } else {
                    user.admissionTestsAllDone = "Ja";
                }

                if (!user.admissionTestsCalledStudent || user.admissionTestsCalledStudent == "Nee") {
                    user.admissionTestsCalledStudent = "Nee";
                } else {
                    user.admissionTestsCalledStudent = "Ja";
                }

                if (!user.uitbesteed || user.uitbesteed == "Nee") {
                    user.uitbesteed = "Nee";
                } else {
                    user.uitbesteed = "Ja";
                }

                if (user.wachtmapDatumString == null || user.wachtmapDatumString === "") {
                    user.wachtmapDatumString = "n.v.t.";
                } else if (Date.parse(user.wachtmapDatumString) >= new Date().setHours(0, 0, 0, 0)) {
                    user.wachtmapDatumString = "Nee";
                } else {
                    user.wachtmapDatumString = "Ja";
                }

                if (user.schakelklasOfVbjKeuze == null || user.schakelklasOfVbjKeuze === "" || user.schakelklasOfVbjKeuze === "Voorbereidend jaar") {
                    user.schakelklasOfVbjKeuze = "Voorbereidend jaar";
                } else {
                    user.schakelklasOfVbjKeuze = "Schakelklas MBO";
                }

                $scope.searchResults.push(user);
            });
            $scope.totalSearchResults = $scope.searchResults.length;
            if ($scope.searchEducationOptions.length == 0) {
                angular.forEach(educationTypes, function (_v, _k) {
                    var option = {};
                    option["name"] = _v;
                    $scope.searchEducationOptions.push(option);
                });
                angular.forEach(locations, function (_v, _k) {
                    var option = {};
                    option["name"] = _v;
                    $scope.searchLocationOptions.push(option);
                });
                angular.forEach(isPrinted, function (_v, _k) {
                    var option = {};
                    option["name"] = _v;
                    $scope.searchIsPrintedOptions.push(option);
                    $scope.searchIsUitbesteedOptions.push(option);
                    $scope.searchOwnStudentOptions.push(option);
                    $scope.searchSpecialIntakeOptions.push(option);
                    $scope.searchShortIntakeOptions.push(option);
                    $scope.searchSeptemberTrajectOptions.push(option);
                    $scope.searchWachtmapDatumOptions.push(option);
                    $scope.searchIsSchakelleerlingOptions.push(option);
                    $scope.searchAdmissionTestsAllDoneOptions.push(option);
                    $scope.searchAdmissionTestsCalledStudentOptions.push(option);
                    $scope.searchTopsportOptions.push(option);
                });
                var schakelklasVbjOption1 = {"name":"Schakelklas MBO"};
                var schakelklasVbjOption2 = {"name":"Voorbereidend jaar"};
                $scope.searchSchakelklasOfVbjOptions.push(schakelklasVbjOption1);
                $scope.searchSchakelklasOfVbjOptions.push(schakelklasVbjOption2);

            }
        });
    };
}];

},{}],50:[function(require,module,exports){
module.exports = ['$scope', '$http', 'Blob', 'FileSaver', function ($scope, $http, Blob, FileSaver) {
    $scope.search = {};
    $scope.count = [];
    $scope.locations = {};
    $scope.educationTypes = {};
    $scope.filteredResults = null;
    $scope.currentPage = 1;
    $scope.currentPageWithFilter = 1;

    $scope.searchEducationType = "";
    $scope.searchProfile = "";
    $scope.searchLocation = "";
    $scope.totalCount = 0

    $scope.educationTypeFilter = function () {
        var filtered = [];
        angular.forEach($scope.educationTypes, function (v, k) {
            var inProfile = false;
            if ($scope.searchProfile != undefined && $scope.searchProfile != "") {
                if ($scope.profiles[$scope.searchProfile].educationTypes.includes(k)) {
                    inProfile = true;
                }
            } else {
                inProfile = true;
            }
            if (inProfile) {
                if ($scope.searchLocation != undefined && $scope.searchLocation != "") {
                    if ($scope.locations[$scope.searchLocation].educationTypes.includes(k)) {
                        filtered.push(v);
                    }
                } else {
                    filtered.push(v);
                }
            }

        });
        return filtered;


    };


    $scope.$watch('search["yearCourse"]', function (newValue) {
        $('.table tbody > tr').empty();
        $('.table tbody > tr').remove();
        $scope.getCount(newValue, $scope.intake['vavoCollege']);
    });

    $scope.storeFieldValue = function (fieldName) {
        if (fieldName && fieldName != null && fieldName != undefined) {
            localStorage.setItem(fieldName, JSON.stringify($scope[fieldName]));
        }
    };

    $scope.loadFieldValue = function (fieldName) {
        var loc = localStorage.getItem(fieldName);
        if (loc && loc !== "undefined" && loc !== "null") {
            var value = JSON.parse(loc);
            if (value) {
                $scope[fieldName] = value;
            }
        }
    };

    $scope.educationTypeInFilter = function (value, index, array) {
        var show = false;
        angular.forEach($scope.profiles, function (v, k) {
            if (v.educationTypes.hasOwnProperty(k)) {
                show = true;
            }

        });
        return show;
    };

    $scope.clearSearch = function () {
        var clearValues = ["searchLocation", "searchEducationType", "searchProfile"];
        for (var x = 0; x < clearValues.length; x++) {
            $scope[clearValues[x]] = "";
            localStorage.setItem(clearValues[x], JSON.stringify(""));
        }
        $scope.searchStatus = [];
        $scope.currentPage = parseInt(localStorage.getItem("currentPage"));
    };

    $scope.objSize = function (obj) {
        return size = Object.keys(obj).length;
    };
    $scope.getFirstObject = function (obj) {
        return Object.keys(obj)[0];
    };

    $scope.getCount = function (year, college) {

        if (college == 0) {
            return;
        }
        $scope.count = [];
        var vavoCollege = encodeURIComponent(college);
        var requestUrl = "";
        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/courseCount?vavoCollege=" + vavoCollege + "&year=" + year;
        } else {
            requestUrl = "/.rest/intake/v1/courseCount?vavoCollege=" + vavoCollege + "&year=" + year;
        }

        $http({
            url: requestUrl,
            method: "GET",
        }).then(function (response) {
            var data = response.data;
            var locations = data;
            angular.forEach(locations, function (location, _k) {
                var locationName = location.name;
                angular.forEach(location.educationTypes, function (educationType, _k) {
                    var educationTypeName = educationType.name;
                    angular.forEach(educationType.courses, function (course, _k) {
                        // If adding more fields. refactor!
                        if ($scope.locations.hasOwnProperty(locationName)) {
                            if (!$scope.locations[locationName].educationTypes.includes(educationTypeName)) {
                                $scope.locations[locationName].educationTypes.push(educationTypeName);
                            }
                        } else {
                            $scope.locations[locationName] = {
                                name: locationName,
                                educationTypes: [educationTypeName]
                            };
                        }

                        if ($scope.educationTypes.hasOwnProperty(educationTypeName)) {
                            if (!$scope.educationTypes[educationTypeName].locations.includes(locationName)) {
                                $scope.educationTypes[educationTypeName].locations.push(locationName);
                            }

                        } else {
                            $scope.educationTypes[educationTypeName] = {
                                name: educationTypeName,
                                locations: [locationName]
                            };
                        }


                        countLine = {
                            statusEnrolment: locationName,
                            educationType: educationTypeName,
                            course: course.name,
                            count: course.count,
                        };
                        $scope.count.push(countLine);
                    });
                });
            });
            $scope.totalCount = $scope.count.length;

        });
    };

    $scope.loadPagination = function () {
        return $scope.filteredResults != null && $scope.calculatePages() > 1;
    };

    $scope.calculatePages = function () {
        if ($scope.filteredResults != null) {
            return Math.ceil($scope.filteredResults.length / 25);
        } else {
            return 0;
        }
    };

    $scope.hasNextPage = function () {
        if ($scope.clearSearch()) {
            return $scope.currentPage != null && $scope.currentPage < $scope.calculatePages();
        } else {
            return $scope.currentPageWithFilter != null && $scope.currentPageWithFilter < $scope.calculatePages();
        }
    };

    $scope.nextPage = function () {
        if ($scope.hasNextPage()) {
            if ($scope.clearSearch()) {
                $scope.currentPage += 1;
            } else {
                $scope.currentPageWithFilter += 1;
            }
            $scope.storeFieldValue("currentPage")
        }
    };

    $scope.previousPage = function () {
        if ($scope.clearSearch() && $scope.currentPage > 1) {
            $scope.currentPage -= 1;
            $scope.storeFieldValue("currentPage")
        } else {
            if ($scope.currentPageWithFilter > 1) {
                $scope.currentPageWithFilter -= 1;
            }
        }
    };

    $scope.getPage = function () {
        if (localStorage.getItem("currentPage") === null) {
            $scope.currentPage = 1
            $scope.storeFieldValue("currentPage")
        }
        if ($scope.clearSearch()) {
            $scope.currentPageWithFilter = 1;
            $scope.currentPage = parseInt(localStorage.getItem("currentPage"));
            if ($scope.currentPage > $scope.calculatePages() && $scope.calculatePages() !== 0) {
                $scope.currentPage = 1;
                $scope.storeFieldValue("currentPage")
            }
            return localStorage.getItem("currentPage")
        } else {
            if ($scope.currentPageWithFilter > $scope.calculatePages()) {
                $scope.currentPageWithFilter = 1;
            }
            return $scope.currentPageWithFilter;
        }
    }

    $scope.courseCountCsv = function () {
        var response = {"vavoCollege": $scope.intake['vavoCollege']};
        response.courseCount = $scope.count;
        response.year = $scope.search["yearCourse"];

        var requestUrl = "/.rest/intake/v1/getCourseCountCsv";

        if (location.hostname === "localhost") {
            requestUrl = "/vavo-intake-webapp/.rest/intake/v1/getCourseCountCsv";
        }

        $.ajax({
            url: requestUrl,
            type: "post",
            contentType: "application/json",
            data: JSON.stringify(response),
            success: function (response) {
                var data = new Blob([response], {type: 'text/csv'});
                FileSaver.saveAs(data, 'aantallen.csv');
            },
            error: function (error) {
                console.error(
                    "The following error occurred: " + error
                );
            },
        });
    };


}];

},{}],51:[function(require,module,exports){
module.exports = [function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$validators.bsn = function (modelValue, viewValue) {
                var numbers;
                var check;
                var isnum = /^\d+$/.test(viewValue);
                if (!isnum) {
                    return false;
                }
                // console.log(viewValue.length);
                if (viewValue.length != 9) {
                    return false;
                }
                numbers = viewValue.split("");
                check = (parseInt(numbers[0], 10) * 9) +
                    (parseInt(numbers[1], 10) * 8) +
                    (parseInt(numbers[2], 10) * 7) +
                    (parseInt(numbers[3], 10) * 6) +
                    (parseInt(numbers[4], 10) * 5) +
                    (parseInt(numbers[5], 10) * 4) +
                    (parseInt(numbers[6], 10) * 3) +
                    (parseInt(numbers[7], 10) * 2) +
                    (parseInt(numbers[8], 10) * -1);
                // console.log(check);
                // console.log(check % 11 === 0);
                if (check % 11 === 0) {
                    return true;
                } else {
                    return false;
                }
            };

            elm.each(function (index, value) {
                value.addEventListener('input', function () {
                    value.setCustomValidity('');
                    try {
                        value.reportValidity();
                    } catch (e) {
                        //Must be an older browser, no need to do anything.
                    }

                });
            });
        }
    };
}];

},{}],52:[function(require,module,exports){
module.exports = ['$templateCache', '$window', function ($templateCache, $window) {
    return {
        restrict: "EA",
        template: $templateCache.get('templates/courses.html'),
        scope: '@',
        controller: 'courseController'
    };
}];
},{}],53:[function(require,module,exports){
module.exports = [function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            var date, otherDate;
            scope.$watch(attrs.dateAfter, function (value) {
                otherDate = value;
                validate();
            });
            scope.$watch(attrs.ngModel, function (value) {
                date = value;
                validate();
            });

            function validate() {
                ngModelCtrl.$setValidity('dateAfter', !date || !otherDate || date >= otherDate);
            }
        }

    };

}];
},{}],54:[function(require,module,exports){
var Popper = require('popper.js');

module.exports = ['$templateCache', '$window', function ($templateCache, $window) {
    return {
        restrict: "EA",
        template: $templateCache.get('templates/informationTooltip.html'),
        transclude: true,
        scope: {
            title: "@"
        },
        controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
            var reference = $element[0].children[0];
            var tooltip = $element[0].children[1];
            var p = new Popper(reference, tooltip, {
                placement: "right",
                modifiers: {
                    preventOverflow: {
                        boundariesElement: 'window'
                    },
                    arrow: {
                        enabled: false
                    }
                }
            });
            $scope.show = false;

            reference.addEventListener('click', function (event) {
                event.stopPropagation();
                $scope.$apply(function () {
                    $scope.show = !$scope.show;
                    setTimeout(function () {
                            p.update();
                        }, 200
                    );
                    setTimeout(function () {
                            p.update();
                        }, 0
                    );
                });
            });

            $window.addEventListener('click', function () {
                $scope.$apply(function () {
                    if ($scope.show == true) {
                        $scope.show = false;
                    }
                });
            });


        }]
    };
}];

},{"popper.js":10}],55:[function(require,module,exports){
module.exports = ['$window', '$rootScope', function ($window, $rootScope) {
    var Mgnl = $window._mgnl || {};
    $rootScope.Mgnl = Mgnl;
    return Mgnl;
}];

},{}],56:[function(require,module,exports){
module.exports = ['$window', function ($window) {
    return $window.Modernizr;
}];

},{}],57:[function(require,module,exports){
module.exports = ['$window', function ($window) {
    return $window.jQuery;
}];

},{}],58:[function(require,module,exports){
module.exports = [function () {
    return function (items, compare, propertyString, currentSelection) {
        if (!angular.isArray(items) || !angular.isArray(compare)) {
            return items;
        }
        var currentSelectionValue;
        if (currentSelection) {
            currentSelectionValue = currentSelection[propertyString];
        }

        items = items.filter(function (item, index, array) {
            if (currentSelectionValue) {
                if (item[propertyString] === currentSelectionValue) {
                    return true;
                }
            }
            if (compare.includes(item[propertyString])) {
                return false;
            }
            return true;
        });
        return items;
    };
}];

},{}],59:[function(require,module,exports){
module.exports = [function () {
    return function (enrolment, statusEnrolment) {
        var items = {
            statusEnrolment: statusEnrolment,
            out: []
        };
        angular.forEach(enrolment, function (value, key) {
            var arrayOfObject = [];
            if (typeof statusEnrolment !== 'undefined' && statusEnrolment != {}) {
                arrayOfObject = Object.values(statusEnrolment);
            }
            if (typeof statusEnrolment !== 'undefined' && statusEnrolment != {} && arrayOfObject.includes(true)) {
                if (this.statusEnrolment[value.statusEnrolment] === true) {
                    this.out.push(value);
                }
            } else {
                this.out.push(value);
            }
        }, items);
        return items.out;
    };
}];

},{}],60:[function(require,module,exports){
module.exports = [function () {
    return function (input, search) {
        if (!input) return input;
        if (!search) return input;
        var expected = ('' + search).toLowerCase();
        var result = {};
        angular.forEach(input, function (value, key) {
            var actual = ('' + key).toLowerCase();
            if (actual !== (expected)) {
                result[key] = value;
            }
        });
        return result;
    }
}];

},{}],61:[function(require,module,exports){
// Creates an update binding for the input with the id field_id, and saves that
// value locally with the key save_prefix + field_id. This value will expire
// after expires_after seconds.
// If there is valid data stored in the aforementioned key, the field will be
// updated with that data.
function persistField(field_id, save_prefix, expires_after) {
    // Save values on field change:
    $("#" + field_id).change(function() {
        localStorage.setItem(save_prefix + field_id,
            JSON.stringify({
                "value": $("#" + field_id).val(),
                "expiration": Date.now() + expires_after * 1000
            }));
    });

    // Restore our value
    let stored_val = localStorage.getItem(save_prefix + field_id);
    if (!stored_val)
        return;
    try {
        let val = JSON.parse(stored_val);
        if (val["expiration"] > Date.now()) {
            $("#" + field_id).val(val["value"]);
        }
        // Refresh value
        localStorage.setItem(save_prefix + field_id,
            JSON.stringify({
                "value": val["value"],
                "expiration": Date.now() + expires_after * 1000
            }));
    }
    catch (err) {}

}

// Invalidates key save_prefix + field_id from local storage by setting it to null
function invalidateField(field_id, save_prefix) {
    let stored_val = localStorage.getItem(save_prefix + field_id);
    if (stored_val != null) {
        localStorage.setItem(save_prefix + field_id, null);
    }
}

let registration_persisted_fields = [
    "username",
    "fullName",
    "email"
]

// The way this works is that we look for two trigger divs with specific ids:
// #registration-issue-clear - Tells us we need to invalidate saved form data
// #registration-issue-restore - Tells us we need to restore saved form data
// See registration.ftl for context.
$(window).on("load", function() {
    let prefix = "registration_fields_";
    if ($("#registration-issue-clear").length) {
        for (let f of registration_persisted_fields) {
            invalidateField(f, prefix);
        }
    } else if ($("#registration-issue-restore").length) {
        for (let f of registration_persisted_fields) {
            persistField(f, prefix, 60);
        }
    }
});

},{}],62:[function(require,module,exports){
'use strict';

var angularAnimate = require('angular-animate');
var angularSanitize = require('angular-sanitize');
var angularCookies = require('angular-cookies');
var ngFileSaver = require('angular-file-saver');


var app = angular.module('vavoIntakeApp', [
    angularAnimate,
    angularSanitize,
    angularCookies,
    'templates',
    ngFileSaver
]);

require('./input-persistence')
app.config(function($sceDelegateProvider ) {
    $sceDelegateProvider.resourceUrlWhitelist([
        'self'
    ]);

});
angular.element(document).ready(function () {
    angular.bootstrap(document, ['vavoIntakeApp'], {
        strictDi: true
    })



});
// Factories
app.factory("$", require('./factories/jQueryFactory'));
app.factory("Modernizr", require('./factories/ModernizrFactory'));
app.factory("Mgnl", require('./factories/MgnlFactory'));

// Filters
app.filter("inArray", require('./filters/inArrayFilter'));
app.filter("inStatus", require('./filters/inStatusFilter'));
app.filter("overview", require('./filters/overviewFilter'));

// Services
app.service('apiService', require('./services/apiService'))
app.service('appointmentApiService', require('./services/appointmentApiService'))
app.service('courseConfigService', require('./services/courseConfigService'))

// Controllers
app.controller('formController', require('./controllers/formController'));
app.controller('portalController', require('./controllers/portalController'));
app.controller('admissionTestPortalController', require('./controllers/admissionTestPortalController'));
app.controller('admissionTestEditController', require('./controllers/admissionTestEditController'));
app.controller('enrolmentEditController', require('./controllers/enrolmentEditController'));
app.controller('beoogddiplomaController', require('./controllers/beoogddiplomaController'));
app.controller('courseController', require('./controllers/courseController'));
app.controller('portalCountController', require('./controllers/portalCountController'));

// Components

app.component('appointmentComponent', {
    templateUrl: 'templates/appointment.component.html',
    bindings: {
        fromintake: '<',
    },
    controller: require('./controllers/appointmentController')
});

app.component('slotComponent', {
    templateUrl: 'templates/appointment.slot.component.html',
    bindings: {
        data: '<',
        global: '<',
        respondtotime: '&',
    },
    controller: require('./controllers/appointmentSlotController')
});

app.component('timeComponent', {
    templateUrl: 'templates/appointment.time.component.html',
    bindings: {
        time: '@',
        data: '<',
        global: '<',
    },
    controller: require('./controllers/appointmentTimeController')
});

app.component('dateComponent', {
    templateUrl: 'templates/appointment.date.component.html',
    bindings: {
        data: '<',
        global: '<',
    },
    controller: require('./controllers/appointmentDateController')
});


app.component('appointmentCandidateComponent', {
    templateUrl: 'templates/appointment.candidate.component.html',
    bindings: {
        data: '<',
        global: '<',
    },
    controller: require('./controllers/appointmentCandidateController')
});

// Directives
app.directive('informationTooltip', require('./directives/informationTooltipDirective'));
app.directive('bsnCheck', require('./directives/bsnCheck'));
app.directive('dateAfter', require('./directives/dateAfter'));
app.directive('course', require('./directives/courseDirective'));


module.exports = app;

},{"./controllers/admissionTestEditController":38,"./controllers/admissionTestPortalController":39,"./controllers/appointmentCandidateController":40,"./controllers/appointmentController":41,"./controllers/appointmentDateController":42,"./controllers/appointmentSlotController":43,"./controllers/appointmentTimeController":44,"./controllers/beoogddiplomaController":45,"./controllers/courseController":46,"./controllers/enrolmentEditController":47,"./controllers/formController":48,"./controllers/portalController":49,"./controllers/portalCountController":50,"./directives/bsnCheck":51,"./directives/courseDirective":52,"./directives/dateAfter":53,"./directives/informationTooltipDirective":54,"./factories/MgnlFactory":55,"./factories/ModernizrFactory":56,"./factories/jQueryFactory":57,"./filters/inArrayFilter":58,"./filters/inStatusFilter":59,"./filters/overviewFilter":60,"./input-persistence":61,"./services/apiService":63,"./services/appointmentApiService":64,"./services/courseConfigService":65,"angular-animate":2,"angular-cookies":4,"angular-file-saver":5,"angular-sanitize":7}],63:[function(require,module,exports){
module.exports = ['$http', function ($http) {


    function getApiEndpoint() {
        var endPoint = '/.rest/enrolment/v1/config';
        return location.hostname === 'localhost' ? '/vavo-intake-webapp' + endPoint : endPoint;
    }

    function transformCourseDisplayLabel(course) {
        if (!course.follow) {
            return course;
        }

        var courseFollowSuffixes = {
            N: "***", // Not
            A: "**", // Evening
            D: "*"  // Day
        };

        course.displayLabel = course.title;

        if (Object.keys(courseFollowSuffixes).includes(course.follow)) {
            course.displayLabel += " " + courseFollowSuffixes[course.follow];
        }
        return course;
    }

    function transformProfileChoices(chosenProfileOption, graduation, profileChoices) {
        var diploma = graduation === "diploma";
        var newCourseConfig = {};
        newCourseConfig[chosenProfileOption] = {};

        angular.forEach(profileChoices, function (profileChoice) {
            var formOptions = profileChoice.formOptions;

            if (diploma) {
                newCourseConfig[chosenProfileOption][profileChoice.title] = {};
            }

            angular.forEach(formOptions, function (formOption) {
                var courses = formOption.courses;
                if (diploma) {
                    newCourseConfig[chosenProfileOption][profileChoice.title][formOption.title] = {};
                    if (courses.length === 1) {
                        var _course = courses[0];
                        newCourseConfig[chosenProfileOption][profileChoice.title][formOption.title]['course'] = {
                            label: _course.title,
                            id: _course.id
                        };
                    }
                }

                angular.forEach(courses, function (course) {
                    transformCourseDisplayLabel(course);
                });

            });

        });


        return {
            newCourseConfig: newCourseConfig,
            profileChoices: profileChoices
        };

    }

    function transformEducationProfiles(profileOptions, graduation) {
        var filteredProfileOptions = ['sectorloos', 'profielloos'];
        var diploma = graduation === "diploma";
        Object.keys(profileOptions).forEach(function (profile) {
            if (diploma) {
                if (filteredProfileOptions.includes(profile.toLowerCase())) {
                    delete profileOptions[profile];
                }
            } else {
                if (!filteredProfileOptions.includes(profile.toLowerCase())) {
                    delete profileOptions[profile];
                }
            }
        });
        return profileOptions;
    }


    function getEducationProfiles(vavoCollege, educationType, graduation) {
        if (vavoCollege == 0) {
            return;
        }
        vavoCollege = encodeURIComponent(vavoCollege);
        var education = educationType ? encodeURIComponent(educationType) : 'none';

        var requestUrl = getApiEndpoint() + "/educationProfile?vavoCollege=" + vavoCollege + "&education=" + education;

        return $http({
            url: requestUrl,
            method: "GET"
        }).then(function (response) {
            return transformEducationProfiles(response.data.profileOptions, graduation);
        });
    }

    function getProfileChoices(chosenProfileOption, education, vavoCollege, graduation) {

        var chosenProfileOptionEncoded = encodeURIComponent(chosenProfileOption);
        education = encodeURIComponent(education);
        vavoCollege = encodeURIComponent(vavoCollege);

        var requestUrl = getApiEndpoint() + "/profileChoices?vavoCollege=" + vavoCollege + "&education=" + education + "&profileOption=" + chosenProfileOptionEncoded;

        return $http({
            url: requestUrl,
            method: "GET"
        }).then(function (response) {
            return transformProfileChoices(chosenProfileOption, graduation, response.data.profileOptions);
        });
    }


    return {
        getEducationProfiles: getEducationProfiles,
        getProfileChoices: getProfileChoices
    }

}];

},{}],64:[function(require,module,exports){
module.exports = ['$http', function ($http) {

    function baseURL() {
        let requestUrl = '';
        if (location.hostname === "localhost") {
            requestUrl += "/vavo-intake-webapp";
        }
        return requestUrl + "/.rest/enrolment/v1/";
    }

    function fetchDates(year, status, setVal) {
        let requestUrl = baseURL() + "appointments/getDates"
        requestUrl += "?year=" + year + "&status=" + status;
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            setVal(response.data);
        });
    }

    function fetchTimes(year, date, setVal) {
        let requestUrl = baseURL() + "appointments/getTimes"
        requestUrl += "?year=" + year + "&date=" + date;
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            setVal(response.data);
        });
    }

    function fetchSlots(year, date, status, type, setVal) {
        let requestUrl = baseURL() + "appointments/getSlots";
        requestUrl += "?year=" + year + "&date=" + date + "&status=" + status + "&type=" + type;
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            setVal(response.data);
        });
    }

    function fetchAppointment(id, setVal) {
        if (id === "") return;
        let requestUrl = baseURL() + "appointments/getAppointment";
        requestUrl += "?id=" + id
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            setVal(response.data);
        });
    }

    function fetchCandidates(year, date, status, type, setVal) {
        let requestUrl = baseURL() + "appointments/getCandidates";
        requestUrl += "?year=" + year + "&date=" + date + "&status=" + status + "&type=" + type;
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            setVal(response.data);
        });
    }
    function deleteAppointment(id, setVal) {
        let requestUrl = baseURL() + "appointments/deleteAppointment";
        requestUrl += "?id=" + id ;
        $http({
            url: requestUrl, method: "GET",
        }).then(function (response) {
            setVal(response.data);
        });
    }

    function saveAppointment(enrolmentID, slotIDs, year, type, status, oldAppointmentId, callBack) {
        let requestUrl = baseURL() + "appointments/save";
        let body = {
            enrolmentID: enrolmentID, slotIDs: slotIDs, year: year, type: type, status: status, oldAppointmentId: oldAppointmentId
        };

        $.ajax({
            url: requestUrl,
            type: "post",
            accept: "application/json",
            contentType: "application/json",
            data: JSON.stringify(body),
            success: function (res) {
                callBack(true, res)
            },
            error: function (error) {
                callBack(false, error)
            },
        });
    }

    function orderSlots(data, ctrlLocal) {
        let timesFromServer = ctrlLocal.global.times

        let names = []
        let times = []

        for (const [key, value] of Object.entries(data)) {
            times.push(key)
            value.forEach(slot => {
                slot.available = slot.available === "true"
                if (slot.possibleStatuses.length === 0) {
                    slot.available = false
                }
                if (!names.includes(slot.name) && slot.possibleStatuses.length > 0) {
                    names.push(slot.name)
                }
            })
        }

        if (timesFromServer != null && timesFromServer.length > 0) {
            times = timesFromServer
        }

        names.sort()
        ctrlLocal.global.columnCount = names.length + 1
        times = fixTimeBrakes(times)
        let returnData = {}
        for (time of times) {
            let returnSlots = []
            for (name of names) {
                let slot
                if (data[time] !== undefined) {
                    slot = data[time].find(item => item.name === name);
                }
                if (slot === undefined || slot.name == null) {
                    slot = {name: name, available: false}
                }
                returnSlots.push(slot)
            }
            returnData[time] = returnSlots
        }
        return returnData
    }

    function fixTimeBrakes(times) {
        times.sort()
        let lastTime
        let newTimes = []
        let firstSpan
        let insertTime;
        for (time of times) {
            let hour = time.substring(0, 2)
            let min = time.substring(3, 5)
            let now = new Date()
            now.setHours(hour)
            now.setMinutes(min)
            if (lastTime !== undefined) {
                if (firstSpan === undefined) {
                    firstSpan = Math.round((now - lastTime) / 60 / 1000)
                }
                insertTime = lastTime
                let exit = false
                do {
                    exit = true
                    insertTime.setTime(insertTime.getTime() + firstSpan * 60 * 1000)
                    if (insertTime < now) {
                        newTimes.push(pad(insertTime.getHours(), 2) + "-" + pad(insertTime.getMinutes(), 2))
                        exit = false
                    }

                } while (!exit)
            }
            newTimes.push(time)
            lastTime = now
        }
        return newTimes
    }

    function pad(num, size) {
        const s = "000000000" + num;
        return s.substring(s.length - size);
    }

    return {
        fetchDates: fetchDates,
        fetchTimes: fetchTimes,
        fetchSlots: fetchSlots,
        fetchCandidates: fetchCandidates,
        saveAppointment: saveAppointment,
        fetchAppointment: fetchAppointment,
        deleteAppointment: deleteAppointment,
        orderSlots: orderSlots,
    }
}];

},{}],65:[function(require,module,exports){
module.exports = [function () {

    var _courseConfig = {};
    var currentProfile = null;
    var exceptionIDs = [];

    function updateExceptionsList() {
        var _exceptionIDs = [];
        forEachCourseEntry(_courseConfig, false, function (course) {
            if (course && course.exceptionID && course.exceptionID !== "0") {
                if (!_exceptionIDs.includes(course.exceptionID)) {
                    _exceptionIDs.push(course.exceptionID);
                }
            }
        });
        exceptionIDs = _exceptionIDs;
    }

    function forEachCourseEntry(courseConfig, clone, callback) {
        var newCourseConfig = {};

        if (typeof callback !== 'function') {
            return courseConfig;
        }
        angular.forEach(courseConfig, function (profile, profileKey) {
            var newProfile = {};
            newCourseConfig[profileKey] = newProfile;
            angular.forEach(profile, function (section, sectionKey) {
                var newSection = {};
                newProfile[sectionKey] = newSection;
                angular.forEach(section, function (option, optionKey) {
                    var newOption = Object.assign({}, option);
                    newSection[optionKey] = newOption;
                    if (option.course) {
                        if (clone) {
                            newOption.course = Object.assign({}, newOption.course);
                            callback(newOption.course);
                        } else {
                            callback(option.course);
                        }
                    }
                });
            });
        });
        if (clone) {
            return newCourseConfig;
        } else {
            return courseConfig;
        }
    }

    function update(profileOption, formOption, state) {

        if (!_courseConfig[currentProfile]) _courseConfig[currentProfile] = {};
        if (!_courseConfig[currentProfile][profileOption]) _courseConfig[currentProfile][profileOption] = {};
        if (!_courseConfig[currentProfile][profileOption][formOption]) _courseConfig[currentProfile][profileOption][formOption] = {};

        if (state.course != null) {
            _courseConfig[currentProfile][profileOption][formOption].course = {
                label: state.course.title,
                id: state.course.id,
                checked: state.follow,
                grade: state.grade,
                exceptionID: state.course.exceptionID
            };
        } else {
            delete _courseConfig[currentProfile][profileOption][formOption].course;
        }

        updateExceptionsList();
    }

    function reset() {
        _courseConfig = {};
        currentProfile = null;
    }

    function setProfile(profileName) {
        currentProfile = profileName;
        _courseConfig[currentProfile] = {};
    }

    function setFromExistingConfigObject(object) {
        _courseConfig = object;
    }

    function cloneAndCleanParams(courseConfig) {
        //var clone = JSON.parse(JSON.stringify(courseConfig));
        var clone = Object.assign({}, courseConfig);
        clone = forEachCourseEntry(clone, true, function (course) {
            delete course.exceptionID;
        });
        return clone;
    }

    return {
        reset: reset,
        setProfile: setProfile,
        setFromExistingConfigObject: setFromExistingConfigObject,
        update: update,
        getRawCourseConfig: function () {
            return _courseConfig;
        },
        getCourseConfig: function () {
            return cloneAndCleanParams(_courseConfig);
        },
        getExceptionIDs: function () {
            return exceptionIDs;
        }
    }

}];

},{}]},{},[62]);
